var _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { StytchB2BHeadlessClient } from './index.headless.esm.js';
import { i as isTruthy, w as wn, q, F, m as merge, y, p as p$1, a as w, g as g$1, h as h$1, N, H as He, b as withMiddleware, u as useSWR, c as useSWRConfig, _, d as useStateWithDeps, T, s as serialize, e as mergeObjects, f as getTimestamp, U as UNDEFINED, j as useIsomorphicLayoutEffect, k as Ue, l as passwordManagerDisableAutofillProps, Z as Ze, n as extractErrorMessage, C as CreateSSRSafeWebComponent, o as Fe } from '../extractErrorMessage-CTyceZDG.js';
import { B as B2BMFAProducts, A as AuthFlowType, a as B2BProducts, b as OTPMethods, W as Wallets, P as Products, S as StytchEventType, r as readB2BInternals, D as DEFAULT_SESSION_DURATION_MINUTES, _ as __awaiter, E as EMAIL_REGEX, c as StytchAPIError, d as B2BOAuthProviders, l as logger, e as OneTapPositions, i as isTestPublicToken, f as debounce, C as COUNTRIES_LIST, g as StytchSDKError, h as checkNotSSR } from '../internal-_L9abnhs.js';
export { j as BiometricsFailedError, k as BiometricsUnavailableError, m as ChallengeSigningFailedError, n as DeviceCredentialsNotAllowedError, F as FailedCodeChallengeError, o as FailedToDecryptDataError, I as InternalError, p as InvalidAuthorizationCredentialError, q as InvalidCredentialTypeError, s as InvalidRedirectSchemeError, t as InvalidStartUrlError, J as JSONDataNotConvertibleToStringError, K as KeyInvalidatedError, u as KeystoreUnavailableError, M as MissingAttestationObjectError, v as MissingAuthorizationCredentialIDTokenError, w as MissingGoogleClientIDError, x as MissingPKCEError, y as MissingPublicKeyError, z as MissingUrlError, N as NoBiometricsEnrolledError, G as NoBiometricsRegistrationError, H as NoCredentialsPresentError, L as NoCurrentSessionError, O as OAuthProviders, Q as PasskeysInvalidEncoding, R as PasskeysMisconfigured, T as PasskeysUnsupportedError, U as RNUIProducts, V as RandomNumberGenerationFailed, X as SDKAPIUnreachableError, Y as SDKNotConfiguredError, Z as SignInWithAppleMisconfigured, $ as StytchAPISchemaError, a0 as StytchAPIUnreachableError, a1 as StytchError, a2 as StytchSDKAPIError, a3 as StytchSDKSchemaError, a4 as StytchSDKUsageError, a5 as UNRECOVERABLE_ERROR_TYPES, a6 as UserCancellationError, a7 as UserLockedOutError, a8 as errorToStytchError } from '../internal-_L9abnhs.js';
var DEFAULT_MFA_STATE = {
  primaryInfo: null,
  isEnrolling: false,
  smsOtp: {
    isSending: false,
    sendError: null,
    codeExpiration: null,
    formattedDestination: null,
    enrolledNumber: null
  },
  totp: {
    isCreating: false,
    createError: null,
    enrollment: null
  }
};
var getEnabledMethods = function getEnabledMethods(_ref3) {
  var allMethods = _ref3.allMethods,
    orgSupportedMethods = _ref3.orgSupportedMethods,
    uiIncludedMethods = _ref3.uiIncludedMethods;
  if (orgSupportedMethods === null || orgSupportedMethods === void 0 ? void 0 : orgSupportedMethods.length) {
    return new Set(orgSupportedMethods);
  }
  var methodsArr = (uiIncludedMethods === null || uiIncludedMethods === void 0 ? void 0 : uiIncludedMethods.length) ? uiIncludedMethods : allMethods;
  return new Set(methodsArr);
};
var DEFAULT_SMS_OTP_EXPIRATION_MS = 1000 * 60 * 2;
function apiMfaMethodToProduct(method) {
  switch (method) {
    case 'totp':
      return B2BMFAProducts.totp;
    case 'sms_otp':
      return B2BMFAProducts.smsOtp;
    default:
      return undefined;
  }
}
var getSmsOtpCodeExpiration = function getSmsOtpCodeExpiration() {
  return new Date(Date.now() + DEFAULT_SMS_OTP_EXPIRATION_MS);
};
var B2B_MFA_METHODS = [B2BMFAProducts.totp, B2BMFAProducts.smsOtp];
var mfaReducer = function mfaReducer(state, action) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
  switch (action.type) {
    case 'primary_authenticate_success':
      {
        var memberAuthenticated = !!action.response.member_session;
        var postAuthScreen = action.resetTokenType === 'multi_tenant_magic_links' ? AppScreens$1.PasswordResetForm : AppScreens$1.LoggedIn;
        if (memberAuthenticated) {
          return Object.assign(Object.assign({}, state), {
            mfa: DEFAULT_MFA_STATE,
            screen: postAuthScreen
          });
        }
        var memberEnrolledInSmsOtp = action.response.member.mfa_phone_number_verified;
        var memberEnrolledInTotp = !!action.response.member.totp_registration_id;
        var primaryInfo = {
          enrolledMfaMethods: [memberEnrolledInTotp && B2BMFAProducts.totp, memberEnrolledInSmsOtp && B2BMFAProducts.smsOtp].filter(isTruthy),
          memberId: action.response.member_id,
          memberPhoneNumber: action.response.member.mfa_phone_number,
          organizationId: action.response.organization.organization_id,
          organizationMfaOptionsSupported: action.response.organization.mfa_methods === 'RESTRICTED' && action.response.organization.allowed_mfa_methods ? (_a = action.response.organization.allowed_mfa_methods) === null || _a === void 0 ? void 0 : _a.map(apiMfaMethodToProduct).filter(isTruthy) : [],
          postAuthScreen: postAuthScreen
        };
        var organizationSupportsMethod = function organizationSupportsMethod(method) {
          return primaryInfo.organizationMfaOptionsSupported.length === 0 || primaryInfo.organizationMfaOptionsSupported.includes(method);
        };
        var getDefaultMethod = function getDefaultMethod() {
          var defaultMethod = apiMfaMethodToProduct(action.response.member.default_mfa_method);
          if (defaultMethod && organizationSupportsMethod(defaultMethod) && primaryInfo.enrolledMfaMethods.includes(defaultMethod)) {
            return defaultMethod;
          }
          return undefined;
        };
        var smsImplicitlySent = ((_b = action.response.mfa_required) === null || _b === void 0 ? void 0 : _b.secondary_auth_initiated) === 'sms_otp';
        var entryMethod = smsImplicitlySent ? B2BMFAProducts.smsOtp : (_c = getDefaultMethod()) !== null && _c !== void 0 ? _c : primaryInfo.enrolledMfaMethods.find(organizationSupportsMethod);
        if (entryMethod) {
          var mfaState = Object.assign(Object.assign({}, DEFAULT_MFA_STATE), {
            primaryInfo: primaryInfo
          });
          switch (entryMethod) {
            case B2BMFAProducts.smsOtp:
              {
                return Object.assign(Object.assign({}, state), {
                  mfa: Object.assign(Object.assign({}, mfaState), {
                    smsOtp: Object.assign(Object.assign({}, DEFAULT_MFA_STATE.smsOtp), {
                      codeExpiration: smsImplicitlySent ? getSmsOtpCodeExpiration() : null
                    })
                  }),
                  screen: AppScreens$1.SMSOTPEntry
                });
              }
            case B2BMFAProducts.totp:
              return Object.assign(Object.assign({}, state), {
                mfa: mfaState,
                screen: AppScreens$1.TOTPEntry
              });
          }
        }
        var enabledMethods = getEnabledMethods({
          allMethods: B2B_MFA_METHODS,
          orgSupportedMethods: primaryInfo.organizationMfaOptionsSupported,
          uiIncludedMethods: action.includedMfaMethods
        });
        var getNextEnrollmentScreen = function getNextEnrollmentScreen() {
          if (enabledMethods.size === 1) {
            if (enabledMethods.has(B2BMFAProducts.totp)) {
              return AppScreens$1.TOTPEnrollmentQRCode;
            }
            if (enabledMethods.has(B2BMFAProducts.smsOtp)) {
              return AppScreens$1.SMSOTPEnrollment;
            }
          }
          return AppScreens$1.MFAEnrollmentSelection;
        };
        return Object.assign(Object.assign({}, state), {
          mfa: Object.assign(Object.assign({}, DEFAULT_MFA_STATE), {
            primaryInfo: primaryInfo,
            isEnrolling: true
          }),
          screen: getNextEnrollmentScreen()
        });
      }
    case 'mfa/start_enrollment':
      {
        var screen = action.method === B2BMFAProducts.smsOtp ? AppScreens$1.SMSOTPEnrollment : AppScreens$1.TOTPEnrollmentQRCode;
        return Object.assign(Object.assign({}, state), {
          screen: screen
        });
      }
    case 'sms_otp/authenticate_success':
      return Object.assign(Object.assign({}, state), {
        mfa: DEFAULT_MFA_STATE,
        screen: (_e = (_d = state.mfa.primaryInfo) === null || _d === void 0 ? void 0 : _d.postAuthScreen) !== null && _e !== void 0 ? _e : AppScreens$1.LoggedIn
      });
    case 'sms_otp/send':
      return Object.assign(Object.assign({}, state), {
        mfa: Object.assign(Object.assign({}, state.mfa), {
          smsOtp: Object.assign(Object.assign({}, state.mfa.smsOtp), {
            isSending: true,
            sendError: null
          })
        })
      });
    case 'sms_otp/send_success':
      return Object.assign(Object.assign({}, state), {
        mfa: Object.assign(Object.assign({}, state.mfa), {
          smsOtp: Object.assign(Object.assign({}, state.mfa.smsOtp), {
            isSending: false,
            sendError: null,
            codeExpiration: getSmsOtpCodeExpiration(),
            formattedDestination: (_f = action.formattedPhoneNumber) !== null && _f !== void 0 ? _f : state.mfa.smsOtp.formattedDestination,
            enrolledNumber: action.phoneNumber ? {
              phoneNumber: action.phoneNumber,
              countryCode: action.countryCode
            } : null
          })
        }),
        screen: AppScreens$1.SMSOTPEntry
      });
    case 'sms_otp/send_error':
      return Object.assign(Object.assign({}, state), {
        mfa: Object.assign(Object.assign({}, state.mfa), {
          smsOtp: Object.assign(Object.assign({}, state.mfa.smsOtp), {
            isSending: false,
            sendError: action.error,
            codeExpiration: (_g = state.mfa.smsOtp.codeExpiration) !== null && _g !== void 0 ? _g : new Date(Date.now() - 1000)
          })
        })
      });
    case 'sms_otp/format_destination':
      return Object.assign(Object.assign({}, state), {
        mfa: Object.assign(Object.assign({}, state.mfa), {
          smsOtp: Object.assign(Object.assign({}, state.mfa.smsOtp), {
            formattedDestination: action.formattedPhoneNumber
          })
        })
      });
    case 'sms_otp/navigate_to_entry':
      return Object.assign(Object.assign({}, state), {
        screen: AppScreens$1.SMSOTPEntry
      });
    case 'recovery_code/authenticate_success':
      return Object.assign(Object.assign({}, state), {
        mfa: DEFAULT_MFA_STATE,
        screen: (_j = (_h = state.mfa.primaryInfo) === null || _h === void 0 ? void 0 : _h.postAuthScreen) !== null && _j !== void 0 ? _j : AppScreens$1.LoggedIn
      });
    case 'recovery_code/navigate_to_entry':
      return Object.assign(Object.assign({}, state), {
        screen: AppScreens$1.RecoveryCodeEntry
      });
    case 'recovery_code/save_acknowledge':
      return Object.assign(Object.assign({}, state), {
        mfa: DEFAULT_MFA_STATE,
        screen: (_l = (_k = state.mfa.primaryInfo) === null || _k === void 0 ? void 0 : _k.postAuthScreen) !== null && _l !== void 0 ? _l : AppScreens$1.LoggedIn
      });
    case 'totp/authenticate_success':
      return Object.assign(Object.assign({}, state), {
        mfa: state.mfa.isEnrolling ? state.mfa : DEFAULT_MFA_STATE,
        screen: state.mfa.isEnrolling ? AppScreens$1.RecoveryCodeSave : (_o = (_m = state.mfa.primaryInfo) === null || _m === void 0 ? void 0 : _m.postAuthScreen) !== null && _o !== void 0 ? _o : AppScreens$1.LoggedIn
      });
    case 'totp/create':
      if (state.mfa.totp.isCreating) {
        return state;
      }
      return Object.assign(Object.assign({}, state), {
        mfa: Object.assign(Object.assign({}, state.mfa), {
          totp: Object.assign(Object.assign({}, state.mfa.totp), {
            isCreating: true,
            createError: null
          })
        })
      });
    case 'totp/create_success':
      if (!state.mfa.isEnrolling || ((_p = state.mfa.primaryInfo) === null || _p === void 0 ? void 0 : _p.memberId) !== action.memberId || ((_q = state.mfa.primaryInfo) === null || _q === void 0 ? void 0 : _q.organizationId) !== action.organizationId) {
        return state;
      }
      return Object.assign(Object.assign({}, state), {
        mfa: Object.assign(Object.assign({}, state.mfa), {
          totp: Object.assign(Object.assign({}, state.mfa.totp), {
            createError: null,
            isCreating: false,
            enrollment: {
              secret: action.response.secret,
              qrCode: action.response.qr_code,
              recoveryCodes: action.response.recovery_codes,
              method: (_s = (_r = state.mfa.totp.enrollment) === null || _r === void 0 ? void 0 : _r.method) !== null && _s !== void 0 ? _s : 'qr'
            }
          })
        })
      });
    case 'totp/create_error':
      return Object.assign(Object.assign({}, state), {
        mfa: Object.assign(Object.assign({}, state.mfa), {
          totp: Object.assign(Object.assign({}, state.mfa.totp), {
            isCreating: false,
            createError: action.error
          })
        })
      });
    case 'totp/navigate_to_entry':
      return Object.assign(Object.assign({}, state), {
        screen: AppScreens$1.TOTPEntry
      });
    case 'totp/show_code':
      {
        if (!state.mfa.isEnrolling || !state.mfa.totp.enrollment) {
          return state;
        }
        var method = (_u = (_t = action.method) !== null && _t !== void 0 ? _t : state.mfa.totp.enrollment.method) !== null && _u !== void 0 ? _u : 'qr';
        return Object.assign(Object.assign({}, state), {
          mfa: Object.assign(Object.assign({}, state.mfa), {
            totp: Object.assign(Object.assign({}, state.mfa.totp), {
              enrollment: Object.assign(Object.assign({}, state.mfa.totp.enrollment), {
                method: method
              })
            })
          }),
          screen: method === 'manual' ? AppScreens$1.TOTPEnrollmentManual : AppScreens$1.TOTPEnrollmentQRCode
        });
      }
    default:
      return state;
  }
};
var reducer$1 = function reducer$1(state, action) {
  switch (action.type) {
    case 'transition':
      return Object.assign(Object.assign({}, state), {
        screen: action.screen
      });
    case 'set_error_message_and_transition':
      return Object.assign(Object.assign({}, state), {
        screen: AppScreens$1.Error,
        errorType: action.errorType
      });
    case 'set_magic_link_email':
      {
        return Object.assign(Object.assign({}, state), {
          formState: Object.assign(Object.assign({}, state.formState), {
            magicLinkState: {
              email: action.email
            }
          })
        });
      }
    case 'set_organization':
      {
        return Object.assign(Object.assign({}, state), {
          flowState: {
            type: AuthFlowType.Organization,
            organization: action.organization
          }
        });
      }
    case 'set_discovery_state':
      {
        return Object.assign(Object.assign({}, state), {
          formState: Object.assign(Object.assign({}, state.formState), {
            discoveryState: {
              email: action.email,
              discoveredOrganizations: action.discoveredOrganizations,
              intermediateSessionToken: action.intermediateSessionToken
            }
          })
        });
      }
    case 'set_password_state':
      {
        return Object.assign(Object.assign({}, state), {
          formState: Object.assign(Object.assign({}, state.formState), {
            passwordState: {
              email: action.email
            }
          })
        });
      }
    default:
      return mfaReducer(state, action);
  }
};
var AppScreens$1;
(function (AppScreens) {
  AppScreens["Main"] = "Main";
  AppScreens["EmailConfirmation"] = "Email Confirmation";
  AppScreens["LoggedIn"] = "Logged In";
  AppScreens["Discovery"] = "Discovery";
  AppScreens["Error"] = "Error";
  AppScreens["PasswordEmailForm"] = "Password Email";
  AppScreens["PasswordAuthenticate"] = "Password Authenticate";
  AppScreens["PasswordResetForm"] = "Password Reset Form";
  AppScreens["PasswordResetVerifyConfirmation"] = "Password Reset Verify Confirmation";
  AppScreens["PasswordForgotForm"] = "Password Forgot Form";
  AppScreens["PasswordSetNewConfirmation"] = "Password Set New Confirmation";
  AppScreens["MFAEnrollmentSelection"] = "MFA Enrollment Selection";
  AppScreens["RecoveryCodeEntry"] = "Recovery Code Entry";
  AppScreens["RecoveryCodeSave"] = "Recovery Code Save";
  AppScreens["SMSOTPEnrollment"] = "SMS OTP Enrollment";
  AppScreens["SMSOTPEntry"] = "SMS OTP Entry";
  AppScreens["TOTPEnrollmentManual"] = "TOTP Enrollment Manual";
  AppScreens["TOTPEnrollmentQRCode"] = "TOTP Enrollment QR Code";
  AppScreens["TOTPEntry"] = "TOTP Entry";
})(AppScreens$1 || (AppScreens$1 = {}));
var ErrorType;
(function (ErrorType) {
  ErrorType[ErrorType["Default"] = 0] = "Default";
  ErrorType[ErrorType["EmailMagicLink"] = 1] = "EmailMagicLink";
  ErrorType[ErrorType["Organization"] = 2] = "Organization";
})(ErrorType || (ErrorType = {}));
var DEFAULT_STATE = {
  screen: AppScreens$1.Main,
  formState: {
    magicLinkState: {
      email: ''
    },
    discoveryState: {
      email: '',
      intermediateSessionToken: '',
      discoveredOrganizations: []
    },
    passwordState: {
      email: ''
    }
  },
  flowState: {
    type: AuthFlowType.Organization,
    organization: null
  },
  mfa: DEFAULT_MFA_STATE,
  errorType: ErrorType.Default
};
var DEFAULT_CONFIG = {
  products: [B2BProducts.emailMagicLinks],
  authFlowType: AuthFlowType.Organization,
  sessionOptions: {
    sessionDurationMinutes: 60
  }
};
var GlobalContext = /*#__PURE__*/wn.createContext({
  client: {},
  config: DEFAULT_CONFIG,
  state: [DEFAULT_STATE, function () {
    return null;
  }]
});
var GlobalContextProvider = function GlobalContextProvider(_ref4) {
  var children = _ref4.children,
    client = _ref4.client,
    config = _ref4.config,
    callbacks = _ref4.callbacks,
    initialState = _ref4.initialState;
  var state = wn.useReducer(reducer$1, initialState !== null && initialState !== void 0 ? initialState : DEFAULT_STATE);
  return /*#__PURE__*/wn.createElement(GlobalContext.Provider, {
    value: {
      client: client,
      state: state,
      config: config,
      callbacks: callbacks
    }
  }, children);
};
var useGlobalContext = function useGlobalContext() {
  return q(GlobalContext);
};
var useStytch = function useStytch() {
  return useGlobalContext().client;
};
var useGlobalReducer = function useGlobalReducer() {
  return useGlobalContext().state;
};
var useConfig = function useConfig() {
  return useGlobalContext().config;
};
var useErrorCallback = function useErrorCallback() {
  var _a, _b;
  return (_b = (_a = useGlobalContext().callbacks) === null || _a === void 0 ? void 0 : _a.onError) !== null && _b !== void 0 ? _b : function () {
    return void 0;
  };
};
var useEventCallback = function useEventCallback() {
  var _a, _b;
  return (_b = (_a = useGlobalContext().callbacks) === null || _a === void 0 ? void 0 : _a.onEvent) !== null && _b !== void 0 ? _b : function () {
    return void 0;
  };
};
var AppScreens;
(function (AppScreens) {
  AppScreens["Main"] = "Main";
  AppScreens["PasskeyRegistrationStart"] = "Register New Passkey";
  AppScreens["PasskeyRegistrationSuccess"] = "Passkey Registration Success";
  AppScreens["PasskeyConfirmation"] = "Passkey Confirmation";
  AppScreens["PasswordCreateOrLogin"] = "Password";
  AppScreens["PasswordResetForm"] = "Password Reset Form";
  AppScreens["PasswordForgot"] = "Password Forgot";
  AppScreens["PasswordBreached"] = "Password Breached";
  AppScreens["PasswordSetNew"] = "Password Set New";
  AppScreens["PasswordDedupe"] = "Password Dedupe";
  AppScreens["PasswordConfirmation"] = "Password Confirmation";
  AppScreens["EmailConfirmation"] = "Email Confirmation";
  AppScreens["OTPAuthenticate"] = "OTP Authenticate";
  AppScreens["OTPConfirmation"] = "OTP Confirmation";
  AppScreens["CryptoConnect"] = "Crypto Connect";
  AppScreens["CryptoSignMessage"] = "Crypto Sign Message";
  AppScreens["CryptoOtherScreen"] = "Crypto Other Screen";
  AppScreens["CryptoSetupWallet"] = "Crypto Setup Wallet";
  AppScreens["CryptoError"] = "Crypto Error";
  AppScreens["CryptoConfirmation"] = "Crypto Confirmation";
})(AppScreens || (AppScreens = {}));
({
  screen: AppScreens.Main,
  formState: {
    magicLinkState: {
      email: ''
    },
    otpState: {
      type: OTPMethods.Email,
      methodId: '',
      otpDestination: ''
    },
    cryptoState: {
      walletAddress: '',
      walletOption: Wallets.Metamask,
      walletChallenge: ''
    },
    passwordState: {
      email: '',
      type: 'new'
    },
    resetPasswordState: {
      token: ''
    },
    errorMessage: ''
  }
});
({
  products: [Products.emailMagicLinks],
  emailMagicLinksOptions: {
    loginRedirectURL: '',
    loginExpirationMinutes: 30,
    signupRedirectURL: '',
    signupExpirationMinutes: 30,
    createUserAsPending: false
  }
});
var DEFAULT_STYLE_CONFIG = {
  container: {
    backgroundColor: '#FFFFFF',
    borderColor: '#ADBCC5',
    borderRadius: '8px',
    width: '400px'
  },
  colors: {
    primary: '#19303D',
    secondary: '#5C727D',
    success: '#0C5A56',
    error: '#8B1214'
  },
  buttons: {
    primary: {
      backgroundColor: '#19303D',
      textColor: '#FFFFFF',
      borderColor: '#19303D',
      borderRadius: '4px'
    },
    secondary: {
      backgroundColor: '#FFFFFF',
      textColor: '#19303D',
      borderColor: '#19303D',
      borderRadius: '4px'
    },
    disabled: {
      backgroundColor: '#F3F5F6',
      textColor: '#8296A1',
      borderColor: '#F3F5F6',
      borderRadius: '4px'
    }
  },
  fontFamily: 'Arial, Helvetica, sans-serif',
  hideHeaderText: false,
  logo: {
    logoImageUrl: ''
  }
};
var defaultDisabledTextColor = '#8296A1';
var createTheme = function createTheme(styles) {
  var displayWatermark = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  var styleConfig = merge({}, DEFAULT_STYLE_CONFIG, styles);
  return {
    typography: {
      fontFamily: styleConfig.fontFamily,
      header: {
        fontFamily: styleConfig.fontFamily,
        fontSize: 24,
        fontWeight: 600,
        lineHeight: '30px'
      },
      body: {
        fontFamily: styleConfig.fontFamily,
        fontSize: 16,
        fontWeight: 'normal',
        lineHeight: '21px'
      },
      helper: {
        fontFamily: styleConfig.fontFamily,
        fontSize: 14,
        fontWeight: '400',
        lineHeight: '20px',
        whiteSpace: 'pre-wrap'
      }
    },
    colors: {
      primary: styleConfig.colors.primary,
      secondary: styleConfig.colors.secondary,
      success: styleConfig.colors.success,
      error: styleConfig.colors.error,
      disabled: '#F3F5F6',
      disabledText: defaultDisabledTextColor
    },
    container: {
      width: styleConfig.container.width,
      border: "1px solid ".concat(styleConfig.container.borderColor),
      borderRadius: styleConfig.container.borderRadius,
      backgroundColor: styleConfig.container.backgroundColor
    },
    buttons: {
      primary: {
        backgroundColor: styleConfig.buttons.primary.backgroundColor,
        textColor: styleConfig.buttons.primary.textColor,
        border: "1px solid ".concat(styleConfig.buttons.primary.borderColor),
        borderRadius: styleConfig.buttons.primary.borderRadius
      },
      secondary: {
        backgroundColor: styleConfig.buttons.secondary.backgroundColor,
        textColor: styleConfig.buttons.secondary.textColor,
        border: "1px solid ".concat(styleConfig.buttons.secondary.borderColor),
        borderRadius: styleConfig.buttons.secondary.borderRadius
      },
      disabled: {
        textColor: styleConfig.buttons.disabled.textColor,
        backgroundColor: styleConfig.buttons.disabled.backgroundColor,
        border: "1px solid ".concat(styleConfig.buttons.disabled.borderColor),
        borderRadius: styleConfig.buttons.disabled.borderRadius
      }
    },
    inputs: {
      backgroundColor: (_b = (_a = styleConfig.inputs) === null || _a === void 0 ? void 0 : _a.backgroundColor) !== null && _b !== void 0 ? _b : 'transparent',
      textColor: (_d = (_c = styleConfig.inputs) === null || _c === void 0 ? void 0 : _c.textColor) !== null && _d !== void 0 ? _d : styleConfig.colors.primary,
      borderColor: (_f = (_e = styleConfig.inputs) === null || _e === void 0 ? void 0 : _e.borderColor) !== null && _f !== void 0 ? _f : styleConfig.colors.primary,
      borderRadius: (_h = (_g = styleConfig.inputs) === null || _g === void 0 ? void 0 : _g.borderRadius) !== null && _h !== void 0 ? _h : '4px',
      placeholderColor: (_k = (_j = styleConfig.inputs) === null || _j === void 0 ? void 0 : _j.placeholderColor) !== null && _k !== void 0 ? _k : defaultDisabledTextColor
    },
    displayHeader: !styleConfig.hideHeaderText,
    displayWatermark: displayWatermark,
    logo: {
      logoImageUrl: styleConfig.logo.logoImageUrl
    }
  };
};
var useTheme = function useTheme(_ref5) {
  var styles = _ref5.styles,
    displayWatermark = _ref5.displayWatermark;
  return F(function () {
    return createTheme(styles, displayWatermark);
  }, [styles, displayWatermark]);
};
var e = {
    data: ""
  },
  t = function t(_t2) {
    return "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) ? ((_t2 ? _t2.querySelector("#_goober") : window._goober) || Object.assign((_t2 || document.head).appendChild(document.createElement("style")), {
      innerHTML: " ",
      id: "_goober"
    })).firstChild : _t2 || e;
  },
  l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g,
  a = /\/\*[^]*?\*\/|  +/g,
  n = /\n+/g,
  o = function o(e, t) {
    var r = "",
      l = "",
      a = "";
    var _loop = function _loop(_n) {
      var c = e[_n];
      "@" == _n[0] ? "i" == _n[1] ? r = _n + " " + c + ";" : l += "f" == _n[1] ? o(c, _n) : _n + "{" + o(c, "k" == _n[1] ? "" : t) + "}" : "object" == _typeof(c) ? l += o(c, t ? t.replace(/([^,])+/g, function (e) {
        return _n.replace(/(^:.*)|([^,])+/g, function (t) {
          return /&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t;
        });
      }) : _n) : null != c && (_n = /^--/.test(_n) ? _n : _n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += o.p ? o.p(_n, c) : _n + ":" + c + ";");
    };
    for (var _n in e) {
      _loop(_n);
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
  },
  c = {},
  s = function s(e) {
    if ("object" == _typeof(e)) {
      var _t3 = "";
      for (var r in e) _t3 += r + s(e[r]);
      return _t3;
    }
    return e;
  },
  i = function i(e, t, r, _i, p) {
    var u = s(e),
      d = c[u] || (c[u] = function (e) {
        var t = 0,
          r = 11;
        for (; t < e.length;) r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
      }(u));
    if (!c[d]) {
      var _t4 = u !== e ? e : function (e) {
        var t,
          r,
          o = [{}];
        for (; t = l.exec(e.replace(a, ""));) t[4] ? o.shift() : t[3] ? (r = t[3].replace(n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace(n, " ").trim();
        return o[0];
      }(e);
      c[d] = o(p ? _defineProperty({}, "@keyframes " + d, _t4) : _t4, r ? "" : "." + d);
    }
    var f = r && c.g ? c.g : null;
    return r && (c.g = c[d]), function (e, t, r, l) {
      l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    }(c[d], t, _i, f), d;
  },
  p = function p(e, t, r) {
    return e.reduce(function (e, l, a) {
      var n = t[a];
      if (n && n.call) {
        var _e2 = n(r),
          _t5 = _e2 && _e2.props && _e2.props.className || /^go/.test(_e2) && _e2;
        n = _t5 ? "." + _t5 : _e2 && "object" == _typeof(_e2) ? _e2.props ? "" : o(_e2, "") : !1 === _e2 ? "" : _e2;
      }
      return e + l + (null == n ? "" : n);
    }, "");
  };
function u(e) {
  var r = this || {},
    l = e.call ? e(r.p) : e;
  return i(l.unshift ? l.raw ? p(l, [].slice.call(arguments, 1), r.p) : l.reduce(function (e, t) {
    return Object.assign(e, t && t.call ? t(r.p) : t);
  }, {}) : l, t(r.target), r.g, r.o, r.k);
}
var d, f, g;
u.bind({
  g: 1
});
var h = u.bind({
  k: 1
});
function m(e, t, r, l) {
  o.p = t, d = e, f = r, g = l;
}
function j(e, t) {
  var r = this || {};
  return function () {
    var l = arguments;
    function a(n, o) {
      var c = Object.assign({}, n),
        s = c.className || a.className;
      r.p = Object.assign({
        theme: f && f()
      }, c), r.o = / *go\d+/.test(s), c.className = u.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
      var i = e;
      return e[0] && (i = c.as || e, delete c.as), g && i[0] && g(c), d(i, c);
    }
    return t ? t(a) : a;
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}
var isFunction = function isFunction(valOrFunction) {
  return typeof valOrFunction === 'function';
};
var resolveValue = function resolveValue(valOrFunction, arg) {
  return isFunction(valOrFunction) ? valOrFunction(arg) : valOrFunction;
};
var genId = /*#__PURE__*/function () {
  var count = 0;
  return function () {
    return (++count).toString();
  };
}();
var createRectRef = function createRectRef(onRect) {
  return function (el) {
    if (el) {
      setTimeout(function () {
        var boundingRect = el.getBoundingClientRect();
        onRect(boundingRect);
      });
    }
  };
};
var prefersReducedMotion = /*#__PURE__*/function () {
  var shouldReduceMotion = undefined;
  return function () {
    if (shouldReduceMotion === undefined && typeof window !== 'undefined') {
      var mediaQuery = matchMedia('(prefers-reduced-motion: reduce)');
      shouldReduceMotion = !mediaQuery || mediaQuery.matches;
    }
    return shouldReduceMotion;
  };
}();
var TOAST_LIMIT = 20;
var ActionType;
(function (ActionType) {
  ActionType[ActionType["ADD_TOAST"] = 0] = "ADD_TOAST";
  ActionType[ActionType["UPDATE_TOAST"] = 1] = "UPDATE_TOAST";
  ActionType[ActionType["UPSERT_TOAST"] = 2] = "UPSERT_TOAST";
  ActionType[ActionType["DISMISS_TOAST"] = 3] = "DISMISS_TOAST";
  ActionType[ActionType["REMOVE_TOAST"] = 4] = "REMOVE_TOAST";
  ActionType[ActionType["START_PAUSE"] = 5] = "START_PAUSE";
  ActionType[ActionType["END_PAUSE"] = 6] = "END_PAUSE";
})(ActionType || (ActionType = {}));
var toastTimeouts = /*#__PURE__*/new Map();
var addToRemoveQueue = function addToRemoveQueue(toastId) {
  if (toastTimeouts.has(toastId)) {
    return;
  }
  var timeout = setTimeout(function () {
    toastTimeouts["delete"](toastId);
    dispatch({
      type: ActionType.REMOVE_TOAST,
      toastId: toastId
    });
  }, 1000);
  toastTimeouts.set(toastId, timeout);
};
var clearFromRemoveQueue = function clearFromRemoveQueue(toastId) {
  var timeout = toastTimeouts.get(toastId);
  if (timeout) {
    clearTimeout(timeout);
  }
};
var reducer = function reducer(state, action) {
  switch (action.type) {
    case ActionType.ADD_TOAST:
      return _extends({}, state, {
        toasts: [action.toast].concat(state.toasts).slice(0, TOAST_LIMIT)
      });
    case ActionType.UPDATE_TOAST:
      if (action.toast.id) {
        clearFromRemoveQueue(action.toast.id);
      }
      return _extends({}, state, {
        toasts: state.toasts.map(function (t) {
          return t.id === action.toast.id ? _extends({}, t, action.toast) : t;
        })
      });
    case ActionType.UPSERT_TOAST:
      var toast = action.toast;
      return state.toasts.find(function (t) {
        return t.id === toast.id;
      }) ? reducer(state, {
        type: ActionType.UPDATE_TOAST,
        toast: toast
      }) : reducer(state, {
        type: ActionType.ADD_TOAST,
        toast: toast
      });
    case ActionType.DISMISS_TOAST:
      var toastId = action.toastId;
      if (toastId) {
        addToRemoveQueue(toastId);
      } else {
        state.toasts.forEach(function (toast) {
          addToRemoveQueue(toast.id);
        });
      }
      return _extends({}, state, {
        toasts: state.toasts.map(function (t) {
          return t.id === toastId || toastId === undefined ? _extends({}, t, {
            visible: false
          }) : t;
        })
      });
    case ActionType.REMOVE_TOAST:
      if (action.toastId === undefined) {
        return _extends({}, state, {
          toasts: []
        });
      }
      return _extends({}, state, {
        toasts: state.toasts.filter(function (t) {
          return t.id !== action.toastId;
        })
      });
    case ActionType.START_PAUSE:
      return _extends({}, state, {
        pausedAt: action.time
      });
    case ActionType.END_PAUSE:
      var diff = action.time - (state.pausedAt || 0);
      return _extends({}, state, {
        pausedAt: undefined,
        toasts: state.toasts.map(function (t) {
          return _extends({}, t, {
            pauseDuration: t.pauseDuration + diff
          });
        })
      });
  }
};
var listeners = [];
var memoryState = {
  toasts: [],
  pausedAt: undefined
};
var dispatch = function dispatch(action) {
  memoryState = reducer(memoryState, action);
  listeners.forEach(function (listener) {
    listener(memoryState);
  });
};
var defaultTimeouts = {
  blank: 4000,
  error: 4000,
  success: 2000,
  loading: Infinity,
  custom: 4000
};
var useStore = function useStore(toastOptions) {
  if (toastOptions === void 0) {
    toastOptions = {};
  }
  var _useState = h$1(memoryState),
    state = _useState[0],
    setState = _useState[1];
  p$1(function () {
    listeners.push(setState);
    return function () {
      var index = listeners.indexOf(setState);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  }, [state]);
  var mergedToasts = state.toasts.map(function (t) {
    var _toastOptions$t$type, _toastOptions, _toastOptions$t$type2;
    return _extends({}, toastOptions, toastOptions[t.type], t, {
      duration: t.duration || ((_toastOptions$t$type = toastOptions[t.type]) == null ? void 0 : _toastOptions$t$type.duration) || ((_toastOptions = toastOptions) == null ? void 0 : _toastOptions.duration) || defaultTimeouts[t.type],
      style: _extends({}, toastOptions.style, (_toastOptions$t$type2 = toastOptions[t.type]) == null ? void 0 : _toastOptions$t$type2.style, t.style)
    });
  });
  return _extends({}, state, {
    toasts: mergedToasts
  });
};
var createToast = function createToast(message, type, opts) {
  if (type === void 0) {
    type = 'blank';
  }
  return _extends({
    createdAt: Date.now(),
    visible: true,
    type: type,
    ariaProps: {
      role: 'status',
      'aria-live': 'polite'
    },
    message: message,
    pauseDuration: 0
  }, opts, {
    id: (opts == null ? void 0 : opts.id) || genId()
  });
};
var createHandler = function createHandler(type) {
  return function (message, options) {
    var toast = createToast(message, type, options);
    dispatch({
      type: ActionType.UPSERT_TOAST,
      toast: toast
    });
    return toast.id;
  };
};
var toast = function toast(message, opts) {
  return createHandler('blank')(message, opts);
};
toast.error = /*#__PURE__*/createHandler('error');
toast.success = /*#__PURE__*/createHandler('success');
toast.loading = /*#__PURE__*/createHandler('loading');
toast.custom = /*#__PURE__*/createHandler('custom');
toast.dismiss = function (toastId) {
  dispatch({
    type: ActionType.DISMISS_TOAST,
    toastId: toastId
  });
};
toast.remove = function (toastId) {
  return dispatch({
    type: ActionType.REMOVE_TOAST,
    toastId: toastId
  });
};
toast.promise = function (promise, msgs, opts) {
  var id = toast.loading(msgs.loading, _extends({}, opts, opts == null ? void 0 : opts.loading));
  promise.then(function (p) {
    toast.success(resolveValue(msgs.success, p), _extends({
      id: id
    }, opts, opts == null ? void 0 : opts.success));
    return p;
  })["catch"](function (e) {
    toast.error(resolveValue(msgs.error, e), _extends({
      id: id
    }, opts, opts == null ? void 0 : opts.error));
  });
  return promise;
};
var useToaster = function useToaster(toastOptions) {
  var _useStore = useStore(toastOptions),
    toasts = _useStore.toasts,
    pausedAt = _useStore.pausedAt;
  p$1(function () {
    if (pausedAt) {
      return;
    }
    var now = Date.now();
    var timeouts = toasts.map(function (t) {
      if (t.duration === Infinity) {
        return;
      }
      var durationLeft = (t.duration || 0) + t.pauseDuration - (now - t.createdAt);
      if (durationLeft < 0) {
        if (t.visible) {
          toast.dismiss(t.id);
        }
        return;
      }
      return setTimeout(function () {
        return toast.dismiss(t.id);
      }, durationLeft);
    });
    return function () {
      timeouts.forEach(function (timeout) {
        return timeout && clearTimeout(timeout);
      });
    };
  }, [toasts, pausedAt]);
  var handlers = F(function () {
    return {
      startPause: function startPause() {
        dispatch({
          type: ActionType.START_PAUSE,
          time: Date.now()
        });
      },
      endPause: function endPause() {
        if (pausedAt) {
          dispatch({
            type: ActionType.END_PAUSE,
            time: Date.now()
          });
        }
      },
      updateHeight: function updateHeight(toastId, height) {
        return dispatch({
          type: ActionType.UPDATE_TOAST,
          toast: {
            id: toastId,
            height: height
          }
        });
      },
      calculateOffset: function calculateOffset(toast, opts) {
        var _relevantToasts$filte;
        var _ref = opts || {},
          _ref$reverseOrder = _ref.reverseOrder,
          reverseOrder = _ref$reverseOrder === void 0 ? false : _ref$reverseOrder,
          _ref$gutter = _ref.gutter,
          gutter = _ref$gutter === void 0 ? 8 : _ref$gutter,
          defaultPosition = _ref.defaultPosition;
        var relevantToasts = toasts.filter(function (t) {
          return (t.position || defaultPosition) === (toast.position || defaultPosition) && t.height;
        });
        var toastIndex = relevantToasts.findIndex(function (t) {
          return t.id === toast.id;
        });
        var toastsBefore = relevantToasts.filter(function (toast, i) {
          return i < toastIndex && toast.visible;
        }).length;
        var offset = (_relevantToasts$filte = relevantToasts.filter(function (t) {
          return t.visible;
        })).slice.apply(_relevantToasts$filte, reverseOrder ? [toastsBefore + 1] : [0, toastsBefore]).reduce(function (acc, t) {
          return acc + (t.height || 0) + gutter;
        }, 0);
        return offset;
      }
    };
  }, [toasts, pausedAt]);
  return {
    toasts: toasts,
    handlers: handlers
  };
};
function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 20px;\n  opacity: 0;\n  height: 20px;\n  border-radius: 10px;\n  background: ", ";\n  position: relative;\n  transform: rotate(45deg);\n\n  animation: ", " 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n  animation-delay: 100ms;\n\n  &:after,\n  &:before {\n    content: '';\n    animation: ", " 0.15s ease-out forwards;\n    animation-delay: 150ms;\n    position: absolute;\n    border-radius: 3px;\n    opacity: 0;\n    background: ", ";\n    bottom: 9px;\n    left: 4px;\n    height: 2px;\n    width: 12px;\n  }\n\n  &:before {\n    animation: ", " 0.15s ease-out forwards;\n    animation-delay: 180ms;\n    transform: rotate(90deg);\n  }\n"]);
  _templateObject4 = function _templateObject4() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\nfrom {\n  transform: scale(0) rotate(90deg);\n\topacity: 0;\n}\nto {\n  transform: scale(1) rotate(90deg);\n\topacity: 1;\n}"]);
  _templateObject3 = function _templateObject3() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\nfrom {\n  transform: scale(0);\n  opacity: 0;\n}\nto {\n  transform: scale(1);\n  opacity: 1;\n}"]);
  _templateObject2 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\nfrom {\n  transform: scale(0) rotate(45deg);\n\topacity: 0;\n}\nto {\n transform: scale(1) rotate(45deg);\n  opacity: 1;\n}"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
var circleAnimation = /*#__PURE__*/h( /*#__PURE__*/_templateObject());
var firstLineAnimation = /*#__PURE__*/h( /*#__PURE__*/_templateObject2());
var secondLineAnimation = /*#__PURE__*/h( /*#__PURE__*/_templateObject3());
var ErrorIcon$1 = /*#__PURE__*/j('div')( /*#__PURE__*/_templateObject4(), function (p) {
  return p.primary || '#ff4b4b';
}, circleAnimation, firstLineAnimation, function (p) {
  return p.secondary || '#fff';
}, secondLineAnimation);
function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 12px;\n  height: 12px;\n  box-sizing: border-box;\n  border: 2px solid;\n  border-radius: 100%;\n  border-color: ", ";\n  border-right-color: ", ";\n  animation: ", " 1s linear infinite;\n"]);
  _templateObject2$1 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"]);
  _templateObject$1 = function _templateObject() {
    return data;
  };
  return data;
}
var rotate = /*#__PURE__*/h( /*#__PURE__*/_templateObject$1());
var LoaderIcon = /*#__PURE__*/j('div')( /*#__PURE__*/_templateObject2$1(), function (p) {
  return p.secondary || '#e0e0e0';
}, function (p) {
  return p.primary || '#616161';
}, rotate);
function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 20px;\n  opacity: 0;\n  height: 20px;\n  border-radius: 10px;\n  background: ", ";\n  position: relative;\n  transform: rotate(45deg);\n\n  animation: ", " 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n  animation-delay: 100ms;\n  &:after {\n    content: '';\n    box-sizing: border-box;\n    animation: ", " 0.2s ease-out forwards;\n    opacity: 0;\n    animation-delay: 200ms;\n    position: absolute;\n    border-right: 2px solid;\n    border-bottom: 2px solid;\n    border-color: ", ";\n    bottom: 6px;\n    left: 6px;\n    height: 10px;\n    width: 6px;\n  }\n"]);
  _templateObject3$1 = function _templateObject3() {
    return data;
  };
  return data;
}
function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n0% {\n\theight: 0;\n\twidth: 0;\n\topacity: 0;\n}\n40% {\n  height: 0;\n\twidth: 6px;\n\topacity: 1;\n}\n100% {\n  opacity: 1;\n  height: 10px;\n}"]);
  _templateObject2$2 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\nfrom {\n  transform: scale(0) rotate(45deg);\n\topacity: 0;\n}\nto {\n  transform: scale(1) rotate(45deg);\n\topacity: 1;\n}"]);
  _templateObject$2 = function _templateObject() {
    return data;
  };
  return data;
}
var circleAnimation$1 = /*#__PURE__*/h( /*#__PURE__*/_templateObject$2());
var checkmarkAnimation = /*#__PURE__*/h( /*#__PURE__*/_templateObject2$2());
var CheckmarkIcon = /*#__PURE__*/j('div')( /*#__PURE__*/_templateObject3$1(), function (p) {
  return p.primary || '#61d345';
}, circleAnimation$1, checkmarkAnimation, function (p) {
  return p.secondary || '#fff';
});
function _templateObject4$1() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  transform: scale(0.6);\n  opacity: 0.4;\n  min-width: 20px;\n  animation: ", " 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n"]);
  _templateObject4$1 = function _templateObject4() {
    return data;
  };
  return data;
}
function _templateObject3$2() {
  var data = _taggedTemplateLiteralLoose(["\nfrom {\n  transform: scale(0.6);\n  opacity: 0.4;\n}\nto {\n  transform: scale(1);\n  opacity: 1;\n}"]);
  _templateObject3$2 = function _templateObject3() {
    return data;
  };
  return data;
}
function _templateObject2$3() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 20px;\n  min-height: 20px;\n"]);
  _templateObject2$3 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n"]);
  _templateObject$3 = function _templateObject() {
    return data;
  };
  return data;
}
var StatusWrapper = /*#__PURE__*/j('div')( /*#__PURE__*/_templateObject$3());
var IndicatorWrapper = /*#__PURE__*/j('div')( /*#__PURE__*/_templateObject2$3());
var enter = /*#__PURE__*/h( /*#__PURE__*/_templateObject3$2());
var AnimatedIconWrapper = /*#__PURE__*/j('div')( /*#__PURE__*/_templateObject4$1(), enter);
var ToastIcon = function ToastIcon(_ref) {
  var toast = _ref.toast;
  var icon = toast.icon,
    type = toast.type,
    iconTheme = toast.iconTheme;
  if (icon !== undefined) {
    if (typeof icon === 'string') {
      return /*#__PURE__*/y(AnimatedIconWrapper, null, icon);
    } else {
      return icon;
    }
  }
  if (type === 'blank') {
    return null;
  }
  return /*#__PURE__*/y(IndicatorWrapper, null, /*#__PURE__*/y(LoaderIcon, Object.assign({}, iconTheme)), type !== 'loading' && /*#__PURE__*/y(StatusWrapper, null, type === 'error' ? /*#__PURE__*/y(ErrorIcon$1, Object.assign({}, iconTheme)) : /*#__PURE__*/y(CheckmarkIcon, Object.assign({}, iconTheme))));
};
function _templateObject2$4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  margin: 4px 10px;\n  color: inherit;\n  flex: 1 1 auto;\n  white-space: pre-line;\n"]);
  _templateObject2$4 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  background: #fff;\n  color: #363636;\n  line-height: 1.3;\n  will-change: transform;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);\n  max-width: 350px;\n  pointer-events: auto;\n  padding: 8px 10px;\n  border-radius: 8px;\n"]);
  _templateObject$4 = function _templateObject() {
    return data;
  };
  return data;
}
var enterAnimation = function enterAnimation(factor) {
  return "\n0% {transform: translate3d(0," + factor * -200 + "%,0) scale(.6); opacity:.5;}\n100% {transform: translate3d(0,0,0) scale(1); opacity:1;}\n";
};
var exitAnimation = function exitAnimation(factor) {
  return "\n0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}\n100% {transform: translate3d(0," + factor * -150 + "%,-1px) scale(.6); opacity:0;}\n";
};
var fadeInAnimation = "0%{opacity:0;} 100%{opacity:1;}";
var fadeOutAnimation = "0%{opacity:1;} 100%{opacity:0;}";
var ToastBarBase = /*#__PURE__*/j('div', N)( /*#__PURE__*/_templateObject$4());
var Message = /*#__PURE__*/j('div')( /*#__PURE__*/_templateObject2$4());
var getAnimationStyle = function getAnimationStyle(position, visible) {
  var top = position.includes('top');
  var factor = top ? 1 : -1;
  var _ref = prefersReducedMotion() ? [fadeInAnimation, fadeOutAnimation] : [enterAnimation(factor), exitAnimation(factor)],
    enter = _ref[0],
    exit = _ref[1];
  return {
    animation: visible ? h(enter) + " 0.35s cubic-bezier(.21,1.02,.73,1) forwards" : h(exit) + " 0.4s forwards cubic-bezier(.06,.71,.55,1)"
  };
};
var ToastBar = /*#__PURE__*/w(function (_ref2) {
  var toast = _ref2.toast,
    position = _ref2.position,
    style = _ref2.style,
    children = _ref2.children;
  var animationStyle = toast != null && toast.height ? getAnimationStyle(toast.position || position || 'top-center', toast.visible) : {
    opacity: 0
  };
  var icon = /*#__PURE__*/y(ToastIcon, {
    toast: toast
  });
  var message = /*#__PURE__*/y(Message, Object.assign({}, toast.ariaProps), resolveValue(toast.message, toast));
  return /*#__PURE__*/y(ToastBarBase, {
    className: toast.className,
    style: _extends({}, animationStyle, style, toast.style)
  }, typeof children === 'function' ? children({
    icon: icon,
    message: message
  }) : /*#__PURE__*/y(g$1, null, icon, message));
});
function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n  z-index: 9999;\n  > * {\n    pointer-events: auto;\n  }\n"]);
  _templateObject$5 = function _templateObject() {
    return data;
  };
  return data;
}
m(y);
var getPositionStyle = function getPositionStyle(position, offset) {
  var top = position.includes('top');
  var verticalStyle = top ? {
    top: 0
  } : {
    bottom: 0
  };
  var horizontalStyle = position.includes('center') ? {
    justifyContent: 'center'
  } : position.includes('right') ? {
    justifyContent: 'flex-end'
  } : {};
  return _extends({
    left: 0,
    right: 0,
    display: 'flex',
    position: 'absolute',
    transition: prefersReducedMotion() ? undefined : "all 230ms cubic-bezier(.21,1.02,.73,1)",
    transform: "translateY(" + offset * (top ? 1 : -1) + "px)"
  }, verticalStyle, horizontalStyle);
};
var activeClass = /*#__PURE__*/u( /*#__PURE__*/_templateObject$5());
var DEFAULT_OFFSET = 16;
var Toaster = function Toaster(_ref) {
  var reverseOrder = _ref.reverseOrder,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'top-center' : _ref$position,
    toastOptions = _ref.toastOptions,
    gutter = _ref.gutter,
    children = _ref.children,
    containerStyle = _ref.containerStyle,
    containerClassName = _ref.containerClassName;
  var _useToaster = useToaster(toastOptions),
    toasts = _useToaster.toasts,
    handlers = _useToaster.handlers;
  return /*#__PURE__*/y("div", {
    style: _extends({
      position: 'fixed',
      zIndex: 9999,
      top: DEFAULT_OFFSET,
      left: DEFAULT_OFFSET,
      right: DEFAULT_OFFSET,
      bottom: DEFAULT_OFFSET,
      pointerEvents: 'none'
    }, containerStyle),
    className: containerClassName,
    onMouseEnter: handlers.startPause,
    onMouseLeave: handlers.endPause
  }, toasts.map(function (t) {
    var toastPosition = t.position || position;
    var offset = handlers.calculateOffset(t, {
      reverseOrder: reverseOrder,
      gutter: gutter,
      defaultPosition: position
    });
    var positionStyle = getPositionStyle(toastPosition, offset);
    var ref = t.height ? undefined : createRectRef(function (rect) {
      handlers.updateHeight(t.id, rect.height);
    });
    return /*#__PURE__*/y("div", {
      ref: ref,
      className: t.visible ? activeClass : '',
      key: t.id,
      style: positionStyle
    }, t.type === 'custom' ? resolveValue(t.message, t) : children ? children(t) : /*#__PURE__*/y(ToastBar, {
      toast: t,
      position: toastPosition
    }));
  }));
};
var toast$1 = toast;
var SuccessIcon = function SuccessIcon() {
  return /*#__PURE__*/y("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/y("path", {
    d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z",
    fill: "#0F4447"
  }));
};
var ErrorIcon = function ErrorIcon() {
  return /*#__PURE__*/y("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/y("path", {
    d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z",
    fill: "#590607"
  }));
};
var baseStyles = {
  display: 'flex',
  gap: '8px',
  padding: '8px',
  fontSize: '14px',
  borderRadius: '4px'
};
var successStyles = Object.assign(Object.assign({}, baseStyles), {
  background: '#ECFFF5',
  boxShadow: '0px 5px 10px rgba(15, 68, 71, 0.18)',
  color: '#0F4447'
});
var errorStyles = Object.assign(Object.assign({}, baseStyles), {
  background: '#FFEEEC',
  boxShadow: '0px 5px 10px rgba(89, 6, 7, 0.2)',
  color: '#590607'
});
var Snackbar = function Snackbar() {
  return /*#__PURE__*/wn.createElement(Toaster, {
    containerStyle: {
      position: 'sticky',
      marginTop: '4px',
      marginBottom: '24px'
    },
    toastOptions: {
      success: {
        style: successStyles,
        icon: /*#__PURE__*/wn.createElement(SuccessIcon, null)
      },
      error: {
        style: errorStyles,
        icon: /*#__PURE__*/wn.createElement(ErrorIcon, null)
      }
    }
  });
};
var itemOrNone = function itemOrNone(item) {
  return item !== null && item !== void 0 ? item : undefined;
};
var spaceOrNone = function spaceOrNone(space) {
  return space ? "".concat(space, "px") : undefined;
};
var Flex = He.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: ", ";\n\n  flex-direction: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  order: ", ";\n  align-self: ", ";\n  flex-flow: ", ";\n  flex-wrap: ", ";\n\n  width: ", ";\n  height: ", ";\n  max-width: ", ";\n  max-height: ", ";\n  min-width: ", ";\n  min-height: ", ";\n  padding: ", ";\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n  padding-top: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n\n  gap: ", ";\n"])), function (_ref7) {
  var inline = _ref7.inline;
  return inline ? 'inline-flex' : 'flex';
}, function (_ref8) {
  var direction = _ref8.direction;
  return itemOrNone(direction);
}, function (_ref9) {
  var justifyContent = _ref9.justifyContent,
    center = _ref9.center;
  return center ? 'center' : itemOrNone(justifyContent);
}, function (_ref10) {
  var alignItems = _ref10.alignItems,
    center = _ref10.center;
  return center ? 'center' : itemOrNone(alignItems);
}, function (_ref11) {
  var grow = _ref11.grow;
  return itemOrNone(grow);
}, function (_ref12) {
  var shrink = _ref12.shrink;
  return itemOrNone(shrink);
}, function (_ref13) {
  var order = _ref13.order;
  return itemOrNone(order);
}, function (_ref14) {
  var alignSelf = _ref14.alignSelf;
  return itemOrNone(alignSelf);
}, function (_ref15) {
  var flow = _ref15.flow;
  return itemOrNone(flow);
}, function (_ref16) {
  var wrap = _ref16.wrap;
  return itemOrNone(wrap);
}, function (_ref17) {
  var width = _ref17.width;
  return typeof width === 'string' ? width : spaceOrNone(width);
}, function (_ref18) {
  var height = _ref18.height;
  return typeof height === 'string' ? height : spaceOrNone(height);
}, function (_ref19) {
  var maxWidth = _ref19.maxWidth;
  return typeof maxWidth === 'string' ? maxWidth : spaceOrNone(maxWidth);
}, function (_ref20) {
  var maxHeight = _ref20.maxHeight;
  return typeof maxHeight === 'string' ? maxHeight : spaceOrNone(maxHeight);
}, function (_ref21) {
  var minWidth = _ref21.minWidth;
  return typeof minWidth === 'string' ? minWidth : spaceOrNone(minWidth);
}, function (_ref22) {
  var minHeight = _ref22.minHeight;
  return typeof minHeight === 'string' ? minHeight : spaceOrNone(minHeight);
}, function (_ref23) {
  var padding = _ref23.padding;
  return spaceOrNone(padding);
}, function (_ref24) {
  var margin = _ref24.margin;
  return spaceOrNone(margin);
}, function (_ref25) {
  var marginTop = _ref25.marginTop;
  return spaceOrNone(marginTop);
}, function (_ref26) {
  var marginRight = _ref26.marginRight;
  return spaceOrNone(marginRight);
}, function (_ref27) {
  var marginBottom = _ref27.marginBottom;
  return spaceOrNone(marginBottom);
}, function (_ref28) {
  var marginLeft = _ref28.marginLeft;
  return spaceOrNone(marginLeft);
}, function (_ref29) {
  var paddingTop = _ref29.paddingTop;
  return spaceOrNone(paddingTop);
}, function (_ref30) {
  var paddingRight = _ref30.paddingRight;
  return spaceOrNone(paddingRight);
}, function (_ref31) {
  var paddingBottom = _ref31.paddingBottom;
  return spaceOrNone(paddingBottom);
}, function (_ref32) {
  var paddingLeft = _ref32.paddingLeft;
  return spaceOrNone(paddingLeft);
}, function (_ref33) {
  var gap = _ref33.gap;
  return spaceOrNone(gap);
});
var Text = He.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-align: ", ";\n  ", ";\n"])), function (props) {
  return props.color && props.theme.colors[props.color];
}, function (props) {
  return props.align;
}, function (props) {
  return props.size && props.theme.typography[props.size];
});
Text.defaultProps = {
  size: 'body',
  color: 'primary',
  align: 'left'
};
var ErrorSVG = function ErrorSVG() {
  return /*#__PURE__*/wn.createElement("svg", {
    width: "200",
    height: "200",
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/wn.createElement("g", {
    opacity: "0.1"
  }, /*#__PURE__*/wn.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.9999 0C155.229 0 200 44.7715 200 99.9999C200 155.229 155.229 200 99.9999 200C44.7715 200 0 155.229 0 99.9999C0 44.7715 44.7715 0 99.9999 0Z",
    fill: "url(#paint0_linear_4408_12810)"
  })), /*#__PURE__*/wn.createElement("g", {
    opacity: "0.3"
  }, /*#__PURE__*/wn.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.9993 17.5723C145.523 17.5723 182.427 54.4762 182.427 99.9993C182.427 145.523 145.523 182.427 99.9993 182.427C54.4762 182.427 17.5723 145.523 17.5723 99.9993C17.5723 54.4762 54.4762 17.5723 99.9993 17.5723Z",
    fill: "url(#paint1_linear_4408_12810)"
  })), /*#__PURE__*/wn.createElement("g", {
    opacity: "0.7"
  }, /*#__PURE__*/wn.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.9987 32.2305C137.487 32.2305 167.877 62.6203 167.877 100.108C167.877 137.596 137.487 167.986 99.9987 167.986C62.5109 167.986 32.1211 137.596 32.1211 100.108C32.1211 62.6203 62.5109 32.2305 99.9987 32.2305Z",
    fill: "url(#paint2_linear_4408_12810)"
  })), /*#__PURE__*/wn.createElement("path", {
    d: "M100 45.8334C70.1 45.8334 45.8333 70.1 45.8333 100C45.8333 129.9 70.1 154.167 100 154.167C129.9 154.167 154.167 129.9 154.167 100C154.167 70.1 129.9 45.8334 100 45.8334ZM105.417 127.083H94.5833V116.25H105.417V127.083ZM105.417 105.417H94.5833V72.9167H105.417V105.417Z",
    fill: "#8B1214"
  }), /*#__PURE__*/wn.createElement("defs", null, /*#__PURE__*/wn.createElement("linearGradient", {
    id: "paint0_linear_4408_12810",
    x1: "-87.1375",
    y1: "160.384",
    x2: "169.669",
    y2: "338.297",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/wn.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/wn.createElement("stop", {
    offset: "1",
    stopColor: "#8B1214"
  })), /*#__PURE__*/wn.createElement("linearGradient", {
    id: "paint1_linear_4408_12810",
    x1: "-87.138",
    y1: "160.384",
    x2: "169.668",
    y2: "338.297",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/wn.createElement("stop", {
    stopColor: "#F7F0F0"
  }), /*#__PURE__*/wn.createElement("stop", {
    offset: "1",
    stopColor: "#8B1214"
  })), /*#__PURE__*/wn.createElement("linearGradient", {
    id: "paint2_linear_4408_12810",
    x1: "-87.1386",
    y1: "160.493",
    x2: "169.668",
    y2: "338.405",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/wn.createElement("stop", {
    stopColor: "#8B1214",
    stopOpacity: "0.01"
  }), /*#__PURE__*/wn.createElement("stop", {
    offset: "1",
    stopColor: "#E4C7C7"
  }))));
};
var ErrorHeader = He(Text)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  text-align: center;\n"])));
var ErrorScreen = function ErrorScreen() {
  var _useGlobalReducer = useGlobalReducer(),
    _useGlobalReducer2 = _slicedToArray(_useGlobalReducer, 1),
    state = _useGlobalReducer2[0];
  var currentErrorType = state.errorType;
  var ErrorTypeMap = _defineProperty(_defineProperty(_defineProperty({}, ErrorType.Default, 'Something went wrong. Try again later or contact your admin for help.'), ErrorType.EmailMagicLink, 'Something went wrong. Your login link may have expired, been revoked, or been used more than once. Request a new login link to try again, or contact your admin for help.'), ErrorType.Organization, 'The organization you are looking for could not be found. If you think this is a mistake, contact your admin.');
  return /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 24,
    alignItems: "center"
  }, /*#__PURE__*/wn.createElement(ErrorHeader, {
    size: "header"
  }, "Looks like there was an error!"), /*#__PURE__*/wn.createElement(ErrorSVG, null), /*#__PURE__*/wn.createElement(Text, null, ErrorTypeMap[currentErrorType]));
};
var mutation = function mutation() {
  return function (key, fetcher) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _useSWRConfig = useSWRConfig(),
      mutate = _useSWRConfig.mutate;
    var keyRef = _(key);
    var fetcherRef = _(fetcher);
    var configRef = _(config);
    var ditchMutationsUntilRef = _(0);
    var _useStateWithDeps = useStateWithDeps({
        data: UNDEFINED,
        error: UNDEFINED,
        isMutating: false
      }),
      _useStateWithDeps2 = _slicedToArray(_useStateWithDeps, 3),
      stateRef = _useStateWithDeps2[0],
      stateDependencies = _useStateWithDeps2[1],
      setState = _useStateWithDeps2[2];
    var currentState = stateRef.current;
    var trigger = T( /*#__PURE__*/function () {
      var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(arg, opts) {
        var _serialize, _serialize2, serializedKey, resolvedKey, options, mutationStartedAt, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _serialize = serialize(keyRef.current), _serialize2 = _slicedToArray(_serialize, 2), serializedKey = _serialize2[0], resolvedKey = _serialize2[1];
              if (fetcherRef.current) {
                _context.next = 3;
                break;
              }
              throw new Error('Can’t trigger the mutation: missing fetcher.');
            case 3:
              if (serializedKey) {
                _context.next = 5;
                break;
              }
              throw new Error('Can’t trigger the mutation: missing key.');
            case 5:
              options = mergeObjects(mergeObjects({
                populateCache: false,
                throwOnError: true
              }, configRef.current), opts);
              mutationStartedAt = getTimestamp();
              ditchMutationsUntilRef.current = mutationStartedAt;
              setState({
                isMutating: true
              });
              _context.prev = 9;
              _context.next = 12;
              return mutate(serializedKey, fetcherRef.current(resolvedKey, {
                arg: arg
              }), mergeObjects(options, {
                throwOnError: true
              }));
            case 12:
              data = _context.sent;
              if (ditchMutationsUntilRef.current <= mutationStartedAt) {
                setState({
                  data: data,
                  isMutating: false,
                  error: undefined
                });
                options.onSuccess == null ? void 0 : options.onSuccess(data, serializedKey, options);
              }
              return _context.abrupt("return", data);
            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](9);
              if (!(ditchMutationsUntilRef.current <= mutationStartedAt)) {
                _context.next = 24;
                break;
              }
              setState({
                error: _context.t0,
                isMutating: false
              });
              options.onError == null ? void 0 : options.onError(_context.t0, serializedKey, options);
              if (!options.throwOnError) {
                _context.next = 24;
                break;
              }
              throw _context.t0;
            case 24:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[9, 17]]);
      }));
      return function (_x, _x2) {
        return _ref34.apply(this, arguments);
      };
    }(), []);
    var reset = T(function () {
      ditchMutationsUntilRef.current = getTimestamp();
      setState({
        data: UNDEFINED,
        error: UNDEFINED,
        isMutating: false
      });
    }, []);
    useIsomorphicLayoutEffect(function () {
      keyRef.current = key;
      fetcherRef.current = fetcher;
      configRef.current = config;
    });
    return {
      trigger: trigger,
      reset: reset,
      get data() {
        stateDependencies.data = true;
        return currentState.data;
      },
      get error() {
        stateDependencies.error = true;
        return currentState.error;
      },
      get isMutating() {
        stateDependencies.isMutating = true;
        return currentState.isMutating;
      }
    };
  };
};
var index = withMiddleware(useSWR, mutation);
var KeyToStytchEventMap = {
  'stytch.magicLinks.authenticate': StytchEventType.B2BMagicLinkAuthenticate,
  'stytch.sso.authenticate': StytchEventType.B2BSSOAuthenticate,
  'stytch.magicLinks.discovery.authenticate': StytchEventType.B2BMagicLinkDiscoveryAuthenticate,
  'stytch.discovery.organization.create': StytchEventType.B2BDiscoveryOrganizationsCreate,
  'stytch.discovery.intermediateSessions.exchange': StytchEventType.B2BDiscoveryIntermediateSessionExchange,
  'stytch.magicLinks.email.loginOrSignup': StytchEventType.B2BMagicLinkEmailLoginOrSignup,
  'stytch.magicLinks.discovery.send': StytchEventType.B2BMagicLinkEmailDiscoverySend,
  'stytch.oauth.authenticate': StytchEventType.B2BOAuthAuthenticate,
  'stytch.oauth.discovery.authenticate': StytchEventType.B2BOAuthDiscoveryAuthenticate,
  'stytch.otps.sms.send': StytchEventType.B2BSMSOTPSend,
  'stytch.otps.sms.authenticate': StytchEventType.B2BSMSOTPAuthenticate,
  'stytch.totp.create': StytchEventType.B2BTOTPCreate,
  'stytch.totp.authenticate': StytchEventType.B2BTOTPAuthenticate,
  'stytch.recoveryCodes.recover': StytchEventType.B2BRecoveryCodesRecover
};
var useMutate = function useMutate(key, fetcher, options) {
  var onEvent = useEventCallback();
  var _onError = useErrorCallback();
  return index(key, fetcher, Object.assign(Object.assign({
    throwOnError: false
  }, options), {
    onSuccess: function onSuccess(data, key, config) {
      if (KeyToStytchEventMap[key]) {
        onEvent({
          type: KeyToStytchEventMap[key],
          data: data
        });
      }
      (options === null || options === void 0 ? void 0 : options.onSuccess) && options.onSuccess(data, key, config);
    },
    onError: function onError(error, key, config) {
      _onError(error);
      (options === null || options === void 0 ? void 0 : options.onError) && options.onError(error, key, config);
    }
  }));
};
var useExtractSlug = function useExtractSlug() {
  var _useGlobalReducer3 = useGlobalReducer(),
    _useGlobalReducer4 = _slicedToArray(_useGlobalReducer3, 2),
    state = _useGlobalReducer4[0],
    dispatch = _useGlobalReducer4[1];
  var _h$ = h$1(),
    _h$2 = _slicedToArray(_h$, 2),
    pattern = _h$2[0],
    setPattern = _h$2[1];
  var stytchClient = useStytch();
  var slug = extractFromPattern(pattern || null);
  var _useMutate = useMutate('stytchClient.organization.getBySlug', function (_, _ref35) {
      var slug = _ref35.arg.slug;
      return stytchClient.organization.getBySlug({
        organization_slug: slug
      });
    }, {
      onSuccess: function onSuccess(_ref36) {
        var organization = _ref36.organization;
        if (organization === null) {
          dispatch({
            type: 'set_error_message_and_transition',
            errorType: ErrorType.Organization
          });
        } else {
          dispatch({
            type: 'set_organization',
            organization: Object.assign({}, organization)
          });
        }
      }
    }),
    trigger = _useMutate.trigger,
    isSearching = _useMutate.isMutating;
  p$1(function () {
    readB2BInternals(stytchClient).bootstrap.getAsync().then(function (_ref37) {
      var slugPattern = _ref37.slugPattern;
      setPattern(slugPattern);
    });
  }, [stytchClient]);
  p$1(function () {
    if (slug !== null && state.flowState.organization === null && state.screen === AppScreens$1.Main && state.flowState.type == AuthFlowType.Organization) {
      trigger({
        slug: slug
      });
    }
  }, [slug, state.flowState, state.screen]);
  return {
    isSearching: isSearching,
    slug: slug,
    pattern: pattern
  };
};
var useBootstrap = function useBootstrap() {
  var stytchClient = useStytch();
  var _h$3 = h$1(readB2BInternals(stytchClient).bootstrap.getSync()),
    _h$4 = _slicedToArray(_h$3, 2),
    boostrap = _h$4[0],
    setBootstrap = _h$4[1];
  p$1(function () {
    readB2BInternals(stytchClient).bootstrap.getAsync().then(function (data) {
      setBootstrap(data);
    });
  }, [stytchClient]);
  return boostrap;
};
var onAuthenticateSuccess = function onAuthenticateSuccess(data, dispatch, config) {
  dispatch({
    type: 'primary_authenticate_success',
    response: data,
    includedMfaMethods: config.mfaProductInclude
  });
};
var usePasswordInput = function usePasswordInput() {
  var _useGlobalReducer5 = useGlobalReducer(),
    _useGlobalReducer6 = _slicedToArray(_useGlobalReducer5, 2),
    state = _useGlobalReducer6[0],
    dispatch = _useGlobalReducer6[1];
  var config = useConfig();
  var stytch = useStytch();
  var onEvent = useEventCallback();
  var onError = useErrorCallback();
  var _h$5 = h$1(state.formState.passwordState.email),
    _h$6 = _slicedToArray(_h$5, 2),
    email = _h$6[0],
    setEmail = _h$6[1];
  var _h$7 = h$1(''),
    _h$8 = _slicedToArray(_h$7, 2),
    password = _h$8[0],
    setPassword = _h$8[1];
  var _h$9 = h$1(''),
    _h$10 = _slicedToArray(_h$9, 2),
    errorMessage = _h$10[0],
    setErrorMessage = _h$10[1];
  var _h$11 = h$1(false),
    _h$12 = _slicedToArray(_h$11, 2),
    isSubmitting = _h$12[0],
    setIsSubmitting = _h$12[1];
  var organization = state.flowState.organization;
  var submitPassword = function submitPassword(organization_id) {
    var _a, _b;
    setErrorMessage('');
    setIsSubmitting(true);
    stytch.passwords.authenticate({
      email_address: email,
      organization_id: organization_id,
      password: password,
      session_duration_minutes: (_b = (_a = config.sessionOptions) === null || _a === void 0 ? void 0 : _a.sessionDurationMinutes) !== null && _b !== void 0 ? _b : DEFAULT_SESSION_DURATION_MINUTES
    }).then(function (data) {
      setIsSubmitting(false);
      onEvent({
        type: StytchEventType.B2BPasswordAuthenticate,
        data: data
      });
      onAuthenticateSuccess(data, dispatch, config);
    })["catch"](function (err) {
      setIsSubmitting(false);
      onError(err);
      setErrorMessage('Invalid email or password. Please try again or use the link below to get help.');
    });
  };
  var emailEligibleForJITProvisioning = function emailEligibleForJITProvisioning(organization, email) {
    var emailDomain = email.split('@').pop();
    return organization.email_jit_provisioning == 'NOT_ALLOWED' || organization.email_jit_provisioning == 'RESTRICTED' && emailDomain && organization.email_allowed_domains.includes(emailDomain);
  };
  var handleNonMemberReset = function handleNonMemberReset() {
    var _a, _b, _c, _d;
    if (!organization) {
      return;
    }
    if (!emailEligibleForJITProvisioning(organization, email)) {
      setIsSubmitting(false);
      setErrorMessage(email + ' does not have access to ' + organization.organization_name + '. If you think this is a mistake, contact your admin.');
      return;
    }
    var dataLayer = readB2BInternals(stytch).dataLayer;
    dataLayer.setItem('reset-email-value', email);
    stytch.magicLinks.email.loginOrSignup({
      email_address: email,
      organization_id: organization.organization_id,
      login_redirect_url: (_a = config.passwordOptions) === null || _a === void 0 ? void 0 : _a.resetPasswordRedirectURL,
      signup_redirect_url: (_b = config.passwordOptions) === null || _b === void 0 ? void 0 : _b.resetPasswordRedirectURL,
      login_template_id: (_c = config.emailMagicLinksOptions) === null || _c === void 0 ? void 0 : _c.loginTemplateId,
      signup_template_id: (_d = config.emailMagicLinksOptions) === null || _d === void 0 ? void 0 : _d.signupTemplateId
    }).then(function () {
      setIsSubmitting(false);
      dispatch({
        type: 'set_password_state',
        email: email
      });
      dispatch({
        type: 'transition',
        screen: AppScreens$1.PasswordResetVerifyConfirmation
      });
    })["catch"](function (err) {
      onError(err);
      setErrorMessage('We were unable to verify your email. Please contact your admin.');
      setIsSubmitting(false);
    });
  };
  return {
    stytch: stytch,
    onError: onError,
    email: email,
    setEmail: setEmail,
    password: password,
    setPassword: setPassword,
    organization: organization,
    errorMessage: errorMessage,
    setErrorMessage: setErrorMessage,
    isSubmitting: isSubmitting,
    setIsSubmitting: setIsSubmitting,
    submitPassword: submitPassword,
    handleNonMemberReset: handleNonMemberReset
  };
};
var extractFromPattern = function extractFromPattern(pattern) {
  if (pattern === null) return null;
  var currentUrl = window.location.href.replace(window.location.search, '').trim();
  var regexPattern = pattern.replace('{{slug}}', '(.+)');
  var regex = new RegExp(regexPattern);
  var match = currentUrl.match(regex);
  if (match && match[1]) {
    return match[1];
  }
  return null;
};
var Button = He.button(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  all: unset;\n  width: 100%;\n  height: 45px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 18px;\n  text-transform: none;\n  font-family: ", ";\n  box-shadow: none;\n  text-align: center;\n\n  ", "\n\n  &:disabled {\n    background-color: ", ";\n    color: ", ";\n    border: ", ";\n    border-radius: ", ";\n    cursor: not-allowed;\n  }\n"])), function (props) {
  return props.theme.typography.fontFamily;
}, function (props) {
  switch (props.variant) {
    case 'primary':
      return "\n          border: ".concat(props.theme.buttons.primary.border, ";\n          border-radius: ").concat(props.theme.buttons.primary.borderRadius, ";\n          color: ").concat(props.theme.buttons.primary.textColor, ";\n          background-color: ").concat(props.theme.buttons.primary.backgroundColor, ";\n        ");
    case 'outlined':
      return "\n          border: ".concat(props.theme.buttons.secondary.border, ";\n          border-radius: ").concat(props.theme.buttons.secondary.borderRadius, ";\n          color: ").concat(props.theme.buttons.secondary.textColor, ";\n          background-color: ").concat(props.theme.buttons.secondary.backgroundColor, ";\n        ");
    case 'text':
      return "\n          color: ".concat(props.theme.colors.primary, ";\n          background-color: transparent;\n          font-weight: 600;\n        ");
  }
}, function (props) {
  return props.theme.buttons.disabled.backgroundColor;
}, function (props) {
  return props.theme.buttons.disabled.textColor;
}, function (props) {
  return props.theme.buttons.disabled.border;
}, function (props) {
  return props.theme.buttons.disabled.borderRadius;
});
Button.defaultProps = {
  variant: 'primary'
};
var circularRotateKeyframe = Ue(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
var circularDashKeyframe = Ue(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  0% {\n    stroke-dasharray: 1px, 200px;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 100px, 200px;\n    stroke-dashoffset: -15px;\n  }\n  100% {\n    stroke-dasharray: 100px, 200px;\n    stroke-dashoffset: -125px;\n  }\n"])));
var AnimatedCircle = He.circle(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  stroke-dasharray: 80px, 200px;\n  stroke-dashoffset: 0;\n  animation: ", " 1.4s ease-in-out infinite;\n  stroke: ", ";\n  fill: none;\n"])), circularDashKeyframe, function (props) {
  return props.theme.colors.primary;
});
var CircularProgressRoot = He.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  width: ", "px;\n  height: ", "px;\n  animation: ", " 1.4s ease-in-out infinite;\n"])), function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, circularRotateKeyframe);
var CircularProgressSVG = He.svg(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: block;\n"])));
var CircularProgress = function CircularProgress(_ref38) {
  var size = _ref38.size,
    thickness = _ref38.thickness;
  return /*#__PURE__*/wn.createElement(CircularProgressRoot, {
    size: size
  }, /*#__PURE__*/wn.createElement(CircularProgressSVG, {
    viewBox: "".concat(size / 2, " ").concat(size / 2, " ").concat(size, " ").concat(size)
  }, /*#__PURE__*/wn.createElement(AnimatedCircle, {
    cx: size,
    cy: size,
    r: (size - thickness) / 2,
    fill: "none",
    strokeWidth: thickness
  })));
};
var SubmitButton = function SubmitButton(props) {
  var buttonDisabled = props.isSubmitting || props.disabled;
  return /*#__PURE__*/wn.createElement(Button, {
    id: 'submit',
    type: "submit",
    disabled: buttonDisabled
  }, props.isSubmitting ? ( /*#__PURE__*/wn.createElement(Flex, {
    justifyContent: "center"
  }, /*#__PURE__*/wn.createElement(CircularProgress, {
    size: 18,
    thickness: 1,
    "data-testid": "loading-icon"
  }))) : props.text);
};
var Input = He.input(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  height: 47px;\n  padding: 0 8px;\n  box-sizing: border-box;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-size: 18px;\n  &::placeholder {\n    color: ", ";\n  }\n\n  &:disabled {\n    border: 1px solid ", ";\n    color: ", ";\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.theme.inputs.backgroundColor;
}, function (props) {
  return props.theme.inputs.borderColor;
}, function (props) {
  return props.theme.inputs.borderRadius;
}, function (props) {
  return props.theme.inputs.textColor;
}, function (props) {
  return props.theme.typography.fontFamily;
}, function (props) {
  return props.theme.inputs.placeholderColor;
}, function (props) {
  return props.theme.colors.disabledText;
}, function (props) {
  return props.theme.colors.disabledText;
}, function (props) {
  return props.theme.colors.disabled;
});
var EmailInput = function EmailInput(_ref39) {
  var email = _ref39.email,
    setEmail = _ref39.setEmail,
    _ref39$disableInput = _ref39.disableInput,
    disableInput = _ref39$disableInput === void 0 ? false : _ref39$disableInput,
    _ref39$hasPasskeys = _ref39.hasPasskeys,
    hasPasskeys = _ref39$hasPasskeys === void 0 ? false : _ref39$hasPasskeys;
  return /*#__PURE__*/wn.createElement(Input, Object.assign({
    placeholder: "example@email.com",
    name: "email",
    type: "email",
    autoComplete: hasPasskeys ? 'email webauthn' : 'email',
    disabled: disableInput,
    id: "email-input",
    value: email,
    onChange: function onChange(e) {
      return setEmail(e.target.value);
    },
    required: true
  }, hasPasskeys ? passwordManagerDisableAutofillProps : {}));
};
var DASHBOARD_REGEX = /https:\/\/stytch\.com\/[#a-zA-Z0-9/-]+/g;
var mapURLsToLinks = function mapURLsToLinks(str) {
  var nonLinkChunks = str.split(DASHBOARD_REGEX);
  var linkChunks = Array.from(str.matchAll(DASHBOARD_REGEX)).map(function (el) {
    return el[0];
  });
  var chunkResults = [];
  while (nonLinkChunks.length || linkChunks.length) {
    if (nonLinkChunks.length) {
      chunkResults.push(nonLinkChunks.shift());
    }
    if (linkChunks.length) {
      var chunk = linkChunks.shift();
      chunkResults.push( /*#__PURE__*/wn.createElement("a", {
        key: chunk + '__' + String(linkChunks.length),
        href: chunk,
        target: "_blank",
        rel: "noreferrer"
      }, chunk));
    }
  }
  return chunkResults;
};
var ErrorText = function ErrorText(_ref40) {
  var errorMessage = _ref40.errorMessage;
  var tokens = F(function () {
    return mapURLsToLinks(errorMessage);
  }, [errorMessage]);
  return /*#__PURE__*/wn.createElement(Text, {
    size: "helper",
    color: "error"
  }, tokens);
};
var JIT_PROVISIONING_ERRORS = ['email_jit_provisioning_not_allowed', 'invalid_email_for_jit_provisioning'];
var parseErrorMessage = function parseErrorMessage(error, _ref41) {
  var email = _ref41.email,
    org = _ref41.org;
  if (JIT_PROVISIONING_ERRORS.includes(error.error_type)) {
    return "".concat(email, " does not have access to ").concat(org, ". If you think this is a mistake, contact your admin");
  } else {
    return error.error_message;
  }
};
var MagicLinkEmailForm = function MagicLinkEmailForm() {
  var _useGlobalReducer7 = useGlobalReducer(),
    _useGlobalReducer8 = _slicedToArray(_useGlobalReducer7, 2),
    state = _useGlobalReducer8[0],
    dispatch = _useGlobalReducer8[1];
  var stytchClient = useStytch();
  var config = useConfig();
  var _h$13 = h$1(''),
    _h$14 = _slicedToArray(_h$13, 2),
    email = _h$14[0],
    setEmail = _h$14[1];
  var _useMutate2 = useMutate('stytch.magicLinks.email.loginOrSignup', function (_, _ref42) {
      var organization_id = _ref42.arg.organization_id;
      var _a, _b, _c, _d;
      return stytchClient.magicLinks.email.loginOrSignup({
        email_address: email,
        organization_id: organization_id,
        login_redirect_url: (_a = config.emailMagicLinksOptions) === null || _a === void 0 ? void 0 : _a.loginRedirectURL,
        signup_redirect_url: (_b = config.emailMagicLinksOptions) === null || _b === void 0 ? void 0 : _b.signupRedirectURL,
        login_template_id: (_c = config.emailMagicLinksOptions) === null || _c === void 0 ? void 0 : _c.loginTemplateId,
        signup_template_id: (_d = config.emailMagicLinksOptions) === null || _d === void 0 ? void 0 : _d.signupTemplateId
      });
    }, {
      onSuccess: function onSuccess() {
        dispatch({
          type: 'set_magic_link_email',
          email: email
        });
        dispatch({
          type: 'transition',
          screen: AppScreens$1.EmailConfirmation
        });
      }
    }),
    stytchLoginOrSignup = _useMutate2.trigger,
    error = _useMutate2.error,
    isMutating = _useMutate2.isMutating;
  var organization = state.flowState.organization;
  if (!organization) return /*#__PURE__*/wn.createElement(wn.Fragment, null);
  var handleSubmit = function handleSubmit(e) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            e.preventDefault();
            stytchLoginOrSignup({
              organization_id: organization.organization_id
            });
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  };
  return /*#__PURE__*/wn.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 8
  }, /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    minHeight: 52
  }, /*#__PURE__*/wn.createElement(EmailInput, {
    email: email,
    setEmail: setEmail
  }), error && ( /*#__PURE__*/wn.createElement(ErrorText, {
    errorMessage: parseErrorMessage(error, {
      email: email,
      org: organization.organization_name
    })
  }))), /*#__PURE__*/wn.createElement(SubmitButton, {
    isSubmitting: isMutating,
    text: 'Continue with email'
  })));
};
var MagicLinkEmailDiscoveryForm = function MagicLinkEmailDiscoveryForm() {
  var _useGlobalReducer9 = useGlobalReducer(),
    _useGlobalReducer10 = _slicedToArray(_useGlobalReducer9, 2),
    dispatch = _useGlobalReducer10[1];
  var stytchClient = useStytch();
  var config = useConfig();
  var _h$15 = h$1(''),
    _h$16 = _slicedToArray(_h$15, 2),
    email = _h$16[0],
    setEmail = _h$16[1];
  var _useMutate3 = useMutate('stytch.magicLinks.discovery.send', function () {
      var _a, _b;
      return stytchClient.magicLinks.email.discovery.send({
        email_address: email,
        discovery_redirect_url: (_a = config.emailMagicLinksOptions) === null || _a === void 0 ? void 0 : _a.discoveryRedirectURL,
        login_template_id: (_b = config.emailMagicLinksOptions) === null || _b === void 0 ? void 0 : _b.loginTemplateId
      });
    }, {
      onSuccess: function onSuccess() {
        dispatch({
          type: 'set_magic_link_email',
          email: email
        });
        dispatch({
          type: 'transition',
          screen: AppScreens$1.EmailConfirmation
        });
      }
    }),
    stytchDiscoverySend = _useMutate3.trigger,
    error = _useMutate3.error,
    isMutating = _useMutate3.isMutating;
  var handleSubmit = function handleSubmit(e) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            e.preventDefault();
            stytchDiscoverySend();
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
  };
  return /*#__PURE__*/wn.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 8
  }, /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    minHeight: 52
  }, /*#__PURE__*/wn.createElement(EmailInput, {
    email: email,
    setEmail: setEmail
  }), error && /*#__PURE__*/wn.createElement(ErrorText, {
    errorMessage: error.error_message
  })), /*#__PURE__*/wn.createElement(SubmitButton, {
    isSubmitting: isMutating,
    text: 'Continue with email'
  })));
};
var SSOButton = function SSOButton(_ref43) {
  var display_name = _ref43.display_name,
    connection_id = _ref43.connection_id;
  var stytchClient = useStytch();
  var config = useConfig();
  var onButtonClick = function onButtonClick() {
    var _a, _b;
    return stytchClient.sso.start({
      connection_id: connection_id,
      signup_redirect_url: (_a = config.ssoOptions) === null || _a === void 0 ? void 0 : _a.signupRedirectURL,
      login_redirect_url: (_b = config.ssoOptions) === null || _b === void 0 ? void 0 : _b.loginRedirectURL
    });
  };
  return /*#__PURE__*/y(Button, {
    id: "sso-".concat(display_name),
    type: "button",
    onClick: onButtonClick,
    variant: "outlined"
  }, /*#__PURE__*/y(Flex, {
    justifyContent: "center",
    alignItems: "center",
    gap: 4
  }, /*#__PURE__*/y("span", {
    style: {
      verticalAlign: 'middle'
    }
  }, "Continue with ".concat(display_name))));
};
var SSOButtons = function SSOButtons() {
  var _useGlobalReducer11 = useGlobalReducer(),
    _useGlobalReducer12 = _slicedToArray(_useGlobalReducer11, 1),
    state = _useGlobalReducer12[0];
  if (!state.flowState.organization) return /*#__PURE__*/y(g$1, null);
  return /*#__PURE__*/y(Flex, {
    direction: "column",
    gap: 8,
    className: "oauth-buttons"
  }, state.flowState.organization.sso_active_connections.map(function (provider) {
    return /*#__PURE__*/y(SSOButton, {
      key: "oauth-".concat(provider.display_name),
      display_name: provider.display_name,
      connection_id: provider.connection_id
    });
  }));
};
var DividerContainer = He(Flex)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (props) {
  return props.theme.colors.secondary;
});
var DividerBar = He.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  border-bottom: 1px solid ", ";\n  flex-grow: 1;\n"])), function (props) {
  return props.$placement === 'left' && 'margin-right: 6px;';
}, function (props) {
  return props.$placement === 'right' && 'margin-left: 6px;';
}, function (props) {
  return props.theme.colors.secondary;
});
var StyledText = He(Text)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (props) {
  return props.theme.colors.secondary;
});
var Divider = function Divider() {
  return /*#__PURE__*/wn.createElement(DividerContainer, {
    alignItems: "center"
  }, /*#__PURE__*/wn.createElement(DividerBar, {
    "$placement": "left"
  }), /*#__PURE__*/wn.createElement(StyledText, null, "or"), /*#__PURE__*/wn.createElement(DividerBar, {
    "$placement": "right"
  }));
};
var PasswordIconSvg = function PasswordIconSvg(_ref44) {
  var _ref44$enabled = _ref44.enabled,
    enabled = _ref44$enabled === void 0 ? false : _ref44$enabled;
  return /*#__PURE__*/wn.createElement("svg", {
    width: "20",
    height: "14",
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/wn.createElement("path", {
    d: "M9.99992 2.41667C13.1583 2.41667 15.9749 4.19167 17.3499 7C15.9749 9.80833 13.1583 11.5833 9.99992 11.5833C6.84158 11.5833 4.02492 9.80833 2.64992 7C4.02492 4.19167 6.84158 2.41667 9.99992 2.41667ZM9.99992 0.75C5.83325 0.75 2.27492 3.34167 0.833252 7C2.27492 10.6583 5.83325 13.25 9.99992 13.25C14.1666 13.25 17.7249 10.6583 19.1666 7C17.7249 3.34167 14.1666 0.75 9.99992 0.75ZM9.99992 4.91667C11.1499 4.91667 12.0833 5.85 12.0833 7C12.0833 8.15 11.1499 9.08333 9.99992 9.08333C8.84992 9.08333 7.91658 8.15 7.91658 7C7.91658 5.85 8.84992 4.91667 9.99992 4.91667ZM9.99992 3.25C7.93325 3.25 6.24992 4.93333 6.24992 7C6.24992 9.06667 7.93325 10.75 9.99992 10.75C12.0666 10.75 13.7499 9.06667 13.7499 7C13.7499 4.93333 12.0666 3.25 9.99992 3.25Z",
    fill: enabled ? '#19303D' : '#5C727D'
  }));
};
var PasswordIconVisibleSvg = function PasswordIconVisibleSvg() {
  return /*#__PURE__*/wn.createElement("svg", {
    width: "20",
    height: "16",
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/wn.createElement("path", {
    d: "M10.0002 2.97921C13.1585 2.97921 15.9752 4.75421 17.3502 7.56254C16.8585 8.57921 16.1668 9.45421 15.3418 10.1625L16.5168 11.3375C17.6752 10.3125 18.5918 9.02921 19.1668 7.56254C17.7252 3.90421 14.1668 1.31254 10.0002 1.31254C8.94183 1.31254 7.92516 1.47921 6.96683 1.78754L8.34183 3.16254C8.8835 3.05421 9.4335 2.97921 10.0002 2.97921ZM9.1085 3.92921L10.8335 5.65421C11.3085 5.86254 11.6918 6.24587 11.9002 6.72087L13.6252 8.44587C13.6918 8.16254 13.7418 7.86254 13.7418 7.55421C13.7502 5.48754 12.0668 3.81254 10.0002 3.81254C9.69183 3.81254 9.40016 3.85421 9.1085 3.92921ZM1.67516 1.20421L3.9085 3.43754C2.55016 4.50421 1.47516 5.92087 0.833496 7.56254C2.27516 11.2209 5.8335 13.8125 10.0002 13.8125C11.2668 13.8125 12.4835 13.5709 13.6002 13.1292L16.4502 15.9792L17.6252 14.8042L2.85016 0.020874L1.67516 1.20421ZM7.92516 7.45421L10.1002 9.62921C10.0668 9.63754 10.0335 9.64587 10.0002 9.64587C8.85016 9.64587 7.91683 8.71254 7.91683 7.56254C7.91683 7.52087 7.92516 7.49587 7.92516 7.45421ZM5.09183 4.62087L6.55016 6.07921C6.3585 6.53754 6.25016 7.03754 6.25016 7.56254C6.25016 9.62921 7.9335 11.3125 10.0002 11.3125C10.5252 11.3125 11.0252 11.2042 11.4752 11.0125L12.2918 11.8292C11.5585 12.0292 10.7918 12.1459 10.0002 12.1459C6.84183 12.1459 4.02516 10.3709 2.65016 7.56254C3.2335 6.37087 4.0835 5.38754 5.09183 4.62087Z",
    fill: "#19303D"
  }));
};
var BaseInput = He.input(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  border: 0;\n  padding: 0;\n  width: 100%;\n\n  background-color: transparent;\n  height: 45px;\n  color: ", ";\n  font-family: ", ";\n  font-size: 18px;\n\n  &::placeholder: {\n    color: ", ";\n  }\n\n  &:disabled {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  &:focus {\n    outline: none;\n  }\n"])), function (props) {
  return props.theme.inputs.textColor;
}, function (props) {
  return props.theme.typography.fontFamily;
}, function (props) {
  return props.theme.inputs.placeholderColor;
}, function (props) {
  return props.theme.colors.disabledText;
}, function (props) {
  return props.theme.colors.disabled;
});
var InputContainer = He(Flex)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  height: 45px;\n  padding-left: 8px;\n  padding-right: 8px;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-size: 18px;\n  width: calc(100% - 18px);\n  & input::placeholder: {\n    color: ", ";\n  }\n"])), function (props) {
  return props.theme.inputs.backgroundColor;
}, function (props) {
  return props.theme.inputs.borderColor;
}, function (props) {
  return props.theme.inputs.borderRadius;
}, function (props) {
  return props.theme.inputs.textColor;
}, function (props) {
  return props.theme.typography.fontFamily;
}, function (props) {
  return props.theme.inputs.placeholderColor;
});
var PasswordIconButton = He.button(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  all: unset;\n  cursor: pointer;\n"])));
var PasswordIcon = function PasswordIcon(_ref45) {
  var onClick = _ref45.onClick,
    enabled = _ref45.enabled,
    visible = _ref45.visible;
  return /*#__PURE__*/wn.createElement(PasswordIconButton, {
    onClick: onClick,
    type: "button"
  }, visible ? /*#__PURE__*/wn.createElement(PasswordIconVisibleSvg, null) : /*#__PURE__*/wn.createElement(PasswordIconSvg, {
    enabled: enabled
  }));
};
var PasswordInput = function PasswordInput(_ref46) {
  var password = _ref46.password,
    setPassword = _ref46.setPassword,
    type = _ref46.type;
  var _h$17 = h$1(false),
    _h$18 = _slicedToArray(_h$17, 2),
    visible = _h$18[0],
    setVisible = _h$18[1];
  return /*#__PURE__*/wn.createElement(InputContainer, {
    gap: 2,
    alignItems: "center"
  }, /*#__PURE__*/wn.createElement(BaseInput, {
    name: "password",
    "aria-label": "Password",
    id: "".concat(type, "-password"),
    autoComplete: "".concat(type, "-password"),
    type: visible ? 'text' : 'password',
    value: password,
    onChange: function onChange(e) {
      return setPassword(e.target.value);
    },
    required: true
  }), /*#__PURE__*/wn.createElement(PasswordIcon, {
    onClick: function onClick() {
      return setVisible(function (visible) {
        return !visible;
      });
    },
    enabled: !!password,
    visible: visible
  }));
};
var BackButton = He.button(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  all: unset;\n  cursor: pointer;\n"])));
var BackArrowSvg = function BackArrowSvg(_ref47) {
  var color = _ref47.color;
  return /*#__PURE__*/wn.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/wn.createElement("path", {
    d: "M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z",
    fill: color
  }));
};
var BackArrow = function BackArrow(_ref48) {
  var onClick = _ref48.onClick;
  var theme = Ze();
  return /*#__PURE__*/wn.createElement(BackButton, {
    type: "button",
    onClick: onClick,
    "aria-label": "Back"
  }, /*#__PURE__*/wn.createElement(BackArrowSvg, {
    color: theme.colors.primary
  }));
};
var GetHelpText = He(Text)(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  font-weight: bold !important;\n  cursor: pointer;\n"])));
var PasswordsAuthenticate = function PasswordsAuthenticate() {
  var _useGlobalReducer13 = useGlobalReducer(),
    _useGlobalReducer14 = _slicedToArray(_useGlobalReducer13, 2),
    dispatch = _useGlobalReducer14[1];
  var config = useConfig();
  var passwordOptions = config.passwordOptions;
  var _usePasswordInput = usePasswordInput(),
    email = _usePasswordInput.email,
    setEmail = _usePasswordInput.setEmail,
    password = _usePasswordInput.password,
    setPassword = _usePasswordInput.setPassword,
    organization = _usePasswordInput.organization,
    errorMessage = _usePasswordInput.errorMessage,
    setErrorMessage = _usePasswordInput.setErrorMessage,
    isSubmitting = _usePasswordInput.isSubmitting,
    submitPassword = _usePasswordInput.submitPassword;
  if (!passwordOptions) return /*#__PURE__*/wn.createElement(wn.Fragment, null);
  if (!organization) return /*#__PURE__*/wn.createElement(wn.Fragment, null);
  var handleSubmit = function handleSubmit(e) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            e.preventDefault();
            if (organization) {
              _context4.next = 3;
              break;
            }
            return _context4.abrupt("return");
          case 3:
            if (!email.match(EMAIL_REGEX)) {
              setErrorMessage('Invalid email address');
            } else {
              submitPassword(organization.organization_id);
            }
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
  };
  var onGetHelp = function onGetHelp() {
    dispatch({
      type: 'set_password_state',
      email: email
    });
    dispatch({
      type: 'transition',
      screen: AppScreens$1.PasswordForgotForm
    });
  };
  return /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 28
  }, /*#__PURE__*/wn.createElement(BackArrow, {
    onClick: function onClick() {
      return dispatch({
        type: 'transition',
        screen: AppScreens$1.Main
      });
    }
  }), /*#__PURE__*/wn.createElement(Text, {
    size: "header"
  }, "Log in with email and password"), /*#__PURE__*/wn.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 8
  }, /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 2
  }, /*#__PURE__*/wn.createElement(Text, {
    size: "helper",
    color: "secondary"
  }, "Email"), /*#__PURE__*/wn.createElement(EmailInput, {
    email: email,
    setEmail: setEmail
  })), /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 2
  }, /*#__PURE__*/wn.createElement(Text, {
    size: "helper",
    color: "secondary"
  }, "Password"), /*#__PURE__*/wn.createElement(PasswordInput, {
    password: password,
    setPassword: setPassword,
    type: "current"
  }), /*#__PURE__*/wn.createElement(ErrorText, {
    errorMessage: errorMessage
  })), /*#__PURE__*/wn.createElement(SubmitButton, {
    isSubmitting: isSubmitting,
    text: "Continue"
  }), /*#__PURE__*/wn.createElement(Flex, {
    onClick: onGetHelp,
    direction: "row"
  }, /*#__PURE__*/wn.createElement(Text, {
    color: "secondary"
  }, "Having trouble signing in?"), "\xA0", /*#__PURE__*/wn.createElement(GetHelpText, {
    color: "secondary"
  }, "Get help")))));
};
var PasswordsEmailForm = function PasswordsEmailForm() {
  var _useGlobalReducer15 = useGlobalReducer(),
    _useGlobalReducer16 = _slicedToArray(_useGlobalReducer15, 2),
    dispatch = _useGlobalReducer16[1];
  var config = useConfig();
  var passwordOptions = config.passwordOptions;
  var _usePasswordInput2 = usePasswordInput(),
    stytch = _usePasswordInput2.stytch,
    email = _usePasswordInput2.email,
    setEmail = _usePasswordInput2.setEmail,
    password = _usePasswordInput2.password,
    setPassword = _usePasswordInput2.setPassword,
    organization = _usePasswordInput2.organization,
    errorMessage = _usePasswordInput2.errorMessage,
    setErrorMessage = _usePasswordInput2.setErrorMessage,
    isSubmitting = _usePasswordInput2.isSubmitting,
    setIsSubmitting = _usePasswordInput2.setIsSubmitting,
    submitPassword = _usePasswordInput2.submitPassword,
    handleNonMemberReset = _usePasswordInput2.handleNonMemberReset;
  var _h$19 = h$1(!email),
    _h$20 = _slicedToArray(_h$19, 2),
    hideInput = _h$20[0],
    setHideInput = _h$20[1];
  if (!passwordOptions) return /*#__PURE__*/wn.createElement(wn.Fragment, null);
  if (!organization) return /*#__PURE__*/wn.createElement(wn.Fragment, null);
  var handleSubmit = function handleSubmit(e) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var organization_id;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            e.preventDefault();
            organization_id = organization.organization_id;
            if (hideInput) {
              _context5.next = 5;
              break;
            }
            submitPassword(organization_id);
            return _context5.abrupt("return");
          case 5:
            if (email.match(EMAIL_REGEX)) {
              _context5.next = 8;
              break;
            }
            setErrorMessage('Invalid email address');
            return _context5.abrupt("return");
          case 8:
            setErrorMessage('');
            setIsSubmitting(true);
            readB2BInternals(stytch).searchManager.searchMember(email, organization.organization_id).then(function (_ref49) {
              var member = _ref49.member;
              if (member === null || member === void 0 ? void 0 : member.member_password_id) {
                setHideInput(false);
                setIsSubmitting(false);
                dispatch({
                  type: 'set_password_state',
                  email: email
                });
                return;
              }
              handleNonMemberReset();
            })["catch"](function (err) {
              setIsSubmitting(false);
              var message = err.message;
              if (err instanceof StytchAPIError) {
                message = err.error_message;
              }
              setErrorMessage(message);
            });
          case 11:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
  };
  var onGetHelp = function onGetHelp() {
    dispatch({
      type: 'set_password_state',
      email: email
    });
    dispatch({
      type: 'transition',
      screen: AppScreens$1.PasswordForgotForm
    });
  };
  return /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 36
  }, /*#__PURE__*/wn.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 8
  }, /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 2
  }, /*#__PURE__*/wn.createElement(Text, {
    size: "helper",
    color: "secondary"
  }, "Email"), /*#__PURE__*/wn.createElement(EmailInput, {
    email: email,
    setEmail: setEmail
  })), !hideInput && ( /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 2
  }, /*#__PURE__*/wn.createElement(Text, {
    size: "helper",
    color: "secondary"
  }, "Password"), /*#__PURE__*/wn.createElement(PasswordInput, {
    password: password,
    setPassword: setPassword,
    type: "current"
  }))), /*#__PURE__*/wn.createElement(ErrorText, {
    errorMessage: errorMessage
  }), /*#__PURE__*/wn.createElement(SubmitButton, {
    isSubmitting: isSubmitting,
    text: "Continue"
  }), !hideInput && ( /*#__PURE__*/wn.createElement(Flex, {
    onClick: onGetHelp,
    direction: "row"
  }, /*#__PURE__*/wn.createElement(Text, {
    color: "secondary"
  }, "Having trouble signing in?"), "\xA0", /*#__PURE__*/wn.createElement(GetHelpText, {
    color: "secondary"
  }, "Get help"))))));
};
var OAuthB2BButton = function OAuthB2BButton(props) {
  var stytchClient = useStytch();
  var _useGlobalReducer17 = useGlobalReducer(),
    _useGlobalReducer18 = _slicedToArray(_useGlobalReducer17, 1),
    state = _useGlobalReducer18[0];
  var onButtonClick = function onButtonClick() {
    if (state.flowState.organization) {
      return stytchClient.oauth[props.providerType].start({
        login_redirect_url: props.loginRedirectUrl,
        signup_redirect_url: props.signupRedirectUrl,
        custom_scopes: props.customScopes,
        organization_id: state.flowState.organization.organization_id,
        provider_params: props.providerParams
      });
    }
    return stytchClient.oauth[props.providerType].discovery.start({
      discovery_redirect_url: props.discoveryRedirectUrl,
      custom_scopes: props.customScopes,
      provider_params: props.providerParams
    });
  };
  return /*#__PURE__*/wn.createElement(Button, {
    id: "oauth-".concat(props.providerType),
    type: "button",
    onClick: onButtonClick,
    variant: "outlined"
  }, /*#__PURE__*/wn.createElement(Flex, {
    justifyContent: "center",
    alignItems: "center",
    gap: 4
  }, props.icon, /*#__PURE__*/wn.createElement("span", {
    style: {
      verticalAlign: 'middle'
    }
  }, "Continue with ", props.providerTypeTitle)));
};
var CreateIcon = function CreateIcon(IconSvgComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    wrapped: true
  };
  var IconComponent = function IconComponent() {
    var component = /*#__PURE__*/wn.createElement(IconSvgComponent, null);
    return options.wrapped ? ( /*#__PURE__*/wn.createElement(Flex, {
      height: 24,
      width: 24
    }, component)) : component;
  };
  return IconComponent;
};
var GoogleIconSvg = function GoogleIconSvg() {
  return /*#__PURE__*/wn.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/wn.createElement("path", {
    fill: "#FFC107",
    d: "M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
  }), /*#__PURE__*/wn.createElement("path", {
    fill: "#FF3D00",
    d: "M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
  }), /*#__PURE__*/wn.createElement("path", {
    fill: "#4CAF50",
    d: "M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
  }), /*#__PURE__*/wn.createElement("path", {
    fill: "#1976D2",
    d: "M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
  }));
};
var GoogleIcon = CreateIcon(GoogleIconSvg);
var MicrosoftIconSvg = function MicrosoftIconSvg() {
  return /*#__PURE__*/wn.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/wn.createElement("path", {
    d: "M9.52382 0.952381H0.952393V9.52381H9.52382V0.952381Z",
    fill: "#F25022"
  }), /*#__PURE__*/wn.createElement("path", {
    d: "M9.52382 10.4762H0.952393V19.0476H9.52382V10.4762Z",
    fill: "#00A4EF"
  }), /*#__PURE__*/wn.createElement("path", {
    d: "M19.0475 0.952381H10.4761V9.52381H19.0475V0.952381Z",
    fill: "#7FBA00"
  }), /*#__PURE__*/wn.createElement("path", {
    d: "M19.0475 10.4762H10.4761V19.0476H19.0475V10.4762Z",
    fill: "#FFB900"
  }));
};
var MicrosoftIcon = CreateIcon(MicrosoftIconSvg);
var getParamsFromB2BOAuthProviderConfig = function getParamsFromB2BOAuthProviderConfig(provider) {
  var providerType = '';
  var oneTap = false;
  var customScopes = [];
  var providerParams = {};
  if (typeof provider === 'string') {
    providerType = provider;
  } else {
    providerType = provider.type;
    if (provider.type === B2BOAuthProviders.Google && 'one_tap' in provider) {
      oneTap = provider.one_tap;
    }
    customScopes = provider.customScopes || [];
    providerParams = provider.providerParams || {};
  }
  var oauthProvider = providerType;
  return {
    type: oauthProvider,
    oneTap: oneTap,
    customScopes: customScopes,
    providerParams: providerParams
  };
};
var useIsOnlyFloatingOneTap = function useIsOnlyFloatingOneTap() {
  var config = useConfig();
  var isOnlyFloatingOneTap = F(function () {
    var _a, _b;
    var oauthProvider = config.oauthOptions ? getParamsFromB2BOAuthProviderConfig((_a = config.oauthOptions) === null || _a === void 0 ? void 0 : _a.providers[0]) : undefined;
    var isGoogleOneTap = (oauthProvider === null || oauthProvider === void 0 ? void 0 : oauthProvider.type) === B2BOAuthProviders.Google && (oauthProvider === null || oauthProvider === void 0 ? void 0 : oauthProvider.oneTap) === true;
    return config.products.length === 1 && config.products.includes(B2BProducts.oauth) && ((_b = config.oauthOptions) === null || _b === void 0 ? void 0 : _b.providers.length) === 1 && isGoogleOneTap;
  }, [config]);
  return isOnlyFloatingOneTap;
};
var useIsUnmounted = function useIsUnmounted() {
  var isUnmounted = _(false);
  p$1(function () {
    return function () {
      isUnmounted.current = true;
    };
  }, []);
  return isUnmounted;
};
var OAuthErrorMessage = function OAuthErrorMessage(_ref50) {
  var children = _ref50.children;
  return /*#__PURE__*/wn.createElement("div", {
    key: "oauth-error-message"
  }, /*#__PURE__*/wn.createElement(Text, {
    color: "error"
  }, children));
};
var OneTapNoConfiguredClientsErrorMessage = function OneTapNoConfiguredClientsErrorMessage() {
  return /*#__PURE__*/wn.createElement(OAuthErrorMessage, null, "One Tap cannot render because no Google OAuth client configuration could be found for this project. Please make sure a client is configured in the\xA0", /*#__PURE__*/wn.createElement("a", {
    href: "https://stytch.com/dashboard/oauth"
  }, "dashboard."));
};
var RedirectUrlsErrorMessage = function RedirectUrlsErrorMessage(_ref51) {
  var niceName = _ref51.niceName,
    variableName = _ref51.variableName;
  return /*#__PURE__*/wn.createElement(OAuthErrorMessage, null, "One Tap cannot render because there are no ", niceName, " set for this project so we are unable to verify the", ' ', /*#__PURE__*/wn.createElement("code", null, variableName), "\xA0 provided in the configuration. To set ", niceName, " for this project please visit\xA0", /*#__PURE__*/wn.createElement("a", {
    href: "https://stytch.com/docs/javascript-sdk"
  }, "the Stytch dashboard."), "\xA0 For more information on why this validation is necessary please visit\xA0", /*#__PURE__*/wn.createElement("a", {
    href: "https://stytch.com/docs/api/url-validation"
  }, "https://stytch.com/docs/api/url-validation."));
};
var OneTapNoConfiguredLoginRedirectUrlsErrorMessage = function OneTapNoConfiguredLoginRedirectUrlsErrorMessage() {
  return /*#__PURE__*/wn.createElement(RedirectUrlsErrorMessage, {
    niceName: "login redirect URLs",
    variableName: "oauthOptions.loginRedirectURL"
  });
};
var OneTapNoConfiguredSignupRedirectUrlsErrorMessage = function OneTapNoConfiguredSignupRedirectUrlsErrorMessage() {
  return /*#__PURE__*/wn.createElement(RedirectUrlsErrorMessage, {
    niceName: "signup redirect URLs",
    variableName: "oauthOptions.signupRedirectURL"
  });
};
var OneTapJSOriginErrorMessage = function OneTapJSOriginErrorMessage() {
  return /*#__PURE__*/wn.createElement(OAuthErrorMessage, null, "One Tap cannot render because the current host\xA0", /*#__PURE__*/wn.createElement("code", null, "\"".concat(window.location.host, "\"")), " is not allowed for this project. Make sure to put your project's host into the Google API console. When using localhost for development, you must add both\xA0", /*#__PURE__*/wn.createElement("code", null, "http://localhost"), " and\xA0", /*#__PURE__*/wn.createElement("code", null, "http://localhost:<port_number>"), "\xA0 to the Authorized JavaScript origins box. You can learn more\xA0", /*#__PURE__*/wn.createElement("a", {
    href: "https://stytch.com/docs/javascript-sdk"
  }, "here."));
};
var OneTapInvalidOAuthClient = function OneTapInvalidOAuthClient() {
  return /*#__PURE__*/wn.createElement(OAuthErrorMessage, null, "One Tap cannot render because the client ID configured for your project is not recognized by Google. \xA0 Please check that the client ID saved in ", /*#__PURE__*/wn.createElement("a", {
    href: "https://stytch.com/dashboard/oauth/google"
  }, "the Stytch Dashboard"), "\xA0 matches the client ID in your Google Cloud Console.");
};
var OneTapNoDefaultProviderAllowedErrorMessage = function OneTapNoDefaultProviderAllowedErrorMessage() {
  return /*#__PURE__*/wn.createElement(OAuthErrorMessage, null, "One Tap cannot render because the Stytch Default OAuth Provider is not compatible with One Tap. Please configure your own Google client in the\xA0", /*#__PURE__*/wn.createElement("a", {
    href: "https://stytch.com/dashboard/oauth"
  }, "dashboard."));
};
var OneTapErrors;
(function (OneTapErrors) {
  OneTapErrors["None"] = "none";
  OneTapErrors["OriginNotAllowedForClient"] = "origin_not_allowed_for_client";
  OneTapErrors["InvalidOAuthClient"] = "invalid_client";
  OneTapErrors["NoConfiguredOAuthClient"] = "oauth_config_not_found";
  OneTapErrors["NoConfiguredLoginRedirectUrls"] = "no_login_redirect_urls_set";
  OneTapErrors["NoConfiguredSignupRedirectUrls"] = "no_signup_redirect_urls_set";
  OneTapErrors["DefaultProviderNotAllowed"] = "default_provider_not_allowed";
})(OneTapErrors || (OneTapErrors = {}));
var ErrorMessages = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, OneTapErrors.None, /*#__PURE__*/wn.createElement(wn.Fragment, null)), OneTapErrors.OriginNotAllowedForClient, /*#__PURE__*/wn.createElement(OneTapJSOriginErrorMessage, null)), OneTapErrors.InvalidOAuthClient, /*#__PURE__*/wn.createElement(OneTapInvalidOAuthClient, null)), OneTapErrors.NoConfiguredOAuthClient, /*#__PURE__*/wn.createElement(OneTapNoConfiguredClientsErrorMessage, null)), OneTapErrors.NoConfiguredLoginRedirectUrls, /*#__PURE__*/wn.createElement(OneTapNoConfiguredLoginRedirectUrlsErrorMessage, null)), OneTapErrors.NoConfiguredSignupRedirectUrls, /*#__PURE__*/wn.createElement(OneTapNoConfiguredSignupRedirectUrlsErrorMessage, null)), OneTapErrors.DefaultProviderNotAllowed, /*#__PURE__*/wn.createElement(OneTapNoDefaultProviderAllowedErrorMessage, null));
He.div(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  height: ", ";\n  display: ", ";\n  transition: all 0.5s ease-out;\n  justify-content: center;\n  align-items: center;\n"])), function (props) {
  return "".concat(props.$height, "px");
}, function (props) {
  return props.pending ? 'flex' : 'block';
});
var B2BGoogleOneTap = function B2BGoogleOneTap() {
  var _a, _b, _c, _d, _e, _f;
  var stytch = useStytch();
  var config = useConfig();
  var isOnlyFloatingOneTap = useIsOnlyFloatingOneTap();
  var _h$21 = h$1(OneTapErrors.None),
    _h$22 = _slicedToArray(_h$21, 2),
    oneTapError = _h$22[0],
    setOneTapError = _h$22[1];
  var isUnmounted = useIsUnmounted();
  var _useGlobalReducer19 = useGlobalReducer(),
    _useGlobalReducer20 = _slicedToArray(_useGlobalReducer19, 2),
    state = _useGlobalReducer20[0],
    dispatch = _useGlobalReducer20[1];
  var attemptToLoadOneTap = T(function () {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var _g, _h, _j, _readB2BInternals, oneTap, clientResult, client, oneTapCallback, renderResult;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _readB2BInternals = readB2BInternals(stytch), oneTap = _readB2BInternals.oneTap;
            _context6.next = 3;
            return oneTap.createOneTapClient();
          case 3:
            clientResult = _context6.sent;
            if (clientResult.success) {
              _context6.next = 7;
              break;
            }
            if (clientResult.reason === 'oauth_config_not_found') {
              setOneTapError(OneTapErrors.NoConfiguredOAuthClient);
            } else if (clientResult.reason === 'default_provider_not_allowed') {
              setOneTapError(OneTapErrors.DefaultProviderNotAllowed);
            } else {
              logger.error('Unable to load One Tap settings for project', clientResult);
            }
            return _context6.abrupt("return");
          case 7:
            client = clientResult.client;
            if (!isUnmounted.current) {
              _context6.next = 10;
              break;
            }
            return _context6.abrupt("return");
          case 10:
            if (state.flowState.organization) {
              oneTapCallback = oneTap.createOnSuccessHandler({
                organizationId: state.flowState.organization.organization_id,
                signupRedirectUrl: (_g = config.oauthOptions) === null || _g === void 0 ? void 0 : _g.signupRedirectURL,
                loginRedirectUrl: (_h = config.oauthOptions) === null || _h === void 0 ? void 0 : _h.loginRedirectURL,
                onSuccess: oneTap.RedirectOnSuccess,
                onError: function onError() {
                  return dispatch({
                    type: 'transition',
                    screen: AppScreens$1.Error
                  });
                }
              });
            } else {
              oneTapCallback = oneTap.createOnDiscoverySuccessHandler({
                discoveryRedirectUrl: (_j = config.oauthOptions) === null || _j === void 0 ? void 0 : _j.discoveryRedirectURL,
                onSuccess: oneTap.RedirectOnSuccess,
                onError: function onError() {
                  return dispatch({
                    type: 'transition',
                    screen: AppScreens$1.Error
                  });
                }
              });
            }
            _context6.next = 13;
            return client.render({
              callback: oneTapCallback,
              style: {
                position: OneTapPositions.floating
              }
            });
          case 13:
            renderResult = _context6.sent;
            if (!isUnmounted.current) {
              _context6.next = 17;
              break;
            }
            client.cancel();
            return _context6.abrupt("return");
          case 17:
            if (!renderResult.success) {
              if (renderResult.reason === 'unregistered_origin') {
                setOneTapError(OneTapErrors.OriginNotAllowedForClient);
              }
              if (renderResult.reason === 'invalid_client') {
                setOneTapError(OneTapErrors.InvalidOAuthClient);
              }
              logger.error('Unable to render One Tap prompt', renderResult);
            }
            return _context6.abrupt("return", client);
          case 19:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
  }, [stytch, isUnmounted, state.flowState.organization, (_a = config.oauthOptions) === null || _a === void 0 ? void 0 : _a.signupRedirectURL, (_b = config.oauthOptions) === null || _b === void 0 ? void 0 : _b.loginRedirectURL, (_c = config.oauthOptions) === null || _c === void 0 ? void 0 : _c.discoveryRedirectURL, dispatch]);
  p$1(function () {
    var client;
    attemptToLoadOneTap().then(function ($client) {
      return client = $client;
    })["catch"](function (err) {
      logger.error('Unable to render One Tap prompt', err);
    });
    return function () {
      return client === null || client === void 0 ? void 0 : client.cancel();
    };
  }, [attemptToLoadOneTap]);
  if (isOnlyFloatingOneTap) {
    return null;
  }
  var googleAuthButton = /*#__PURE__*/wn.createElement(OAuthB2BButton, {
    key: "oauth-".concat(B2BOAuthProviders.Google),
    providerType: B2BOAuthProviders.Google,
    icon: /*#__PURE__*/wn.createElement(GoogleIcon, null),
    providerTypeTitle: "Google",
    loginRedirectUrl: (_d = config.oauthOptions) === null || _d === void 0 ? void 0 : _d.loginRedirectURL,
    signupRedirectUrl: (_e = config.oauthOptions) === null || _e === void 0 ? void 0 : _e.signupRedirectURL,
    discoveryRedirectUrl: (_f = config.oauthOptions) === null || _f === void 0 ? void 0 : _f.discoveryRedirectURL
  });
  var _readB2BInternals2 = readB2BInternals(stytch),
    publicToken = _readB2BInternals2.publicToken;
  if (oneTapError !== OneTapErrors.None) {
    return /*#__PURE__*/wn.createElement(wn.Fragment, null, isTestPublicToken(publicToken) ? ErrorMessages[oneTapError] : null, googleAuthButton);
  }
  return googleAuthButton;
};
var getProviderInfo = function getProviderInfo(provider) {
  switch (provider) {
    case B2BOAuthProviders.Google:
      return {
        providerTypeTitle: 'Google',
        allowedAuthMethod: 'google_oauth',
        icon: /*#__PURE__*/y(GoogleIcon, null)
      };
    case B2BOAuthProviders.Microsoft:
      return {
        providerTypeTitle: 'Microsoft',
        allowedAuthMethod: 'microsoft_oauth',
        icon: /*#__PURE__*/y(MicrosoftIcon, null)
      };
    default:
      return {
        providerTypeTitle: '',
        allowedAuthMethod: '',
        icon: /*#__PURE__*/y(g$1, null)
      };
  }
};
var getCustomScopesForProvider = function getCustomScopesForProvider(oauthProvider, oauthOptionsCustomScopes) {
  var currentCustomScopes = oauthProvider.customScopes;
  if (Object.keys(currentCustomScopes).length == 0) {
    currentCustomScopes = oauthOptionsCustomScopes;
  }
  return currentCustomScopes;
};
var getProviderParamsForProvider = function getProviderParamsForProvider(oauthProvider, oauthOptionsProviderParams) {
  var currentProviderParams = oauthProvider.providerParams;
  if (Object.keys(currentProviderParams).length == 0) {
    currentProviderParams = oauthOptionsProviderParams;
  }
  return currentProviderParams;
};
var OAuthButtons = function OAuthButtons() {
  var _a, _b;
  var config = useConfig();
  var _useGlobalReducer21 = useGlobalReducer(),
    _useGlobalReducer22 = _slicedToArray(_useGlobalReducer21, 1),
    state = _useGlobalReducer22[0];
  if (!config.oauthOptions) return /*#__PURE__*/y(g$1, null);
  var _config$oauthOptions = config.oauthOptions,
    providers = _config$oauthOptions.providers,
    loginRedirectURL = _config$oauthOptions.loginRedirectURL,
    signupRedirectURL = _config$oauthOptions.signupRedirectURL,
    discoveryRedirectURL = _config$oauthOptions.discoveryRedirectURL,
    customScopes = _config$oauthOptions.customScopes,
    providerParams = _config$oauthOptions.providerParams;
  var allowedAuthMethods = [];
  if (state.flowState.organization && state.flowState.organization.auth_methods === 'RESTRICTED') {
    allowedAuthMethods = (_b = (_a = state.flowState.organization) === null || _a === void 0 ? void 0 : _a.allowed_auth_methods) !== null && _b !== void 0 ? _b : [];
  }
  var mappedProviders = providers.map(function (provider) {
    var oauthProvider = getParamsFromB2BOAuthProviderConfig(provider);
    var _getProviderInfo = getProviderInfo(oauthProvider.type),
      icon = _getProviderInfo.icon,
      providerTypeTitle = _getProviderInfo.providerTypeTitle,
      allowedAuthMethod = _getProviderInfo.allowedAuthMethod;
    if (!state.flowState.organization || state.flowState.organization.auth_methods === 'ALL_ALLOWED' || allowedAuthMethods.includes(allowedAuthMethod)) {
      if (oauthProvider.oneTap) {
        return /*#__PURE__*/y(B2BGoogleOneTap, {
          key: "oauth-".concat(oauthProvider.type)
        });
      }
      return /*#__PURE__*/y(OAuthB2BButton, {
        key: "oauth-".concat(oauthProvider.type),
        providerType: oauthProvider.type,
        icon: icon,
        providerTypeTitle: providerTypeTitle,
        loginRedirectUrl: loginRedirectURL,
        signupRedirectUrl: signupRedirectURL,
        discoveryRedirectUrl: discoveryRedirectURL,
        customScopes: getCustomScopesForProvider(oauthProvider, customScopes),
        providerParams: getProviderParamsForProvider(oauthProvider, providerParams)
      });
    }
    console.error("Provider ".concat(provider, " is not an `allowed_auth_method` for this organization. Please update your organization settings."));
    return null;
  });
  return /*#__PURE__*/y(Flex, {
    direction: "column",
    gap: 8,
    className: "oauth-buttons"
  }, mappedProviders);
};
var UsePasswordText = He(Text)(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  font-weight: bold !important;\n  cursor: pointer;\n"])));
var PasswordUseButton = function PasswordUseButton() {
  var _useGlobalReducer23 = useGlobalReducer(),
    _useGlobalReducer24 = _slicedToArray(_useGlobalReducer23, 2),
    dispatch = _useGlobalReducer24[1];
  var handleUsePassword = function handleUsePassword() {
    dispatch({
      type: 'transition',
      screen: AppScreens$1.PasswordAuthenticate
    });
  };
  return /*#__PURE__*/wn.createElement(Flex, {
    justifyContent: "center"
  }, /*#__PURE__*/wn.createElement(UsePasswordText, {
    onClick: handleUsePassword
  }, "Use a password instead"));
};
var Component;
(function (Component) {
  Component["MagicLinkEmailForm"] = "MagicLinkEmailForm";
  Component["MagicLinkEmailDiscoveryForm"] = "MagicLinkEmailDiscoveryForm";
  Component["OAuthButtons"] = "OAuthButtons";
  Component["SSOButtons"] = "SSOButtons";
  Component["PasswordsEmailForm"] = "PasswordsEmailForm";
  Component["PasswordEMLCombined"] = "PasswordEMLCombined";
  Component["Divider"] = "Divider";
})(Component || (Component = {}));
var generateProductComponentsOrdering = function generateProductComponentsOrdering(products, flowState) {
  var flowStateType = flowState.type;
  var displayEmlAndPasswordsTogether = products.includes(B2BProducts.emailMagicLinks) && products.includes(B2BProducts.passwords);
  var ProductComponents = products.map(function (product) {
    var _a, _b, _c;
    switch (product) {
      case B2BProducts.emailMagicLinks:
        if (displayEmlAndPasswordsTogether) return null;
        return flowStateType === AuthFlowType.Organization ? Component.MagicLinkEmailForm : Component.MagicLinkEmailDiscoveryForm;
      case B2BProducts.oauth:
        return Component.OAuthButtons;
      case B2BProducts.sso:
        var isSsoValid = ((_c = (_b = (_a = flowState.organization) === null || _a === void 0 ? void 0 : _a.sso_active_connections) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0;
        return flowStateType === AuthFlowType.Organization && isSsoValid ? Component.SSOButtons : null;
      case B2BProducts.passwords:
        if (displayEmlAndPasswordsTogether) return null;
        return Component.PasswordsEmailForm;
    }
  }).filter(function (component) {
    return component !== null;
  });
  if (displayEmlAndPasswordsTogether) {
    var passwordIndex = products.indexOf(B2BProducts.passwords);
    var emlIndex = products.indexOf(B2BProducts.emailMagicLinks);
    var firstProductIndex = Math.min(passwordIndex, emlIndex);
    var combinedComponent = flowStateType === AuthFlowType.Organization ? Component.PasswordEMLCombined : Component.MagicLinkEmailDiscoveryForm;
    ProductComponents.splice(firstProductIndex, 0, combinedComponent);
  }
  var hasButtons = ProductComponents.includes(Component.OAuthButtons) || ProductComponents.includes(Component.SSOButtons);
  var hasInput = products.includes(B2BProducts.emailMagicLinks) || products.includes(B2BProducts.passwords);
  var showDivider = hasButtons && hasInput;
  if (ProductComponents.length > 1 && showDivider) {
    ProductComponents.splice(ProductComponents.length - 1, 0, Component.Divider);
  }
  return ProductComponents;
};
var Container$1 = He(Flex)(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  > * + * {\n    margin-top: 24px;\n  }\n"])));
var LogoImage$1 = He.img(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  max-height: 50px;\n  max-width: 100px;\n"])));
var Header = He(Text)(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  text-align: center;\n"])));
var Logo$1 = function Logo$1(_ref52) {
  var orgLogo = _ref52.orgLogo,
    appLogo = _ref52.appLogo;
  if (orgLogo !== '' && appLogo !== '') return /*#__PURE__*/wn.createElement(wn.Fragment, null);
  return /*#__PURE__*/wn.createElement(Flex, {
    justifyContent: "center",
    gap: 4
  }, /*#__PURE__*/wn.createElement(LogoImage$1, {
    src: orgLogo
  }), /*#__PURE__*/wn.createElement(LogoImage$1, {
    src: appLogo
  }));
};
var ProductComponents = function ProductComponents(_ref53) {
  var components = _ref53.components;
  var renderedComponents = components.map(function (component) {
    switch (component) {
      case Component.MagicLinkEmailForm:
        return /*#__PURE__*/wn.createElement(MagicLinkEmailForm, {
          key: component
        });
      case Component.MagicLinkEmailDiscoveryForm:
        return /*#__PURE__*/wn.createElement(MagicLinkEmailDiscoveryForm, {
          key: component
        });
      case Component.OAuthButtons:
        return /*#__PURE__*/wn.createElement(OAuthButtons, {
          key: component
        });
      case Component.SSOButtons:
        return /*#__PURE__*/wn.createElement(SSOButtons, {
          key: component
        });
      case Component.PasswordsEmailForm:
        return /*#__PURE__*/wn.createElement(PasswordsEmailForm, {
          key: component
        });
      case Component.PasswordEMLCombined:
        return /*#__PURE__*/wn.createElement(Flex, {
          key: "eml_password",
          direction: "column",
          gap: 12
        }, /*#__PURE__*/wn.createElement(MagicLinkEmailForm, {
          key: "magic_link"
        }), /*#__PURE__*/wn.createElement(PasswordUseButton, {
          key: "password"
        }));
      case Component.Divider:
        return /*#__PURE__*/wn.createElement(Divider, {
          key: "divider"
        });
    }
  });
  return /*#__PURE__*/wn.createElement(wn.Fragment, null, renderedComponents);
};
var MainScreen = function MainScreen() {
  var _a, _b, _c, _d, _e, _f, _g;
  var _Ze = Ze(),
    displayHeader = _Ze.displayHeader,
    logo = _Ze.logo;
  var config = useConfig();
  var _useGlobalReducer25 = useGlobalReducer(),
    _useGlobalReducer26 = _slicedToArray(_useGlobalReducer25, 1),
    state = _useGlobalReducer26[0];
  var allowedProducts = [];
  var products = config.products;
  if (((_a = state.flowState.organization) === null || _a === void 0 ? void 0 : _a.auth_methods) === 'RESTRICTED') {
    var allowedAuthMethods = (_c = (_b = state.flowState.organization) === null || _b === void 0 ? void 0 : _b.allowed_auth_methods) !== null && _c !== void 0 ? _c : [];
    allowedAuthMethods.forEach(function (authMethod) {
      if (authMethod === 'sso') allowedProducts.push(B2BProducts.sso);
      if (authMethod === 'magic_link') allowedProducts.push(B2BProducts.emailMagicLinks);
      if (authMethod === 'password') allowedProducts.push(B2BProducts.passwords);
      if (authMethod === 'google_oauth' || authMethod === 'microsoft_oauth') allowedProducts.push(B2BProducts.oauth);
    });
    products = products.filter(function (product) {
      return allowedProducts.includes(product);
    });
  }
  var ProductComponentsOrdering = generateProductComponentsOrdering(products, state.flowState);
  var title;
  switch (state.flowState.type) {
    case AuthFlowType.Discovery:
      title = 'Sign up or log in';
      break;
    case AuthFlowType.PasswordReset:
      title = '';
      break;
    default:
      title = "Continue to ".concat((_e = (_d = state.flowState.organization) === null || _d === void 0 ? void 0 : _d.organization_name) !== null && _e !== void 0 ? _e : '...');
      break;
  }
  return /*#__PURE__*/wn.createElement(Container$1, {
    direction: "column"
  }, /*#__PURE__*/wn.createElement(Logo$1, {
    appLogo: logo.logoImageUrl,
    orgLogo: (_g = (_f = state.flowState.organization) === null || _f === void 0 ? void 0 : _f.organization_logo_url) !== null && _g !== void 0 ? _g : ''
  }), displayHeader && title ? ( /*#__PURE__*/wn.createElement(Flex, {
    justifyContent: "center"
  }, /*#__PURE__*/wn.createElement(Header, {
    size: "header"
  }, title))) : ( /*#__PURE__*/wn.createElement(wn.Fragment, null)), /*#__PURE__*/wn.createElement(ProductComponents, {
    components: ProductComponentsOrdering
  }));
};
var GmailIconSvg = function GmailIconSvg() {
  return /*#__PURE__*/wn.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/wn.createElement("path", {
    fill: "#4caf50",
    d: "M45,16.2l-5,2.75l-5,4.75L35,40h7c1.657,0,3-1.343,3-3V16.2z"
  }), /*#__PURE__*/wn.createElement("path", {
    fill: "#1e88e5",
    d: "M3,16.2l3.614,1.71L13,23.7V40H6c-1.657,0-3-1.343-3-3V16.2z"
  }), /*#__PURE__*/wn.createElement("polygon", {
    fill: "#e53935",
    points: "35,11.2 24,19.45 13,11.2 12,17 13,23.7 24,31.95 35,23.7 36,17"
  }), /*#__PURE__*/wn.createElement("path", {
    fill: "#c62828",
    d: "M3,12.298V16.2l10,7.5V11.2L9.876,8.859C9.132,8.301,8.228,8,7.298,8h0C4.924,8,3,9.924,3,12.298z"
  }), /*#__PURE__*/wn.createElement("path", {
    fill: "#fbc02d",
    d: "M45,12.298V16.2l-10,7.5V11.2l3.124-2.341C38.868,8.301,39.772,8,40.702,8h0 C43.076,8,45,9.924,45,12.298z"
  }));
};
var GmailIcon = CreateIcon(GmailIconSvg);
var OutlookIconSvg = function OutlookIconSvg() {
  return /*#__PURE__*/wn.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    id: "Layer_1",
    viewBox: "0 0 103.17322 104.31332",
    xmlSpace: "preserve"
  }, /*#__PURE__*/wn.createElement("defs", {
    id: "defs43"
  }), /*#__PURE__*/wn.createElement("path", {
    d: "m 64.566509,22.116383 v 20.404273 l 7.130526,4.489881 c 0.188058,0.05485 0.595516,0.05877 0.783574,0 L 103.16929,26.320259 c 0,-2.44867 -2.28412,-4.203876 -3.573094,-4.203876 H 64.566509 z",
    id: "path3",
    style: {
      fill: '#0072c6'
    }
  }), /*#__PURE__*/wn.createElement("path", {
    d: "m 64.566509,50.13308 6.507584,4.470291 c 0.916782,0.673874 2.021622,0 2.021622,0 -1.100922,0.673874 30.077495,-20.035993 30.077495,-20.035993 v 37.501863 c 0,4.082422 -2.61322,5.794531 -5.551621,5.794531 H 64.562591 V 50.13308 z",
    id: "path5",
    style: {
      fill: '#0072c6'
    }
  }), /*#__PURE__*/wn.createElement("g", {
    id: "g23",
    transform: "matrix(3.9178712,0,0,3.9178712,-13.481403,-41.384473)"
  }, /*#__PURE__*/wn.createElement("path", {
    d: "m 11.321,20.958 c -0.566,0 -1.017,0.266 -1.35,0.797 -0.333,0.531 -0.5,1.234 -0.5,2.109 0,0.888 0.167,1.59 0.5,2.106 0.333,0.517 0.77,0.774 1.31,0.774 0.557,0 0.999,-0.251 1.325,-0.753 0.326,-0.502 0.49,-1.199 0.49,-2.09 0,-0.929 -0.158,-1.652 -0.475,-2.169 -0.317,-0.516 -0.75,-0.774 -1.3,-0.774 z",
    id: "path25",
    style: {
      fill: '#0072c6'
    }
  }), /*#__PURE__*/wn.createElement("path", {
    d: "m 3.441,13.563 v 20.375 l 15.5,3.25 V 10.563 l -15.5,3 z m 10.372,13.632 c -0.655,0.862 -1.509,1.294 -2.563,1.294 -1.027,0 -1.863,-0.418 -2.51,-1.253 C 8.094,26.4 7.77,25.312 7.77,23.97 c 0,-1.417 0.328,-2.563 0.985,-3.438 0.657,-0.875 1.527,-1.313 2.61,-1.313 1.023,0 1.851,0.418 2.482,1.256 0.632,0.838 0.948,1.942 0.948,3.313 10e-4,1.409 -0.327,2.545 -0.982,3.407 z",
    id: "path27",
    style: {
      fill: '#0072c6'
    }
  })));
};
var OutlookIcon = CreateIcon(OutlookIconSvg);
var YahooIconSvg = function YahooIconSvg() {
  return /*#__PURE__*/wn.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/wn.createElement("rect", {
    x: "2",
    y: "2",
    width: "20",
    height: "20",
    rx: "1",
    fill: "#671BDF"
  }), /*#__PURE__*/wn.createElement("path", {
    d: "M5 8.7284H7.71407L9.29444 12.7716L10.8953 8.7284H13.5379L9.55876 18.3H6.89942L7.98865 15.7637L5 8.7284Z",
    fill: "white"
  }), /*#__PURE__*/wn.createElement("path", {
    d: "M14.2 16.2028C15.108 16.2028 15.8441 15.4667 15.8441 14.5587C15.8441 13.6507 15.108 12.9146 14.2 12.9146C13.292 12.9146 12.5559 13.6507 12.5559 14.5587C12.5559 15.4667 13.292 16.2028 14.2 16.2028Z",
    fill: "white"
  }), /*#__PURE__*/wn.createElement("path", {
    d: "M16.3842 12.3106H13.4243L16.0512 6H19L16.3842 12.3106Z",
    fill: "white"
  }));
};
var YahooIcon = CreateIcon(YahooIconSvg);
var inboxLinks$1 = function inboxLinks$1(emailDomain) {
  if (!emailDomain) {
    return {
      GMAIL: 'https://mail.google.com/mail/u/0/#search/in%3Aanywhere',
      OUTLOOK: 'https://outlook.office.com/mail/0/inbox',
      YAHOO: 'https://mail.yahoo.com/d/search/referrer=unread'
    };
  }
  var gmailQuery = encodeURIComponent("from:@".concat(emailDomain, " in:anywhere"));
  return {
    GMAIL: "https://mail.google.com/mail/u/0/#search/".concat(gmailQuery),
    OUTLOOK: 'https://outlook.office.com/mail/0/inbox',
    YAHOO: "https://mail.yahoo.com/d/search/keyword=".concat(emailDomain)
  };
};
var Link$1 = He.a(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  all: unset;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n    text-decoration-color: ", ";\n  }\n"])), function (props) {
  return props.theme.colors.primary;
});
var EmailProviderLink$1 = function EmailProviderLink$1(_ref54) {
  var label = _ref54.label,
    href = _ref54.href,
    Icon = _ref54.Icon;
  return /*#__PURE__*/wn.createElement(Flex, {
    gap: 4
  }, Icon, /*#__PURE__*/wn.createElement(Link$1, {
    href: href,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/wn.createElement(Text, null, "Open in ", label)));
};
var EmailConfirmation$1 = function EmailConfirmation$1(_ref55) {
  var emailDomain = _ref55.emailDomain,
    reset = _ref55.reset,
    email = _ref55.email;
  var _inboxLinks$ = inboxLinks$1(emailDomain),
    GMAIL = _inboxLinks$.GMAIL,
    YAHOO = _inboxLinks$.YAHOO,
    OUTLOOK = _inboxLinks$.OUTLOOK;
  return /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 24
  }, /*#__PURE__*/wn.createElement(Text, {
    size: "header"
  }, "Check your email"), /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 12
  }, /*#__PURE__*/wn.createElement(Text, null, "An email was sent to ", /*#__PURE__*/wn.createElement("b", null, email), "."), /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 8
  }, /*#__PURE__*/wn.createElement(EmailProviderLink$1, {
    href: GMAIL,
    label: 'Gmail',
    Icon: /*#__PURE__*/wn.createElement(GmailIcon, null)
  }), /*#__PURE__*/wn.createElement(EmailProviderLink$1, {
    href: YAHOO,
    label: 'Yahoo',
    Icon: /*#__PURE__*/wn.createElement(YahooIcon, null)
  }), /*#__PURE__*/wn.createElement(EmailProviderLink$1, {
    href: OUTLOOK,
    label: 'Outlook',
    Icon: /*#__PURE__*/wn.createElement(OutlookIcon, null)
  }))), /*#__PURE__*/wn.createElement(Button, {
    type: "button",
    onClick: reset
  }, "Try again"));
};
var useEmailDomain$1 = function useEmailDomain$1() {
  var _a, _b;
  var stytch = useStytch();
  var config = useConfig();
  var _h$23 = h$1(function () {
      var _readB2BInternals$boo = readB2BInternals(stytch).bootstrap.getSync(),
        emailDomains = _readB2BInternals$boo.emailDomains;
      return emailDomains;
    }),
    _h$24 = _slicedToArray(_h$23, 2),
    emailDomains = _h$24[0],
    setEmailDomains = _h$24[1];
  p$1(function () {
    readB2BInternals(stytch).bootstrap.getAsync().then(function (_ref56) {
      var emailDomains = _ref56.emailDomains;
      setEmailDomains(emailDomains);
    });
  }, [stytch]);
  if ((_a = config.emailMagicLinksOptions) === null || _a === void 0 ? void 0 : _a.domainHint) {
    return (_b = config.emailMagicLinksOptions) === null || _b === void 0 ? void 0 : _b.domainHint;
  }
  if (emailDomains.length === 1) {
    return emailDomains[0];
  }
  return null;
};
var EmailConfirmation = function EmailConfirmation() {
  var _useGlobalReducer27 = useGlobalReducer(),
    _useGlobalReducer28 = _slicedToArray(_useGlobalReducer27, 2),
    state = _useGlobalReducer28[0],
    dispatch = _useGlobalReducer28[1];
  var emailDomain = useEmailDomain$1();
  var reset = function reset() {
    dispatch({
      type: 'set_magic_link_email',
      email: ''
    });
    dispatch({
      type: 'transition',
      screen: AppScreens$1.Main
    });
  };
  return /*#__PURE__*/wn.createElement(EmailConfirmation$1, {
    emailDomain: emailDomain,
    reset: reset,
    email: state.formState.magicLinkState.email
  });
};
var LoggingInScreen = function LoggingInScreen() {
  return /*#__PURE__*/y(Flex, {
    direction: "column",
    gap: 36,
    alignItems: "center"
  }, /*#__PURE__*/y(Text, {
    size: "header"
  }, "Logging in..."), /*#__PURE__*/y(CircularProgress, {
    size: 100,
    thickness: 8
  }));
};
var LoadingScreen = function LoadingScreen() {
  return /*#__PURE__*/y(Flex, {
    direction: "column",
    gap: 36,
    alignItems: "center"
  }, /*#__PURE__*/y(CircularProgress, {
    size: 100,
    thickness: 8
  }));
};
var OrganizationsContainer = He(Flex)(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  border: ", ";\n  border-radius: ", ";\n  > div + div {\n    border-top: ", ";\n  }\n"])), function (_ref57) {
  var theme = _ref57.theme;
  return theme.container.border;
}, function (_ref58) {
  var theme = _ref58.theme;
  return theme.container.borderRadius;
}, function (_ref59) {
  var theme = _ref59.theme;
  return theme.container.border;
});
var OrganizationsRow = He(Flex)(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  cursor: pointer;\n"])));
var LogoImage = He.img(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  height: 40px;\n  width: 40px;\n  border-radius: 4px;\n"])));
var LogoText = He(Flex)(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  height: 40px;\n  width: 40px;\n  background-color: ", ";\n  color: ", ";\n  border-radius: 4px;\n\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 25px;\n"])), function (_ref60) {
  var theme = _ref60.theme;
  return theme.buttons.primary.backgroundColor;
}, function (_ref61) {
  var theme = _ref61.theme;
  return theme.buttons.primary.textColor;
});
var RightArrowSVG = function RightArrowSVG() {
  return /*#__PURE__*/y("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/y("path", {
    d: "M7 0.333313L5.825 1.50831L10.475 6.16665H0.333334V7.83331H10.475L5.825 12.4916L7 13.6666L13.6667 6.99998L7 0.333313Z",
    fill: "#19303D"
  }));
};
var Logo = function Logo(_ref62) {
  var name = _ref62.name,
    logo = _ref62.logo;
  if (logo !== '') {
    return /*#__PURE__*/y(LogoImage, {
      src: logo
    });
  }
  return /*#__PURE__*/y(LogoText, {
    alignItems: "center",
    justifyContent: "center"
  }, name[0]);
};
var ArrowText = function ArrowText(_ref63) {
  var type = _ref63.type;
  if (type === 'eligible_to_join_by_email_domain' || type === 'pending_member') return /*#__PURE__*/y(Text, null, "Join");
  if (type === 'invited_member') return /*#__PURE__*/y(Text, null, "Accept Invite");
  return /*#__PURE__*/y(g$1, null);
};
var DiscoverNoOrganizations = function DiscoverNoOrganizations() {
  var _useGlobalReducer29 = useGlobalReducer(),
    _useGlobalReducer30 = _slicedToArray(_useGlobalReducer29, 2),
    state = _useGlobalReducer30[0],
    dispatch = _useGlobalReducer30[1];
  var stytchClient = useStytch();
  var config = useConfig();
  var _useBootstrap = useBootstrap(),
    createOrganizationEnabled = _useBootstrap.createOrganizationEnabled;
  var goBack = function goBack() {
    return dispatch({
      type: 'transition',
      screen: AppScreens$1.Main
    });
  };
  var _useMutate4 = useMutate("stytch.discovery.organization.create", function () {
      return stytchClient.discovery.organizations.create({
        session_duration_minutes: config.sessionOptions.sessionDurationMinutes
      });
    }, {
      onSuccess: function onSuccess(data) {
        onAuthenticateSuccess(data, dispatch, config);
      },
      onError: function onError() {
        dispatch({
          type: 'transition',
          screen: AppScreens$1.Error
        });
      }
    }),
    stytchCreateOrganization = _useMutate4.trigger,
    isCreateLoading = _useMutate4.isMutating;
  if (isCreateLoading) {
    return /*#__PURE__*/y(LoadingScreen, null);
  }
  if (createOrganizationEnabled && !config.disableCreateOrganization) {
    return /*#__PURE__*/y(Flex, {
      direction: "column",
      gap: 24
    }, /*#__PURE__*/y(BackArrow, {
      onClick: goBack
    }), /*#__PURE__*/y(Text, {
      size: "header"
    }, "Create an organization to get started"), /*#__PURE__*/y(Button, {
      type: "button",
      onClick: function onClick() {
        return stytchCreateOrganization();
      }
    }, "Create an organization"), /*#__PURE__*/y(Text, null, state.formState.discoveryState.email, " does not have an account. Think this is a mistake? Try a different email address, or contact your admin."));
  }
  return /*#__PURE__*/y(Flex, {
    direction: "column",
    gap: 24
  }, /*#__PURE__*/y(BackArrow, {
    onClick: goBack
  }), /*#__PURE__*/y(Text, {
    size: "header"
  }, state.formState.discoveryState.email, " does not belong to any organizations."), /*#__PURE__*/y(Text, null, "Make sure your email address is correct. Otherwise, you might need to be invited by your admin."), /*#__PURE__*/y(Button, {
    type: "button",
    variant: "outlined",
    onClick: goBack
  }, "Try a different email address"));
};
var shouldAllowDirectLoginToOrganization = function shouldAllowDirectLoginToOrganization(organizations, config) {
  if (!(config === null || config === void 0 ? void 0 : config.status)) {
    return null;
  }
  var activeOrganizations = organizations.filter(function (org) {
    return org.membership.type === 'active_member';
  });
  var hasBlockingConditions = organizations.some(function (org) {
    return (org.membership.type === 'pending_member' || org.membership.type === 'invited_member') && !config.ignoreInvites || org.membership.type === 'eligible_to_join_by_email_domain' && !config.ignoreJitProvisioning;
  });
  return activeOrganizations.length === 1 && !hasBlockingConditions ? activeOrganizations[0] : null;
};
var Discovery = function Discovery() {
  var _a;
  var _useGlobalReducer31 = useGlobalReducer(),
    _useGlobalReducer32 = _slicedToArray(_useGlobalReducer31, 2),
    state = _useGlobalReducer32[0],
    dispatch = _useGlobalReducer32[1];
  var stytchClient = useStytch();
  var config = useConfig();
  var shouldDirectLoginConfigEnabled = !!((_a = config.directLoginForSingleMembership) === null || _a === void 0 ? void 0 : _a.status);
  var _useBootstrap2 = useBootstrap(),
    createOrganizationEnabled = _useBootstrap2.createOrganizationEnabled;
  p$1(function () {
    var directLoginOrganization = shouldAllowDirectLoginToOrganization(state.formState.discoveryState.discoveredOrganizations, config.directLoginForSingleMembership);
    if (shouldDirectLoginConfigEnabled && directLoginOrganization !== null) {
      handleDiscoveryOrganizationStart(directLoginOrganization);
    }
  }, [shouldDirectLoginConfigEnabled, state.formState.discoveryState.discoveredOrganizations, config.directLoginForSingleMembership]);
  var handleDiscoveryOrganizationStart = function handleDiscoveryOrganizationStart(discoveredOrganization) {
    var _a;
    var organization = discoveredOrganization.organization;
    var email = (_a = discoveredOrganization.membership.member) === null || _a === void 0 ? void 0 : _a.email_address;
    if (discoveredOrganization.primary_required) {
      if (organization.allowed_auth_methods && organization.allowed_auth_methods.length === 1 && organization.allowed_auth_methods[0] === 'sso' && organization.sso_default_connection_id) {
        startSso(organization.sso_default_connection_id);
      } else {
        dispatch({
          type: 'set_organization',
          organization: organization
        });
        dispatch({
          type: 'set_password_state',
          email: email !== null && email !== void 0 ? email : ''
        });
        dispatch({
          type: 'transition',
          screen: AppScreens$1.Main
        });
      }
    } else {
      stytchDiscoveryExchange({
        organizationId: organization.organization_id
      });
    }
  };
  var startSso = T(function (connectionId) {
    stytchClient.sso.start({
      connection_id: connectionId
    });
  }, [stytchClient]);
  var _useMutate5 = useMutate("stytch.discovery.intermediateSessions.exchange", function (_, _ref64) {
      var organizationId = _ref64.arg.organizationId;
      return stytchClient.discovery.intermediateSessions.exchange({
        organization_id: organizationId,
        session_duration_minutes: config.sessionOptions.sessionDurationMinutes
      });
    }, {
      onSuccess: function onSuccess(data) {
        onAuthenticateSuccess(data, dispatch, config);
      }
    }),
    stytchDiscoveryExchange = _useMutate5.trigger,
    isExchangeLoading = _useMutate5.isMutating;
  var _useMutate6 = useMutate("stytch.discovery.organization.create", function () {
      return stytchClient.discovery.organizations.create({
        session_duration_minutes: config.sessionOptions.sessionDurationMinutes
      });
    }, {
      onSuccess: function onSuccess(data) {
        onAuthenticateSuccess(data, dispatch, config);
      },
      onError: function onError() {
        dispatch({
          type: 'transition',
          screen: AppScreens$1.Error
        });
      }
    }),
    stytchCreateOrganization = _useMutate6.trigger,
    isCreateLoading = _useMutate6.isMutating;
  if (isExchangeLoading) {
    return /*#__PURE__*/y(LoggingInScreen, null);
  }
  if (isCreateLoading) {
    return /*#__PURE__*/y(LoadingScreen, null);
  }
  if (state.formState.discoveryState.discoveredOrganizations.length === 0) {
    return /*#__PURE__*/y(DiscoverNoOrganizations, null);
  }
  return /*#__PURE__*/y(Flex, {
    direction: "column",
    gap: 24
  }, /*#__PURE__*/y(BackArrow, {
    onClick: function onClick() {
      return dispatch({
        type: 'transition',
        screen: AppScreens$1.Main
      });
    }
  }), /*#__PURE__*/y(Text, {
    size: "header"
  }, "Select an organization to continue"), /*#__PURE__*/y(OrganizationsContainer, {
    direction: "column"
  }, state.formState.discoveryState.discoveredOrganizations.map(function (discoveredOrganization) {
    var organization = discoveredOrganization.organization,
      membership = discoveredOrganization.membership;
    return /*#__PURE__*/y(OrganizationsRow, {
      padding: 8,
      justifyContent: "space-between",
      key: organization.organization_id,
      alignItems: "center",
      onClick: function onClick() {
        return handleDiscoveryOrganizationStart(discoveredOrganization);
      }
    }, /*#__PURE__*/y(Flex, {
      gap: 4,
      alignItems: "center"
    }, /*#__PURE__*/y(Logo, {
      name: organization.organization_name,
      logo: organization.organization_logo_url
    }), /*#__PURE__*/y(Text, null, organization.organization_name)), /*#__PURE__*/y(Flex, {
      gap: 4,
      alignItems: "center"
    }, /*#__PURE__*/y(ArrowText, {
      type: membership.type
    }), /*#__PURE__*/y(RightArrowSVG, null)));
  })), createOrganizationEnabled && ( /*#__PURE__*/y(Flex, {
    direction: "column",
    gap: 8
  }, /*#__PURE__*/y(Divider, null), /*#__PURE__*/y(Button, {
    type: "button",
    variant: "outlined",
    onClick: function onClick() {
      return stytchCreateOrganization();
    }
  }, "Create an organization"))));
};
var ConfirmationSVG = function ConfirmationSVG() {
  return /*#__PURE__*/y("svg", {
    width: "201",
    height: "200",
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/y("g", {
    opacity: "0.1"
  }, /*#__PURE__*/y("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.5 0C155.729 0 200.5 44.7715 200.5 99.9999C200.5 155.229 155.729 200 100.5 200C45.2715 200 0.5 155.229 0.5 99.9999C0.5 44.7715 45.2715 0 100.5 0Z",
    fill: "url(#paint0_linear_1356_5135)"
  })), /*#__PURE__*/y("g", {
    opacity: "0.3"
  }, /*#__PURE__*/y("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.5 17.5728C146.023 17.5728 182.927 54.4767 182.927 99.9998C182.927 145.523 146.023 182.427 100.5 182.427C54.9768 182.427 18.0729 145.523 18.0729 99.9998C18.0729 54.4767 54.9768 17.5728 100.5 17.5728Z",
    fill: "url(#paint1_linear_1356_5135)"
  })), /*#__PURE__*/y("g", {
    opacity: "0.7"
  }, /*#__PURE__*/y("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.5 32.231C137.988 32.231 168.378 62.6208 168.378 100.109C168.378 137.597 137.988 167.987 100.5 167.987C63.012 167.987 32.6222 137.597 32.6222 100.109C32.6222 62.6208 63.012 32.231 100.5 32.231Z",
    fill: "url(#paint2_linear_1356_5135)"
  })), /*#__PURE__*/y("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.605 48.7734C128.955 48.7734 151.937 71.7553 151.937 100.105C151.937 128.455 128.955 151.437 100.605 151.437C72.255 151.437 49.2731 128.455 49.2731 100.105C49.2731 71.7553 72.255 48.7734 100.605 48.7734Z",
    fill: "#00AC26",
    fillOpacity: "0.12"
  }), /*#__PURE__*/y("mask", {
    id: "mask0_1356_5135",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: "49",
    y: "48",
    width: "103",
    height: "104"
  }, /*#__PURE__*/y("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.605 48.7734C128.955 48.7734 151.937 71.7553 151.937 100.105C151.937 128.455 128.955 151.437 100.605 151.437C72.255 151.437 49.2731 128.455 49.2731 100.105C49.2731 71.7553 72.255 48.7734 100.605 48.7734Z",
    fill: "white"
  })), /*#__PURE__*/y("g", {
    mask: "url(#mask0_1356_5135)"
  }), /*#__PURE__*/y("path", {
    d: "M88 117.5L70.5 100L64.6667 105.833L88 129.167L138 79.1666L132.167 73.3333L88 117.5Z",
    fill: "white"
  }), /*#__PURE__*/y("defs", null, /*#__PURE__*/y("linearGradient", {
    id: "paint0_linear_1356_5135",
    x1: "-86.6375",
    y1: "160.384",
    x2: "170.169",
    y2: "338.297",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/y("stop", {
    stopColor: "white"
  }), /*#__PURE__*/y("stop", {
    offset: "1",
    stopColor: "#09F33D"
  })), /*#__PURE__*/y("linearGradient", {
    id: "paint1_linear_1356_5135",
    x1: "-86.6374",
    y1: "160.384",
    x2: "170.169",
    y2: "338.297",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/y("stop", {
    stopColor: "#00AC26",
    stopOpacity: "0.4"
  }), /*#__PURE__*/y("stop", {
    offset: "1",
    stopColor: "#BDFFBC",
    stopOpacity: "0.58"
  })), /*#__PURE__*/y("linearGradient", {
    id: "paint2_linear_1356_5135",
    x1: "-86.6375",
    y1: "160.493",
    x2: "170.169",
    y2: "338.406",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/y("stop", {
    stopColor: "#F8FFF5"
  }), /*#__PURE__*/y("stop", {
    offset: "1",
    stopColor: "#00AC26",
    stopOpacity: "0.26"
  }))));
};
var ConfirmationScreen = function ConfirmationScreen() {
  return /*#__PURE__*/y(Flex, {
    direction: "column",
    gap: 24,
    alignItems: "center"
  }, /*#__PURE__*/y(Text, {
    size: "header"
  }, "Success!"), /*#__PURE__*/y(Text, null, "You have successfully logged in."), /*#__PURE__*/y(ConfirmationSVG, null));
};
var assertUnreachable = function assertUnreachable() {
  throw new Error('Assertion failure');
};
var Chevron = function Chevron() {
  return /*#__PURE__*/wn.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/wn.createElement("path", {
    d: "M9.09 7.91L13.67 12.5L9.09 17.09L10.5 18.5L16.5 12.5L10.5 6.5L9.09 7.91Z",
    fill: "currentColor"
  }));
};
var Chevron$1 = CreateIcon(Chevron);
var StyledButton = He.button(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  all: unset;\n  color: ", ";\n  cursor: pointer;\n  padding: 20px 0;\n  border-bottom: 1px solid #e5e8eb;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])), function (props) {
  return props.theme.colors.primary;
});
var MenuText = He.div(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n"])));
var ChevronContainer = He.span(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n  flex: 0 0 auto;\n"])));
var MenuButton = function MenuButton(_ref65) {
  var children = _ref65.children,
    onClick = _ref65.onClick;
  return /*#__PURE__*/wn.createElement(StyledButton, {
    type: "button",
    onClick: onClick
  }, /*#__PURE__*/wn.createElement(MenuText, null, children), /*#__PURE__*/wn.createElement(ChevronContainer, {
    "aria-hidden": true
  }, /*#__PURE__*/wn.createElement(Chevron$1, null)));
};
var mfaOptions = _defineProperty(_defineProperty({}, B2BMFAProducts.totp, {
  label: 'Use an authenticator app'
}), B2BMFAProducts.smsOtp, {
  label: 'Text me a code'
});
var MFAEnrollmentSelectionScreen = function MFAEnrollmentSelectionScreen() {
  var _useConfig = useConfig(),
    mfaProductInclude = _useConfig.mfaProductInclude,
    mfaProductOrder = _useConfig.mfaProductOrder;
  var _useGlobalReducer33 = useGlobalReducer(),
    _useGlobalReducer34 = _slicedToArray(_useGlobalReducer33, 2),
    state = _useGlobalReducer34[0],
    dispatch = _useGlobalReducer34[1];
  var organizationMfaOptionsSupported = state.mfa.primaryInfo.organizationMfaOptionsSupported;
  var handleChooseMethod = function handleChooseMethod(method) {
    dispatch({
      type: 'mfa/start_enrollment',
      method: method
    });
  };
  var displayOptions = F(function () {
    var optionsToDisplay = getEnabledMethods({
      allMethods: B2B_MFA_METHODS,
      orgSupportedMethods: organizationMfaOptionsSupported,
      uiIncludedMethods: mfaProductInclude
    });
    var sortedOptions = (mfaProductOrder !== null && mfaProductOrder !== void 0 ? mfaProductOrder : B2B_MFA_METHODS).reduce(function (acc, cur) {
      if (optionsToDisplay.has(cur)) {
        acc.push({
          option: cur,
          label: mfaOptions[cur].label
        });
        optionsToDisplay["delete"](cur);
      }
      return acc;
    }, []);
    optionsToDisplay.forEach(function (option) {
      sortedOptions.push({
        option: option,
        label: mfaOptions[option].label
      });
    });
    return sortedOptions;
  }, [mfaProductInclude, mfaProductOrder, organizationMfaOptionsSupported]);
  return /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 24
  }, /*#__PURE__*/wn.createElement(Text, {
    size: "header"
  }, "Set up Multi-Factor Authentication"), /*#__PURE__*/wn.createElement(Text, null, "Your organization requires an additional form of verification to make your account more secure."), /*#__PURE__*/wn.createElement(Flex, {
    direction: "column"
  }, displayOptions.map(function (_ref66) {
    var option = _ref66.option,
      label = _ref66.label;
    return /*#__PURE__*/wn.createElement(MenuButton, {
      key: option,
      onClick: function onClick() {
        handleChooseMethod(option);
      }
    }, label);
  })));
};
var inboxLinks = function inboxLinks(emailDomain) {
  if (!emailDomain) {
    return {
      GMAIL: 'https://mail.google.com/mail/u/0/#search/in%3Aanywhere',
      OUTLOOK: 'https://outlook.office.com/mail/0/inbox'
    };
  }
  var gmailQuery = encodeURIComponent("from:@".concat(emailDomain, " in:anywhere"));
  return {
    GMAIL: "https://mail.google.com/mail/u/0/#search/".concat(gmailQuery),
    OUTLOOK: 'https://outlook.office.com/mail/0/inbox'
  };
};
var Link = He.a(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n  all: unset;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n    text-decoration-color: ", ";\n  }\n"])), function (props) {
  return props.theme.colors.primary;
});
var EmailProviderLink = function EmailProviderLink(_ref67) {
  var label = _ref67.label,
    href = _ref67.href,
    Icon = _ref67.Icon;
  return /*#__PURE__*/wn.createElement(Flex, {
    gap: 4
  }, Icon, /*#__PURE__*/wn.createElement(Link, {
    href: href,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/wn.createElement(Text, null, "Open in ", label)));
};
var VerifyEmailConfirmation = function VerifyEmailConfirmation(_ref68) {
  var emailDomain = _ref68.emailDomain,
    reset = _ref68.reset,
    email = _ref68.email;
  var _inboxLinks = inboxLinks(emailDomain),
    GMAIL = _inboxLinks.GMAIL,
    OUTLOOK = _inboxLinks.OUTLOOK;
  var _useGlobalReducer35 = useGlobalReducer(),
    _useGlobalReducer36 = _slicedToArray(_useGlobalReducer35, 2),
    dispatch = _useGlobalReducer36[1];
  return /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 24
  }, /*#__PURE__*/wn.createElement(BackArrow, {
    onClick: function onClick() {
      return dispatch({
        type: 'transition',
        screen: AppScreens$1.Main
      });
    }
  }), /*#__PURE__*/wn.createElement(Text, {
    size: "header"
  }, "Verify your email first."), /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 12
  }, /*#__PURE__*/wn.createElement(Text, null, "A login link was sent to you at ", /*#__PURE__*/wn.createElement("b", null, email), "."), /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 8
  }, /*#__PURE__*/wn.createElement(EmailProviderLink, {
    href: GMAIL,
    label: 'Gmail',
    Icon: /*#__PURE__*/wn.createElement(GmailIcon, null)
  }), /*#__PURE__*/wn.createElement(EmailProviderLink, {
    href: OUTLOOK,
    label: 'Outlook',
    Icon: /*#__PURE__*/wn.createElement(OutlookIcon, null)
  }))), /*#__PURE__*/wn.createElement(Flex, {
    direction: "row"
  }, /*#__PURE__*/wn.createElement(Text, {
    color: "secondary"
  }, "Didn't get it?"), "\xA0", /*#__PURE__*/wn.createElement(GetHelpText, {
    color: "secondary",
    onClick: reset
  }, "Resend email")));
};
var useEmailDomain = function useEmailDomain() {
  var _a, _b;
  var stytch = useStytch();
  var config = useConfig();
  var _h$25 = h$1(function () {
      var _readB2BInternals$boo2 = readB2BInternals(stytch).bootstrap.getSync(),
        emailDomains = _readB2BInternals$boo2.emailDomains;
      return emailDomains;
    }),
    _h$26 = _slicedToArray(_h$25, 2),
    emailDomains = _h$26[0],
    setEmailDomains = _h$26[1];
  p$1(function () {
    readB2BInternals(stytch).bootstrap.getAsync().then(function (_ref69) {
      var emailDomains = _ref69.emailDomains;
      setEmailDomains(emailDomains);
    });
  }, [stytch]);
  if ((_a = config.emailMagicLinksOptions) === null || _a === void 0 ? void 0 : _a.domainHint) {
    return (_b = config.emailMagicLinksOptions) === null || _b === void 0 ? void 0 : _b.domainHint;
  }
  if (emailDomains.length === 1) {
    return emailDomains[0];
  }
  return null;
};
var PasswordResetConfirmation = function PasswordResetConfirmation() {
  var _useGlobalReducer37 = useGlobalReducer(),
    _useGlobalReducer38 = _slicedToArray(_useGlobalReducer37, 2),
    state = _useGlobalReducer38[0],
    dispatch = _useGlobalReducer38[1];
  var emailDomain = useEmailDomain();
  var reset = function reset() {
    dispatch({
      type: 'set_magic_link_email',
      email: ''
    });
    dispatch({
      type: 'transition',
      screen: AppScreens$1.Main
    });
  };
  return /*#__PURE__*/wn.createElement(VerifyEmailConfirmation, {
    emailDomain: emailDomain,
    reset: reset,
    email: state.formState.passwordState.email
  });
};
var Block = He.div(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n  height: 4px;\n  width: 25%;\n  background-color: ", ";\n"])), function (props) {
  return props.$bgColor;
});
var PasswordStrengthCheck = function PasswordStrengthCheck(_ref70) {
  var score = _ref70.score;
  var blocks = [];
  switch (score) {
    case 0:
    case 1:
      blocks = ['#8B1214', '#ADBCC5', '#ADBCC5', '#ADBCC5'];
      break;
    case 2:
      blocks = ['#8B1214', '#8B1214', '#ADBCC5', '#ADBCC5'];
      break;
    case 3:
      blocks = ['#0C5A56', '#0C5A56', '#0C5A56', '#ADBCC5'];
      break;
    case 4:
      blocks = ['#0C5A56', '#0C5A56', '#0C5A56', '#0C5A56'];
      break;
    default:
      blocks = ['#ADBCC5', '#ADBCC5', '#ADBCC5', '#ADBCC5'];
      break;
  }
  return /*#__PURE__*/wn.createElement(Flex, {
    gap: 2
  }, blocks.map(function (block, i) {
    return /*#__PURE__*/wn.createElement(Block, {
      key: "".concat(block, "-").concat(i),
      "$bgColor": block
    });
  }));
};
var CheckIcon = function CheckIcon() {
  return /*#__PURE__*/y(Flex, {
    height: 16,
    width: 16
  }, /*#__PURE__*/y("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/y("path", {
    d: "M5.86332 10.5833L3.08332 7.80333L2.13666 8.74333L5.86332 12.47L13.8633 4.47L12.9233 3.53L5.86332 10.5833Z",
    fill: "#0C5A56"
  })));
};
var CrossIcon = function CrossIcon() {
  return /*#__PURE__*/y(Flex, {
    height: 16,
    width: 16
  }, /*#__PURE__*/y("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/y("path", {
    d: "M12.6667 4.27334L11.7267 3.33334L8.00001 7.06001L4.27334 3.33334L3.33334 4.27334L7.06001 8.00001L3.33334 11.7267L4.27334 12.6667L8.00001 8.94001L11.7267 12.6667L12.6667 11.7267L8.94001 8.00001L12.6667 4.27334Z",
    fill: "#8B1214"
  })));
};
var PasswordB2BError = function PasswordB2BError(props) {
  var _a, _b;
  var bootstrap = useBootstrap();
  var complexity = (_a = bootstrap.passwordConfig) === null || _a === void 0 ? void 0 : _a.ludsComplexity;
  var characterLength = (_b = bootstrap.passwordConfig) === null || _b === void 0 ? void 0 : _b.ludsMinimumCount;
  if (props.passwordPolicy === 'none') {
    return null;
  }
  if (props.passwordPolicy === 'zxcvbn') {
    return /*#__PURE__*/wn.createElement(wn.Fragment, null, /*#__PURE__*/wn.createElement(PasswordStrengthCheck, {
      score: props.passwordScore
    }), /*#__PURE__*/wn.createElement(ErrorText, {
      errorMessage: props.errorMessage !== '' ? props.errorMessage : props.passwordFeedback
    }));
  }
  return /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 4
  }, /*#__PURE__*/wn.createElement(Flex, {
    gap: 4
  }, props.missingCharacters === 0 ? /*#__PURE__*/wn.createElement(CheckIcon, null) : /*#__PURE__*/wn.createElement(CrossIcon, null), /*#__PURE__*/wn.createElement(Text, {
    size: "helper",
    color: props.missingCharacters === 0 ? 'success' : 'error'
  }, "Must be at least ", characterLength, " characters long")), /*#__PURE__*/wn.createElement(Flex, {
    gap: 4
  }, props.missingComplexity === 0 ? /*#__PURE__*/wn.createElement(CheckIcon, null) : /*#__PURE__*/wn.createElement(CrossIcon, null), /*#__PURE__*/wn.createElement(Text, {
    size: "helper",
    color: props.missingComplexity === 0 ? 'success' : 'error'
  }, "Must contain ", complexity, " of the following: uppercase letter, lowercase letter, number, symbol")), props.isPasswordBreached && ( /*#__PURE__*/wn.createElement(Flex, {
    gap: 4
  }, /*#__PURE__*/wn.createElement(CrossIcon, null), /*#__PURE__*/wn.createElement(Text, {
    size: "helper",
    color: "error"
  }, "This password may have been used on a different site that experienced a security issue. Please choose another password."))));
};
var clearStytchSearchParams = function clearStytchSearchParams() {
  return window.history.replaceState(null, window.document.title, window.location.pathname);
};
var Form = He.form(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var PasswordResetForm = function PasswordResetForm() {
  var stytchClient = useStytch();
  var config = useConfig();
  var _useGlobalReducer39 = useGlobalReducer(),
    _useGlobalReducer40 = _slicedToArray(_useGlobalReducer39, 2),
    dispatch = _useGlobalReducer40[1];
  var onEvent = useEventCallback();
  var onError = useErrorCallback();
  var _h$27 = h$1(''),
    _h$28 = _slicedToArray(_h$27, 2),
    resetTokenType = _h$28[0],
    setResetTokenType = _h$28[1];
  var _h$29 = h$1(''),
    _h$30 = _slicedToArray(_h$29, 2),
    resetToken = _h$30[0],
    setResetToken = _h$30[1];
  var dataLayer = readB2BInternals(stytchClient).dataLayer;
  var email = dataLayer.getItem('reset-email-value');
  var _h$31 = h$1(''),
    _h$32 = _slicedToArray(_h$31, 2),
    password = _h$32[0],
    setPassword = _h$32[1];
  var _h$33 = h$1(''),
    _h$34 = _slicedToArray(_h$33, 2),
    errorMessage = _h$34[0],
    setErrorMessage = _h$34[1];
  var _h$35 = h$1(0),
    _h$36 = _slicedToArray(_h$35, 2),
    passwordScore = _h$36[0],
    setPasswordScore = _h$36[1];
  var _h$37 = h$1(''),
    _h$38 = _slicedToArray(_h$37, 2),
    passwordFeedback = _h$38[0],
    setPasswordFeedback = _h$38[1];
  var _h$39 = h$1(true),
    _h$40 = _slicedToArray(_h$39, 2),
    invalidPassword = _h$40[0],
    setInvalidPassword = _h$40[1];
  var _h$41 = h$1(false),
    _h$42 = _slicedToArray(_h$41, 2),
    isSubmitting = _h$42[0],
    setIsSubmitting = _h$42[1];
  var _h$43 = h$1('none'),
    _h$44 = _slicedToArray(_h$43, 2),
    strengthPolicy = _h$44[0],
    setStrengthPolicy = _h$44[1];
  var _h$45 = h$1(0),
    _h$46 = _slicedToArray(_h$45, 2),
    missingCharacters = _h$46[0],
    setMissingCharacters = _h$46[1];
  var _h$47 = h$1(0),
    _h$48 = _slicedToArray(_h$47, 2),
    missingComplexity = _h$48[0],
    setMissingComplexity = _h$48[1];
  var _h$49 = h$1(false),
    _h$50 = _slicedToArray(_h$49, 2),
    isPasswordBreached = _h$50[0],
    setIsPasswordBreached = _h$50[1];
  var updateStrengthCheck = F(function () {
    return debounce(function (password) {
      return stytchClient.passwords.strengthCheck({
        password: password
      }).then(function (_ref71) {
        var score = _ref71.score,
          valid_password = _ref71.valid_password,
          zxcvbn_feedback = _ref71.zxcvbn_feedback,
          luds_feedback = _ref71.luds_feedback,
          strength_policy = _ref71.strength_policy,
          breached_password = _ref71.breached_password;
        setStrengthPolicy(strength_policy);
        setInvalidPassword(!valid_password);
        if (strength_policy === 'zxcvbn') {
          setPasswordScore(score);
          setPasswordFeedback(zxcvbn_feedback.warning);
        } else if (strength_policy === 'luds') {
          setMissingCharacters(luds_feedback.missing_characters);
          setMissingComplexity(luds_feedback.missing_complexity);
          setIsPasswordBreached(breached_password);
        }
      });
    });
  }, [stytchClient.passwords]);
  p$1(function () {
    var _a, _b;
    var params = new URLSearchParams(window.location.search);
    var token = (_a = params.get('token')) !== null && _a !== void 0 ? _a : '';
    var tokenType = (_b = params.get('stytch_token_type')) !== null && _b !== void 0 ? _b : '';
    setResetToken(token);
    setResetTokenType(tokenType);
  }, []);
  p$1(function () {
    var _a, _b;
    if (resetTokenType === 'multi_tenant_magic_links') {
      stytchClient.magicLinks.authenticate({
        magic_links_token: resetToken,
        session_duration_minutes: (_b = (_a = config.sessionOptions) === null || _a === void 0 ? void 0 : _a.sessionDurationMinutes) !== null && _b !== void 0 ? _b : DEFAULT_SESSION_DURATION_MINUTES
      }).then(function (data) {
        clearStytchSearchParams();
        dispatch({
          type: 'primary_authenticate_success',
          response: data,
          includedMfaMethods: config.mfaProductInclude,
          resetTokenType: resetTokenType
        });
      })["catch"](function (e) {
        setErrorMessage('We were unable to verify your email. Please contact your admin for help.');
        onError(e);
      });
      return;
    }
  }, [resetTokenType]);
  var onPasswordChange = function onPasswordChange(password) {
    setPassword(password);
    updateStrengthCheck(password);
  };
  var handleSubmit = function handleSubmit(e) {
    var _a, _b;
    e.preventDefault();
    setErrorMessage('');
    setIsSubmitting(true);
    if (resetTokenType == 'multi_tenant_passwords') {
      stytchClient.passwords.resetByEmail({
        password_reset_token: resetToken,
        password: password,
        session_duration_minutes: (_b = (_a = config.sessionOptions) === null || _a === void 0 ? void 0 : _a.sessionDurationMinutes) !== null && _b !== void 0 ? _b : DEFAULT_SESSION_DURATION_MINUTES
      }).then(function (data) {
        setIsSubmitting(false);
        onEvent({
          type: StytchEventType.B2BPasswordResetByEmail,
          data: data
        });
        onAuthenticateSuccess(data, dispatch, config);
      })["catch"](function (e) {
        onError(e);
        var message = e.message;
        if (e instanceof StytchAPIError) {
          message = e.error_message;
        }
        setErrorMessage(message);
        setIsSubmitting(false);
      });
    } else {
      stytchClient.passwords.resetBySession({
        password: password
      }).then(function (data) {
        setIsSubmitting(false);
        onEvent({
          type: StytchEventType.B2BPasswordResetBySession,
          data: data
        });
        dispatch({
          type: 'transition',
          screen: AppScreens$1.LoggedIn
        });
      })["catch"](function (e) {
        onError(e);
        var message = e.message;
        if (e instanceof StytchAPIError) {
          message = e.error_message;
        }
        setErrorMessage(message);
        setIsSubmitting(false);
      });
    }
  };
  return /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 36,
    className: 'resetPasswordContainer'
  }, /*#__PURE__*/wn.createElement(Text, {
    size: "header"
  }, "Set a new password"), /*#__PURE__*/wn.createElement(Form, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 8
  }, email ? ( /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 2
  }, /*#__PURE__*/wn.createElement(Text, {
    size: "helper",
    color: "secondary"
  }, "Email"), /*#__PURE__*/wn.createElement(Input, {
    disabled: true,
    name: "email",
    id: "email-input",
    value: email
  }))) : ( /*#__PURE__*/wn.createElement(wn.Fragment, null)), /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 2
  }, /*#__PURE__*/wn.createElement(Text, {
    size: "helper",
    color: "secondary"
  }, "Password"), /*#__PURE__*/wn.createElement(PasswordInput, {
    password: password,
    setPassword: onPasswordChange,
    type: "new"
  }), /*#__PURE__*/wn.createElement(PasswordB2BError, {
    passwordPolicy: strengthPolicy,
    passwordScore: passwordScore,
    errorMessage: errorMessage,
    passwordFeedback: passwordFeedback,
    missingCharacters: missingCharacters,
    missingComplexity: missingComplexity,
    isPasswordBreached: isPasswordBreached
  })), /*#__PURE__*/wn.createElement(SubmitButton, {
    isSubmitting: isSubmitting,
    text: "Continue",
    disabled: invalidPassword
  }))));
};
var PasswordSetNew = function PasswordSetNew() {
  var _useGlobalReducer41 = useGlobalReducer(),
    _useGlobalReducer42 = _slicedToArray(_useGlobalReducer41, 2),
    dispatch = _useGlobalReducer42[1];
  var onEvent = useEventCallback();
  var config = useConfig();
  var _usePasswordInput3 = usePasswordInput(),
    stytch = _usePasswordInput3.stytch,
    onError = _usePasswordInput3.onError,
    email = _usePasswordInput3.email,
    organization = _usePasswordInput3.organization,
    setIsSubmitting = _usePasswordInput3.setIsSubmitting;
  if (!organization) {
    return /*#__PURE__*/wn.createElement(wn.Fragment, null);
  }
  var resendResetPassword = function resendResetPassword() {
    var _a, _b, _c, _d;
    stytch.passwords.resetByEmailStart({
      email_address: email,
      organization_id: organization.organization_id,
      login_redirect_url: (_a = config.emailMagicLinksOptions) === null || _a === void 0 ? void 0 : _a.loginTemplateId,
      reset_password_redirect_url: (_b = config.passwordOptions) === null || _b === void 0 ? void 0 : _b.resetPasswordRedirectURL,
      reset_password_expiration_minutes: (_c = config.passwordOptions) === null || _c === void 0 ? void 0 : _c.resetPasswordExpirationMinutes,
      reset_password_template_id: (_d = config.passwordOptions) === null || _d === void 0 ? void 0 : _d.resetPasswordTemplateId
    }).then(function (data) {
      toast$1.success('Email resent');
      setIsSubmitting(false);
      onEvent({
        type: StytchEventType.B2BPasswordResetByEmailStart,
        data: data
      });
    })["catch"](function (e) {
      onError(e);
    });
  };
  return /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 24
  }, /*#__PURE__*/wn.createElement(BackArrow, {
    onClick: function onClick() {
      return dispatch({
        type: 'transition',
        screen: AppScreens$1.Main
      });
    }
  }), /*#__PURE__*/wn.createElement(Text, {
    size: "header"
  }, "Check your email!"), /*#__PURE__*/wn.createElement(Text, null, "A login link was sent to you at ", /*#__PURE__*/wn.createElement("b", null, email), "."), /*#__PURE__*/wn.createElement(Text, null, "Didn't get it?", ' ', /*#__PURE__*/wn.createElement("button", {
    onClick: resendResetPassword,
    style: {
      all: 'unset'
    }
  }, /*#__PURE__*/wn.createElement("b", {
    style: {
      cursor: 'pointer'
    }
  }, "Resend email"))));
};
var PasswordsForgotForm = function PasswordsForgotForm() {
  var _useGlobalReducer43 = useGlobalReducer(),
    _useGlobalReducer44 = _slicedToArray(_useGlobalReducer43, 2),
    dispatch = _useGlobalReducer44[1];
  var config = useConfig();
  var onEvent = useEventCallback();
  var passwordOptions = config.passwordOptions;
  var _usePasswordInput4 = usePasswordInput(),
    stytch = _usePasswordInput4.stytch,
    email = _usePasswordInput4.email,
    setEmail = _usePasswordInput4.setEmail,
    organization = _usePasswordInput4.organization,
    errorMessage = _usePasswordInput4.errorMessage,
    setErrorMessage = _usePasswordInput4.setErrorMessage,
    isSubmitting = _usePasswordInput4.isSubmitting,
    setIsSubmitting = _usePasswordInput4.setIsSubmitting,
    handleNonMemberReset = _usePasswordInput4.handleNonMemberReset;
  if (!passwordOptions) return /*#__PURE__*/wn.createElement(wn.Fragment, null);
  if (!organization) return /*#__PURE__*/wn.createElement(wn.Fragment, null);
  var handleSubmit = function handleSubmit(e) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            e.preventDefault();
            if (email.match(EMAIL_REGEX)) {
              _context7.next = 4;
              break;
            }
            setErrorMessage('Invalid email address');
            return _context7.abrupt("return");
          case 4:
            setErrorMessage('');
            setIsSubmitting(true);
            readB2BInternals(stytch).searchManager.searchMember(email, organization.organization_id).then(function (_ref72) {
              var member = _ref72.member;
              var _a, _b, _c, _d;
              if (!(member === null || member === void 0 ? void 0 : member.member_password_id)) {
                handleNonMemberReset();
                return;
              }
              stytch.passwords.resetByEmailStart({
                email_address: email,
                organization_id: organization.organization_id,
                login_redirect_url: (_a = config.emailMagicLinksOptions) === null || _a === void 0 ? void 0 : _a.loginRedirectURL,
                reset_password_redirect_url: (_b = config.passwordOptions) === null || _b === void 0 ? void 0 : _b.resetPasswordRedirectURL,
                reset_password_expiration_minutes: (_c = config.passwordOptions) === null || _c === void 0 ? void 0 : _c.resetPasswordExpirationMinutes,
                reset_password_template_id: (_d = config.passwordOptions) === null || _d === void 0 ? void 0 : _d.resetPasswordTemplateId
              }).then(function (data) {
                setIsSubmitting(false);
                onEvent({
                  type: StytchEventType.B2BPasswordResetByEmailStart,
                  data: data
                });
                dispatch({
                  type: 'set_password_state',
                  email: email
                });
                dispatch({
                  type: 'transition',
                  screen: AppScreens$1.PasswordSetNewConfirmation
                });
              })["catch"](function (err) {
                setIsSubmitting(false);
                setErrorMessage(err.error_message);
              });
            })["catch"](function (err) {
              setIsSubmitting(false);
              var message = err.message;
              if (err instanceof StytchAPIError) {
                message = err.error_message;
              }
              setErrorMessage(message);
            });
          case 7:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
  };
  return /*#__PURE__*/wn.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 24
  }, /*#__PURE__*/wn.createElement(BackArrow, {
    onClick: function onClick() {
      return dispatch({
        type: 'transition',
        screen: AppScreens$1.Main
      });
    }
  }), /*#__PURE__*/wn.createElement(Text, {
    size: "header"
  }, "Check your email for help signing in!"), /*#__PURE__*/wn.createElement(Text, null, "We'll email you a login link to sign in to your account directly or reset your password if you have one."), /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 4
  }, /*#__PURE__*/wn.createElement(Text, {
    size: "helper",
    color: "secondary"
  }, "Email"), /*#__PURE__*/wn.createElement(EmailInput, {
    email: email,
    setEmail: setEmail
  }), /*#__PURE__*/wn.createElement(ErrorText, {
    errorMessage: errorMessage
  }), /*#__PURE__*/wn.createElement(SubmitButton, {
    isSubmitting: isSubmitting,
    text: "Continue"
  }))));
};
var RecoveryCodeEntryScreen = function RecoveryCodeEntryScreen() {
  var stytchClient = useStytch();
  var _useConfig2 = useConfig(),
    sessionDurationMinutes = _useConfig2.sessionOptions.sessionDurationMinutes;
  var _useGlobalReducer45 = useGlobalReducer(),
    _useGlobalReducer46 = _slicedToArray(_useGlobalReducer45, 2),
    state = _useGlobalReducer46[0],
    dispatch = _useGlobalReducer46[1];
  var _state$mfa$primaryInf = state.mfa.primaryInfo,
    memberId = _state$mfa$primaryInf.memberId,
    organizationId = _state$mfa$primaryInf.organizationId;
  var _h$51 = h$1(''),
    _h$52 = _slicedToArray(_h$51, 2),
    recoveryCode = _h$52[0],
    setRecoveryCode = _h$52[1];
  var _useMutate7 = useMutate('stytch.recoveryCodes.recover', function (_, _ref73) {
      var _ref73$arg = _ref73.arg,
        recoveryCode = _ref73$arg.recoveryCode,
        memberId = _ref73$arg.memberId,
        organizationId = _ref73$arg.organizationId,
        sessionDurationMinutes = _ref73$arg.sessionDurationMinutes;
      return stytchClient.recoveryCodes.recover({
        recovery_code: recoveryCode,
        member_id: memberId,
        organization_id: organizationId,
        session_duration_minutes: sessionDurationMinutes
      });
    }, {
      onSuccess: function onSuccess() {
        dispatch({
          type: 'recovery_code/authenticate_success'
        });
      }
    }),
    authenticate = _useMutate7.trigger,
    isSubmitting = _useMutate7.isMutating,
    error = _useMutate7.error;
  var errorMessage = error ? 'Invalid backup code, please try again.' : undefined;
  var handleSubmit = function handleSubmit(e) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            e.preventDefault();
            authenticate({
              recoveryCode: recoveryCode,
              memberId: memberId,
              organizationId: organizationId,
              sessionDurationMinutes: sessionDurationMinutes
            });
          case 2:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
  };
  var handleSwitchToTotp = function handleSwitchToTotp() {
    dispatch({
      type: 'totp/navigate_to_entry'
    });
  };
  return /*#__PURE__*/wn.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 24
  }, /*#__PURE__*/wn.createElement(BackArrow, {
    onClick: handleSwitchToTotp
  }), /*#__PURE__*/wn.createElement(Text, {
    size: "header"
  }, "Enter backup code"), /*#__PURE__*/wn.createElement(Text, null, "Enter one of the backup codes you saved when setting up your authenticator app."), /*#__PURE__*/wn.createElement(Flex, {
    direction: "column"
  }, /*#__PURE__*/wn.createElement(Input, {
    value: recoveryCode,
    onChange: function onChange(e) {
      setRecoveryCode(e.target.value);
    },
    placeholder: "Enter backup code",
    "aria-label": "Backup code",
    required: true,
    autoComplete: "off"
  }), errorMessage && /*#__PURE__*/wn.createElement(ErrorText, {
    errorMessage: errorMessage
  })), /*#__PURE__*/wn.createElement(SubmitButton, {
    text: "Continue",
    disabled: !recoveryCode,
    isSubmitting: isSubmitting
  })));
};
var InsetContainer = He.div(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n  background-color: #f3f5f6;\n  color: #000;\n  font-size: 16px;\n  line-height: 28px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 8px;\n  padding: 16px 8px;\n"])));
var CodeList = He.ul(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n  list-style: none;\n  padding: 0;\n  margin: 0;\n"])));
var downloadFile = function downloadFile(content, filename) {
  var blob = new Blob([content], {
    type: 'text/plain'
  });
  var url = URL.createObjectURL(blob);
  var a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};
var RecoveryCodeSaveScreen = function RecoveryCodeSaveScreen() {
  var _useGlobalReducer47 = useGlobalReducer(),
    _useGlobalReducer48 = _slicedToArray(_useGlobalReducer47, 2),
    state = _useGlobalReducer48[0],
    dispatch = _useGlobalReducer48[1];
  var recoveryCodes = state.mfa.totp.enrollment.recoveryCodes;
  var handleContinue = function handleContinue() {
    dispatch({
      type: 'recovery_code/save_acknowledge'
    });
  };
  var handleCodesDownload = function handleCodesDownload() {
    var _a;
    var organizationName = (_a = state.flowState.organization) === null || _a === void 0 ? void 0 : _a.organization_name;
    downloadFile(recoveryCodes.join('\n'), "".concat(!!organizationName ? organizationName + '-' : '', "backup-codes.txt"));
  };
  var handleCodesCopy = function handleCodesCopy() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            _context9.next = 3;
            return navigator.clipboard.writeText(recoveryCodes.join('\n'));
          case 3:
            toast$1.success('Copied');
            _context9.next = 9;
            break;
          case 6:
            _context9.prev = 6;
            _context9.t0 = _context9["catch"](0);
            toast$1.error("Couldn't copy codes to clipboard");
          case 9:
          case "end":
            return _context9.stop();
        }
      }, _callee9, null, [[0, 6]]);
    }));
  };
  return /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 24
  }, /*#__PURE__*/wn.createElement(Text, {
    size: "header"
  }, "Save your backup codes!"), /*#__PURE__*/wn.createElement(Text, null, "This is the only time you will be able to access and save your backup codes."), /*#__PURE__*/wn.createElement(InsetContainer, null, /*#__PURE__*/wn.createElement(CodeList, null, recoveryCodes.map(function (code, i) {
    return /*#__PURE__*/wn.createElement("li", {
      key: i
    }, /*#__PURE__*/wn.createElement("code", null, code));
  }))), /*#__PURE__*/wn.createElement(Flex, {
    gap: 24
  }, /*#__PURE__*/wn.createElement(Button, {
    type: "button",
    onClick: handleCodesDownload
  }, "Download file"), /*#__PURE__*/wn.createElement(Button, {
    type: "button",
    onClick: handleCodesCopy
  }, "Copy all")), /*#__PURE__*/wn.createElement(Button, {
    type: "button",
    variant: "text",
    onClick: handleContinue
  }, "Done"));
};
var Select = He.select(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  height: 47px;\n  box-sizing: border-box;\n  padding: 0 8px;\n  color: ", ";\n  font-family: ", ";\n  width: 80px;\n  font-size: 18px;\n"])), function (props) {
  return props.theme.inputs.backgroundColor;
}, function (props) {
  return props.theme.inputs.borderColor;
}, function (props) {
  return props.theme.inputs.borderRadius;
}, function (props) {
  return props.theme.inputs.textColor;
}, function (props) {
  return props.theme.typography.fontFamily;
});
var CountrySelector = function CountrySelector(_ref74) {
  var country = _ref74.country,
    setCountry = _ref74.setCountry;
  var countryFormatter = new Intl.DisplayNames(['en'], {
    type: 'region'
  });
  return /*#__PURE__*/wn.createElement(Select, {
    "data-testid": "select-test-id",
    name: "country-select",
    value: country,
    onChange: function onChange(e) {
      setCountry(e.target.value);
    }
  }, Object.entries(COUNTRIES_LIST).map(function (_ref75) {
    var _ref76 = _slicedToArray(_ref75, 2),
      countryCode = _ref76[0],
      countryNumber = _ref76[1];
    return /*#__PURE__*/wn.createElement("option", {
      key: countryCode,
      value: countryCode
    }, countryCode !== country ? "+".concat(countryNumber, " ").concat(countryFormatter.of(countryCode)) : "+".concat(countryNumber));
  }));
};
var PhoneStyledInput = He(Input)(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  min-width: 100px;\n"])));
var PhoneInput = function PhoneInput(_ref77) {
  var phone = _ref77.phone,
    setPhone = _ref77.setPhone,
    country = _ref77.country,
    setCountry = _ref77.setCountry,
    parsePhoneNumber = _ref77.parsePhoneNumber,
    hasPasskeys = _ref77.hasPasskeys;
  return /*#__PURE__*/wn.createElement(Flex, {
    direction: "row",
    wrap: "nowrap",
    justifyContent: "flex-start",
    alignContent: "stretch",
    alignItems: "center",
    gap: 8
  }, /*#__PURE__*/wn.createElement(CountrySelector, {
    country: country,
    setCountry: setCountry
  }), /*#__PURE__*/wn.createElement(PhoneStyledInput, Object.assign({
    placeholder: "(123) 456-7890",
    name: hasPasskeys ? 'email' : 'phoneNumber',
    id: "phone-input",
    autoComplete: hasPasskeys ? 'webauthn' : undefined,
    value: phone,
    type: 'text',
    onChange: function onChange(e) {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var parsedPhoneNumber;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return parsePhoneNumber(e.target.value, country);
            case 2:
              parsedPhoneNumber = _context10.sent;
              setPhone(parsedPhoneNumber.national);
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));
    },
    required: true
  }, hasPasskeys ? passwordManagerDisableAutofillProps : {})));
};
var extractErrorType = function extractErrorType(error) {
  if (error && _typeof(error) === 'object') {
    if ('error_type' in error && typeof error.error_type === 'string') {
      return error.error_type;
    }
  }
};
var DEFAULT_COUNTRY_CODE = 'US';
var InvalidPhoneNumberError = /*#__PURE__*/function (_StytchSDKError) {
  _inherits(InvalidPhoneNumberError, _StytchSDKError);
  function InvalidPhoneNumberError() {
    _classCallCheck(this, InvalidPhoneNumberError);
    return _callSuper(this, InvalidPhoneNumberError, ['InvalidPhoneNumberError', 'Invalid phone number']);
  }
  return _createClass(InvalidPhoneNumberError);
}(StytchSDKError);
var findErrorTypeFrom = function findErrorTypeFrom(_ref78) {
  var error = _ref78.error;
  var errorType = extractErrorType(error);
  return !!errorType && errorType in supportedErrorTypeMap ? errorType : 'default';
};
var supportedErrorTypeMap = {
  "default": 'Invalid phone number, please try again.',
  duplicate_member_phone_number: 'A member with the specified phone number already exists for this organization.'
};
var SMSOTPEnrollScreen = function SMSOTPEnrollScreen() {
  var _a, _b;
  var stytchClient = useStytch();
  var _useGlobalReducer49 = useGlobalReducer(),
    _useGlobalReducer50 = _slicedToArray(_useGlobalReducer49, 2),
    state = _useGlobalReducer50[0],
    dispatch = _useGlobalReducer50[1];
  var _state$mfa$smsOtp = state.mfa.smsOtp,
    isSending = _state$mfa$smsOtp.isSending,
    sendError = _state$mfa$smsOtp.sendError,
    enrolledNumber = _state$mfa$smsOtp.enrolledNumber;
  var _state$mfa$primaryInf2 = state.mfa.primaryInfo,
    memberId = _state$mfa$primaryInf2.memberId,
    organizationId = _state$mfa$primaryInf2.organizationId;
  var _wn$useState = wn.useState((_a = enrolledNumber === null || enrolledNumber === void 0 ? void 0 : enrolledNumber.countryCode) !== null && _a !== void 0 ? _a : DEFAULT_COUNTRY_CODE),
    _wn$useState2 = _slicedToArray(_wn$useState, 2),
    countryCode = _wn$useState2[0],
    setCountryCode = _wn$useState2[1];
  var _wn$useState3 = wn.useState((_b = enrolledNumber === null || enrolledNumber === void 0 ? void 0 : enrolledNumber.phoneNumber) !== null && _b !== void 0 ? _b : ''),
    _wn$useState4 = _slicedToArray(_wn$useState3, 2),
    phoneNumber = _wn$useState4[0],
    setPhoneNumber = _wn$useState4[1];
  var errorType = findErrorTypeFrom({
    error: sendError
  });
  var errorMessage = sendError ? supportedErrorTypeMap[errorType] : undefined;
  var parsePhoneNumber = function parsePhoneNumber(phoneNumber, countryCode) {
    return readB2BInternals(stytchClient).clientsideServices.parsedPhoneNumber({
      phoneNumber: phoneNumber,
      regionCode: countryCode
    });
  };
  var _useMutate8 = useMutate('stytch.otps.sms.send', function (_, _ref79) {
      var parsedNumber = _ref79.arg.parsedNumber;
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", stytchClient.otps.sms.send({
                mfa_phone_number: parsedNumber,
                member_id: memberId,
                organization_id: organizationId
              }));
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }));
    }, {
      onSuccess: function onSuccess(response) {
        dispatch({
          type: 'sms_otp/send_success',
          response: response,
          countryCode: countryCode,
          phoneNumber: phoneNumber,
          formattedPhoneNumber: "+".concat(COUNTRIES_LIST[countryCode], " ").concat(phoneNumber)
        });
      },
      onError: function onError(error) {
        dispatch({
          type: 'sms_otp/send_error',
          error: error
        });
      }
    }),
    sendSms = _useMutate8.trigger;
  var handleSubmit = function handleSubmit(e) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
      var parsedNumber;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            e.preventDefault();
            dispatch({
              type: 'sms_otp/send'
            });
            _context12.prev = 2;
            _context12.next = 5;
            return parsePhoneNumber(phoneNumber, countryCode);
          case 5:
            parsedNumber = _context12.sent;
            if (parsedNumber.isValid) {
              _context12.next = 8;
              break;
            }
            throw new InvalidPhoneNumberError();
          case 8:
            _context12.next = 10;
            return sendSms({
              parsedNumber: parsedNumber.number
            });
          case 10:
            _context12.next = 15;
            break;
          case 12:
            _context12.prev = 12;
            _context12.t0 = _context12["catch"](2);
            dispatch({
              type: 'sms_otp/send_error',
              error: _context12.t0
            });
          case 15:
          case "end":
            return _context12.stop();
        }
      }, _callee12, null, [[2, 12]]);
    }));
  };
  return /*#__PURE__*/wn.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 24
  }, /*#__PURE__*/wn.createElement(Text, {
    size: "header"
  }, "Enter your phone number to set up Multi-Factor Authentication"), /*#__PURE__*/wn.createElement(Text, null, "Your organization requires an additional form of verification to make your account more secure."), /*#__PURE__*/wn.createElement(Flex, {
    direction: "column"
  }, /*#__PURE__*/wn.createElement(PhoneInput, {
    country: countryCode,
    setCountry: setCountryCode,
    phone: phoneNumber,
    setPhone: setPhoneNumber,
    parsePhoneNumber: parsePhoneNumber
  }), errorMessage && /*#__PURE__*/wn.createElement(ErrorText, {
    errorMessage: errorMessage
  })), /*#__PURE__*/wn.createElement(SubmitButton, {
    text: "Continue",
    isSubmitting: isSending,
    disabled: !phoneNumber
  })));
};
var InlineButton = function InlineButton(_ref80) {
  var onClick = _ref80.onClick,
    children = _ref80.children;
  return /*#__PURE__*/wn.createElement("button", {
    onClick: onClick,
    style: {
      all: 'unset'
    }
  }, /*#__PURE__*/wn.createElement("b", {
    style: {
      cursor: 'pointer'
    }
  }, children));
};
var Wrapper = He.div(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-rows: ", ";\n  transition: grid-template-rows 0.15s ease-out;\n"])), function (_ref81) {
  var isOpen = _ref81.isOpen;
  return isOpen ? '1fr' : '0fr';
});
var Inner = He.div(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n  overflow: hidden;\n"])));
var AnimatedContainer = function AnimatedContainer(_ref82) {
  var isOpen = _ref82.isOpen,
    children = _ref82.children;
  return /*#__PURE__*/wn.createElement(Wrapper, {
    isOpen: isOpen
  }, /*#__PURE__*/wn.createElement(Inner, null, children));
};
var Container = He.div(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n  height: 4px;\n  background-color: ", ";\n  border-radius: 3px;\n  overflow: hidden;\n"])), function (_ref83) {
  var theme = _ref83.theme;
  return theme.colors.disabled;
});
var loading = Ue(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(-1%);\n  }\n"])));
var Progress = He.div(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 100%;\n  background-color: ", ";\n  animation: ", " 10s cubic-bezier(0.22, 1, 0.36, 1);\n"])), function (_ref84) {
  var theme = _ref84.theme;
  return theme.colors.primary;
}, loading);
var LoadingBar = function LoadingBar(_ref85) {
  var isLoading = _ref85.isLoading;
  return /*#__PURE__*/wn.createElement(Container, null, isLoading && /*#__PURE__*/wn.createElement(Progress, null));
};
var GAP = '8px';
var WIDTH = '46px';
var INPUT_HEIGHT = '46px';
var Digit = He.div(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  border-radius: 4px;\n  align-items: center;\n  display: flex;\n  font-size: 18px;\n  justify-content: center;\n  height: ", ";\n  width: ", ";\n  background: ", ";\n  color: ", ";\n"])), function (_ref86) {
  var disabled = _ref86.disabled,
    theme = _ref86.theme;
  return disabled ? theme.colors.disabled : '#ADBCC5';
}, INPUT_HEIGHT, WIDTH, function (_ref87) {
  var disabled = _ref87.disabled,
    theme = _ref87.theme;
  return disabled ? theme.colors.disabled : theme.inputs.backgroundColor;
}, function (_ref88) {
  var disabled = _ref88.disabled,
    theme = _ref88.theme;
  return disabled ? theme.colors.disabledText : theme.inputs.textColor;
});
var digitsContainerStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: GAP,
  position: 'relative',
  zIndex: -1
};
var otpContainerStyles = {
  overflow: 'hidden',
  position: 'relative',
  textAlign: 'initial',
  zIndex: 1
};
var invisibleInputStyles = {
  background: 'transparent',
  border: 'none',
  color: 'transparent',
  height: INPUT_HEIGHT,
  margin: 0,
  outline: 'none',
  position: 'absolute',
  width: "calc(100% - (0.5 * ".concat(WIDTH, "))"),
  caretColor: '#ADBCC5',
  letterSpacing: "calc(".concat(WIDTH, " - 1ch + ").concat(GAP, ")"),
  paddingLeft: "calc(0.5 * ".concat(WIDTH, ")"),
  zIndex: 10
};
var DigitAtIndex = function DigitAtIndex(_ref89) {
  var index = _ref89.index,
    disabled = _ref89.disabled,
    otp = _ref89.otp;
  var fill = otp ? otp[index] : '';
  return /*#__PURE__*/wn.createElement(Digit, {
    disabled: disabled,
    "data-testid": "otp-".concat(index)
  }, fill);
};
var OTPInput = function OTPInput(_ref90) {
  var otp = _ref90.otp,
    setOtp = _ref90.setOtp,
    disabled = _ref90.disabled;
  var onPasscodeChange = function onPasscodeChange(e) {
    if (!/^\d*$/.test(e.target.value)) {
      return;
    }
    setOtp(e.target.value);
  };
  return /*#__PURE__*/wn.createElement("div", {
    style: otpContainerStyles
  }, /*#__PURE__*/wn.createElement("input", Object.assign({
    "aria-label": "One-time passcode",
    autoComplete: "one-time-code",
    autoFocus: true,
    disabled: disabled,
    style: invisibleInputStyles,
    maxLength: 6,
    onChange: onPasscodeChange,
    type: "text",
    inputMode: "numeric",
    value: otp
  }, passwordManagerDisableAutofillProps)), /*#__PURE__*/wn.createElement("div", {
    style: digitsContainerStyles
  }, _toConsumableArray(Array(6).keys()).map(function (i) {
    return /*#__PURE__*/wn.createElement(DigitAtIndex, {
      key: "digit-".concat(i),
      index: i,
      otp: otp,
      disabled: !!disabled
    });
  })));
};
var OTP_CODE_LENGTH = 6;
var OTPControl = function OTPControl(_ref91) {
  var isSubmitting = _ref91.isSubmitting,
    onSubmit = _ref91.onSubmit,
    errorMessage = _ref91.errorMessage;
  var _h$53 = h$1(''),
    _h$54 = _slicedToArray(_h$53, 2),
    otp = _h$54[0],
    setOtp = _h$54[1];
  var handleOtpChange = function handleOtpChange(otp) {
    setOtp(otp);
    if (otp.length === OTP_CODE_LENGTH) {
      onSubmit(otp);
    }
  };
  return /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    maxWidth: 316
  }, /*#__PURE__*/wn.createElement(OTPInput, {
    otp: otp,
    setOtp: handleOtpChange,
    disabled: isSubmitting
  }), /*#__PURE__*/wn.createElement(AnimatedContainer, {
    isOpen: isSubmitting
  }, /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 8,
    marginTop: 8
  }, /*#__PURE__*/wn.createElement(Text, {
    color: "secondary",
    size: "helper"
  }, "Verifying passcode..."), /*#__PURE__*/wn.createElement(LoadingBar, {
    isLoading: isSubmitting
  }))), !isSubmitting && /*#__PURE__*/wn.createElement(ErrorText, {
    errorMessage: errorMessage !== null && errorMessage !== void 0 ? errorMessage : ''
  }));
};
var OTPEntry = function OTPEntry(_ref92) {
  var header = _ref92.header,
    helperContent = _ref92.helperContent,
    instruction = _ref92.instruction,
    isSubmitting = _ref92.isSubmitting,
    onSubmit = _ref92.onSubmit,
    errorMessage = _ref92.errorMessage;
  return /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 24
  }, /*#__PURE__*/wn.createElement(Text, {
    size: "header"
  }, header), /*#__PURE__*/wn.createElement(Text, null, instruction), /*#__PURE__*/wn.createElement(OTPControl, {
    isSubmitting: isSubmitting,
    onSubmit: onSubmit,
    errorMessage: errorMessage
  }), /*#__PURE__*/wn.createElement(Text, {
    size: "helper",
    color: "secondary"
  }, helperContent));
};
var getSecondsRemaining = function getSecondsRemaining(expiration) {
  var now = new Date();
  return Math.ceil((expiration.getTime() - now.getTime()) / 1000);
};
var ExpirationMessage = function ExpirationMessage(_ref93) {
  var expiration = _ref93.expiration,
    resendOTP = _ref93.resendOTP;
  var _h$55 = h$1(function () {
      return getSecondsRemaining(expiration);
    }),
    _h$56 = _slicedToArray(_h$55, 2),
    seconds = _h$56[0],
    setSeconds = _h$56[1];
  var codeExpired = seconds <= 0;
  p$1(function () {
    if (!codeExpired) {
      var updateSeconds = function updateSeconds() {
        return setSeconds(getSecondsRemaining(expiration));
      };
      var interval = setInterval(updateSeconds, 1000);
      updateSeconds();
      return function () {
        return clearInterval(interval);
      };
    }
  }, [codeExpired, expiration]);
  var displayMinutes = Math.floor(Number(seconds / 60));
  var displaySeconds = seconds - displayMinutes * 60;
  var formattedTime = "".concat(displayMinutes, ":").concat(displaySeconds < 10 ? "0".concat(displaySeconds) : displaySeconds);
  var formattedText = seconds > 0 ? "Your code expires in ".concat(formattedTime, ". Didn't get it? ") : 'Your code has expired. ';
  return /*#__PURE__*/wn.createElement(wn.Fragment, null, formattedText, /*#__PURE__*/wn.createElement(InlineButton, {
    onClick: resendOTP
  }, "Resend code"));
};
var SentOTPEntry = function SentOTPEntry(_ref94) {
  var expiration = _ref94.expiration,
    formattedDestination = _ref94.formattedDestination,
    isSubmitting = _ref94.isSubmitting,
    onSubmit = _ref94.onSubmit,
    errorMessage = _ref94.errorMessage,
    resendOTP = _ref94.resendOTP;
  return /*#__PURE__*/wn.createElement(OTPEntry, {
    header: "Enter passcode",
    helperContent: /*#__PURE__*/wn.createElement(ExpirationMessage, {
      expiration: expiration,
      resendOTP: resendOTP
    }),
    instruction: /*#__PURE__*/wn.createElement(wn.Fragment, null, "A 6-digit passcode was sent to you at ", /*#__PURE__*/wn.createElement("b", null, formattedDestination), "."),
    isSubmitting: isSubmitting,
    onSubmit: onSubmit,
    errorMessage: errorMessage
  });
};
var SMSOTPEntryScreen = function SMSOTPEntryScreen() {
  var _a;
  var stytchClient = useStytch();
  var _useConfig3 = useConfig(),
    sessionDurationMinutes = _useConfig3.sessionOptions.sessionDurationMinutes;
  var _useGlobalReducer51 = useGlobalReducer(),
    _useGlobalReducer52 = _slicedToArray(_useGlobalReducer51, 2),
    state = _useGlobalReducer52[0],
    dispatch = _useGlobalReducer52[1];
  var _state$mfa = state.mfa,
    isEnrolling = _state$mfa.isEnrolling,
    _state$mfa$smsOtp2 = _state$mfa.smsOtp,
    codeExpiration = _state$mfa$smsOtp2.codeExpiration,
    formattedDestination = _state$mfa$smsOtp2.formattedDestination;
  var _state$mfa$primaryInf3 = state.mfa.primaryInfo,
    enrolledMfaMethods = _state$mfa$primaryInf3.enrolledMfaMethods,
    memberId = _state$mfa$primaryInf3.memberId,
    memberPhoneNumber = _state$mfa$primaryInf3.memberPhoneNumber,
    organizationId = _state$mfa$primaryInf3.organizationId,
    organizationMfaOptionsSupported = _state$mfa$primaryInf3.organizationMfaOptionsSupported;
  var _useMutate9 = useMutate('stytch.otps.sms.send', function (_, _ref95) {
      var _ref95$arg = _ref95.arg,
        memberId = _ref95$arg.memberId,
        organizationId = _ref95$arg.organizationId;
      dispatch({
        type: 'sms_otp/send'
      });
      return stytchClient.otps.sms.send({
        member_id: memberId,
        organization_id: organizationId
      });
    }, {
      onSuccess: function onSuccess(response) {
        dispatch({
          type: 'sms_otp/send_success',
          response: response
        });
      },
      onError: function onError(error) {
        var message = extractErrorMessage(error);
        if (message) {
          toast$1.error(message);
        }
        dispatch({
          type: 'sms_otp/send_error',
          error: error
        });
      }
    }),
    sendSms = _useMutate9.trigger,
    isSending = _useMutate9.isMutating,
    sendError = _useMutate9.error;
  var _useMutate10 = useMutate('stytch.otps.sms.authenticate', function (_, _ref96) {
      var _ref96$arg = _ref96.arg,
        otp = _ref96$arg.otp,
        memberId = _ref96$arg.memberId,
        organizationId = _ref96$arg.organizationId,
        sessionDurationMinutes = _ref96$arg.sessionDurationMinutes;
      return stytchClient.otps.sms.authenticate({
        code: otp,
        member_id: memberId,
        organization_id: organizationId,
        session_duration_minutes: sessionDurationMinutes
      });
    }, {
      onSuccess: function onSuccess() {
        dispatch({
          type: 'sms_otp/authenticate_success'
        });
      }
    }),
    authenticate = _useMutate10.trigger,
    isAuthenticating = _useMutate10.isMutating,
    authenticateError = _useMutate10.error;
  var shouldCreate = codeExpiration === null && !isSending && !sendError;
  p$1(function () {
    if (shouldCreate) {
      sendSms({
        memberId: memberId,
        organizationId: organizationId
      });
    }
  }, [memberId, organizationId, sendSms, shouldCreate]);
  p$1(function () {
    if (!formattedDestination && memberPhoneNumber) {
      var formatNumber = function formatNumber() {
        return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
          var parsePhoneNumber, parsedNumber;
          return _regeneratorRuntime().wrap(function _callee13$(_context13) {
            while (1) switch (_context13.prev = _context13.next) {
              case 0:
                parsePhoneNumber = function parsePhoneNumber(phoneNumber) {
                  return readB2BInternals(stytchClient).clientsideServices.parsedPhoneNumber({
                    phoneNumber: phoneNumber
                  });
                };
                _context13.next = 3;
                return parsePhoneNumber(memberPhoneNumber);
              case 3:
                parsedNumber = _context13.sent;
                if (parsedNumber.isValid) {
                  dispatch({
                    type: 'sms_otp/format_destination',
                    formattedPhoneNumber: parsedNumber.national
                  });
                }
              case 5:
              case "end":
                return _context13.stop();
            }
          }, _callee13);
        }));
      };
      formatNumber();
    }
  }, [dispatch, formattedDestination, stytchClient, memberPhoneNumber]);
  var isTotpAvailable = F(function () {
    return !isEnrolling && enrolledMfaMethods.includes(B2BMFAProducts.totp) && (organizationMfaOptionsSupported.length === 0 || organizationMfaOptionsSupported.includes(B2BMFAProducts.totp));
  }, [enrolledMfaMethods, isEnrolling, organizationMfaOptionsSupported]);
  var errorMessage = authenticateError ? 'Invalid passcode, please try again.' : undefined;
  var canGoBack = F(function () {
    return isEnrolling || enrolledMfaMethods.length === 0 || organizationMfaOptionsSupported.length > 0 && !enrolledMfaMethods.some(function (enrolledMethod) {
      return organizationMfaOptionsSupported.includes(enrolledMethod);
    });
  }, [enrolledMfaMethods, isEnrolling, organizationMfaOptionsSupported]);
  var handleSubmit = function handleSubmit(otp) {
    authenticate({
      otp: otp,
      memberId: memberId,
      organizationId: organizationId,
      sessionDurationMinutes: sessionDurationMinutes
    });
  };
  var handleSwitchToTotp = function handleSwitchToTotp() {
    dispatch({
      type: 'totp/navigate_to_entry'
    });
  };
  var handleResendOTP = function handleResendOTP() {
    sendSms({
      memberId: memberId,
      organizationId: organizationId
    });
  };
  var handleBack = function handleBack() {
    dispatch({
      type: 'mfa/start_enrollment',
      method: B2BMFAProducts.smsOtp
    });
  };
  return /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 24
  }, canGoBack && /*#__PURE__*/wn.createElement(BackArrow, {
    onClick: handleBack
  }), codeExpiration !== null ? ( /*#__PURE__*/wn.createElement(SentOTPEntry, {
    isSubmitting: isAuthenticating,
    onSubmit: handleSubmit,
    errorMessage: errorMessage,
    expiration: codeExpiration,
    formattedDestination: (_a = formattedDestination !== null && formattedDestination !== void 0 ? formattedDestination : memberPhoneNumber) !== null && _a !== void 0 ? _a : '',
    resendOTP: handleResendOTP
  })) : ( /*#__PURE__*/wn.createElement(LoadingScreen, null)), isTotpAvailable && ( /*#__PURE__*/wn.createElement(wn.Fragment, null, /*#__PURE__*/wn.createElement(Divider, null), /*#__PURE__*/wn.createElement(Button, {
    type: "button",
    variant: "text",
    onClick: handleSwitchToTotp
  }, "Use an authenticator app"))));
};
var CopyIcon = function CopyIcon() {
  return /*#__PURE__*/y("svg", {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/y("path", {
    d: "M17 1H5C3.9 1 3 1.9 3 3V17H5V3H17V1ZM20 5H9C7.9 5 7 5.9 7 7V21C7 22.1 7.9 23 9 23H20C21.1 23 22 22.1 22 21V7C22 5.9 21.1 5 20 5ZM20 21H9V7H20V21Z",
    fill: "currentColor"
  }));
};
var Copy = CreateIcon(CopyIcon);
var CopyButton = He.button(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n  all: unset;\n  flex: 0 0 24px;\n  height: 28px;\n  opacity: 0;\n  :focus {\n    opacity: 1;\n  }\n"])));
var CodeContainer = He(InsetContainer)(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  :hover ", " {\n    opacity: 1;\n  }\n"])), CopyButton);
var Spacer = He.div(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["\n  flex: 0 1 24px;\n"])));
var Code = He.code(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["\n  white-space: pre-wrap;\n  align-self: center;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 1ch;\n"])));
var TOTPEnrollManualScreen = function TOTPEnrollManualScreen() {
  var _useGlobalReducer53 = useGlobalReducer(),
    _useGlobalReducer54 = _slicedToArray(_useGlobalReducer53, 2),
    state = _useGlobalReducer54[0],
    dispatch = _useGlobalReducer54[1];
  var secret = state.mfa.totp.enrollment.secret;
  var displaySecret = secret.toLowerCase();
  var secretChunked = displaySecret.split(/(.{4})/g).filter(Boolean);
  var handleShowQRCode = function handleShowQRCode() {
    dispatch({
      type: 'totp/show_code',
      method: 'qr'
    });
  };
  var handleContinue = function handleContinue() {
    dispatch({
      type: 'totp/navigate_to_entry'
    });
  };
  var handleCodeCopy = function handleCodeCopy(e) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
      return _regeneratorRuntime().wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            e.stopPropagation();
            _context14.prev = 1;
            _context14.next = 4;
            return navigator.clipboard.writeText(displaySecret);
          case 4:
            toast$1.success('Code copied');
            _context14.next = 10;
            break;
          case 7:
            _context14.prev = 7;
            _context14.t0 = _context14["catch"](1);
            toast$1.error("Couldn't copy code to clipboard");
          case 10:
          case "end":
            return _context14.stop();
        }
      }, _callee14, null, [[1, 7]]);
    }));
  };
  return /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 24
  }, /*#__PURE__*/wn.createElement(BackArrow, {
    onClick: handleShowQRCode
  }), /*#__PURE__*/wn.createElement(Text, {
    size: "header"
  }, "Having trouble scanning the QR code?"), /*#__PURE__*/wn.createElement(Text, null, "Click to copy the code below. Enter into your authenticator app to link your account."), /*#__PURE__*/wn.createElement(CodeContainer, {
    onClick: handleCodeCopy
  }, /*#__PURE__*/wn.createElement(Spacer, null), /*#__PURE__*/wn.createElement(Code, null, secretChunked.map(function (part, i) {
    return /*#__PURE__*/wn.createElement("span", {
      key: i
    }, part);
  })), /*#__PURE__*/wn.createElement(CopyButton, {
    type: "button",
    onClick: handleCodeCopy,
    "aria-label": "Copy code"
  }, /*#__PURE__*/wn.createElement(Copy, null))), /*#__PURE__*/wn.createElement(Button, {
    type: "button",
    onClick: handleContinue
  }, "Continue"), /*#__PURE__*/wn.createElement(Button, {
    type: "button",
    variant: "text",
    onClick: handleShowQRCode
  }, "Try to scan the QR code again"));
};
var QRCodeImg = He.img(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["\n  margin: 0 auto;\n"])));
var TOTPEnrollQRScreen = function TOTPEnrollQRScreen() {
  var stytchClient = useStytch();
  var _useGlobalReducer55 = useGlobalReducer(),
    _useGlobalReducer56 = _slicedToArray(_useGlobalReducer55, 2),
    state = _useGlobalReducer56[0],
    dispatch = _useGlobalReducer56[1];
  var _state$mfa$totp = state.mfa.totp,
    createError = _state$mfa$totp.createError,
    enrollment = _state$mfa$totp.enrollment,
    isCreating = _state$mfa$totp.isCreating;
  var _state$mfa$primaryInf4 = state.mfa.primaryInfo,
    memberId = _state$mfa$primaryInf4.memberId,
    organizationId = _state$mfa$primaryInf4.organizationId;
  var _useMutate11 = useMutate('stytch.totp.create', function (_, _ref97) {
      var _ref97$arg = _ref97.arg,
        memberId = _ref97$arg.memberId,
        organizationId = _ref97$arg.organizationId;
      dispatch({
        type: 'totp/create'
      });
      return stytchClient.totp.create({
        member_id: memberId,
        organization_id: organizationId
      });
    }, {
      onSuccess: function onSuccess(response) {
        dispatch({
          type: 'totp/create_success',
          response: response,
          memberId: memberId,
          organizationId: organizationId
        });
      },
      onError: function onError(error) {
        var message = extractErrorMessage(error);
        if (message) {
          toast$1.error(message);
        }
        dispatch({
          type: 'totp/create_error',
          error: error
        });
      }
    }),
    createTotp = _useMutate11.trigger;
  var shouldCreate = !enrollment && !isCreating && !createError;
  p$1(function () {
    if (shouldCreate) {
      createTotp({
        memberId: memberId,
        organizationId: organizationId
      });
    }
  }, [createTotp, memberId, organizationId, shouldCreate]);
  var handleShowManualCode = function handleShowManualCode() {
    dispatch({
      type: 'totp/show_code',
      method: 'manual'
    });
  };
  var handleContinue = function handleContinue() {
    dispatch({
      type: 'totp/navigate_to_entry'
    });
  };
  return /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 24
  }, /*#__PURE__*/wn.createElement(Text, {
    size: "header"
  }, "Scan the QR code to link your authenticator app"), /*#__PURE__*/wn.createElement(Text, null, "Your organization requires an additional form of verification to make your account more secure. If you don\u2019t have an authenticator app, you\u2019ll need to install one first."), !!enrollment ? ( /*#__PURE__*/wn.createElement(wn.Fragment, null, /*#__PURE__*/wn.createElement(QRCodeImg, {
    alt: "QR code for TOTP enrollment",
    src: enrollment.qrCode
  }), /*#__PURE__*/wn.createElement(Button, {
    type: "button",
    variant: "text",
    onClick: handleShowManualCode
  }, "Having trouble scanning?"), /*#__PURE__*/wn.createElement(Button, {
    type: "button",
    onClick: handleContinue
  }, "Continue"))) : ( /*#__PURE__*/wn.createElement(LoadingScreen, null)));
};
var TOTPEntry = function TOTPEntry(_ref98) {
  var helperContent = _ref98.helperContent,
    isSubmitting = _ref98.isSubmitting,
    onSubmit = _ref98.onSubmit,
    errorMessage = _ref98.errorMessage;
  return /*#__PURE__*/wn.createElement(OTPEntry, {
    header: "Enter verification code",
    instruction: "Enter the 6-digit code from your authenticator app.",
    helperContent: helperContent,
    isSubmitting: isSubmitting,
    onSubmit: onSubmit,
    errorMessage: errorMessage
  });
};
var TOTPEntryScreen = function TOTPEntryScreen() {
  var stytchClient = useStytch();
  var _useConfig4 = useConfig(),
    sessionDurationMinutes = _useConfig4.sessionOptions.sessionDurationMinutes;
  var _useGlobalReducer57 = useGlobalReducer(),
    _useGlobalReducer58 = _slicedToArray(_useGlobalReducer57, 2),
    state = _useGlobalReducer58[0],
    dispatch = _useGlobalReducer58[1];
  var isEnrolling = state.mfa.isEnrolling;
  var _state$mfa$primaryInf5 = state.mfa.primaryInfo,
    enrolledMfaMethods = _state$mfa$primaryInf5.enrolledMfaMethods,
    memberId = _state$mfa$primaryInf5.memberId,
    organizationId = _state$mfa$primaryInf5.organizationId,
    organizationMfaOptionsSupported = _state$mfa$primaryInf5.organizationMfaOptionsSupported;
  var _useMutate12 = useMutate('stytch.totp.authenticate', function (_, _ref99) {
      var _ref99$arg = _ref99.arg,
        memberId = _ref99$arg.memberId,
        organizationId = _ref99$arg.organizationId,
        otp = _ref99$arg.otp,
        sessionDurationMinutes = _ref99$arg.sessionDurationMinutes;
      return stytchClient.totp.authenticate({
        code: otp,
        member_id: memberId,
        organization_id: organizationId,
        session_duration_minutes: sessionDurationMinutes
      });
    }, {
      onSuccess: function onSuccess() {
        dispatch({
          type: 'totp/authenticate_success'
        });
      }
    }),
    authenticate = _useMutate12.trigger,
    isAuthenticating = _useMutate12.isMutating,
    authenticateError = _useMutate12.error;
  var isSmsOtpAvailable = F(function () {
    return !isEnrolling && enrolledMfaMethods.includes(B2BMFAProducts.smsOtp) && (organizationMfaOptionsSupported.length === 0 || organizationMfaOptionsSupported.includes(B2BMFAProducts.smsOtp));
  }, [enrolledMfaMethods, isEnrolling, organizationMfaOptionsSupported]);
  var errorMessage = authenticateError ? 'Invalid passcode, please try again.' : undefined;
  var canGoBack = isEnrolling;
  var handleSubmit = function handleSubmit(otp) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
      return _regeneratorRuntime().wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            authenticate({
              memberId: memberId,
              organizationId: organizationId,
              otp: otp,
              sessionDurationMinutes: sessionDurationMinutes
            });
          case 1:
          case "end":
            return _context15.stop();
        }
      }, _callee15);
    }));
  };
  var handleSwitchToRecoveryCode = function handleSwitchToRecoveryCode() {
    dispatch({
      type: 'recovery_code/navigate_to_entry'
    });
  };
  var handleSwitchToSms = function handleSwitchToSms() {
    dispatch({
      type: 'sms_otp/navigate_to_entry'
    });
  };
  var handleBack = function handleBack() {
    dispatch({
      type: 'totp/show_code'
    });
  };
  return /*#__PURE__*/wn.createElement(Flex, {
    direction: "column",
    gap: 24
  }, canGoBack && /*#__PURE__*/wn.createElement(BackArrow, {
    onClick: handleBack
  }), /*#__PURE__*/wn.createElement(TOTPEntry, {
    helperContent: !isEnrolling ? ( /*#__PURE__*/wn.createElement(wn.Fragment, null, "Can\u2019t access your authenticator app?", ' ', /*#__PURE__*/wn.createElement(InlineButton, {
      onClick: handleSwitchToRecoveryCode
    }, "Use a backup code"))) : 'If the verification code doesn’t work, go back to your authenticator app to get a new code.',
    isSubmitting: isAuthenticating,
    onSubmit: handleSubmit,
    errorMessage: errorMessage
  }), isSmsOtpAvailable && ( /*#__PURE__*/wn.createElement(wn.Fragment, null, /*#__PURE__*/wn.createElement(Divider, null), /*#__PURE__*/wn.createElement(Button, {
    type: "button",
    variant: "text",
    onClick: handleSwitchToSms
  }, "Text me a code instead"))));
};
var MainContainer = He.div(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["\n  width: ", ";\n  font-family: ", ";\n  box-sizing: border-box;\n  * {\n    box-sizing: content-box;\n  }\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  border-bottom-left-radius: ", ";\n  border-bottom-right-radius: ", ";\n  border-bottom: ", ";\n"])), function (_ref100) {
  var theme = _ref100.theme;
  return theme.container.width;
}, function (_ref101) {
  var theme = _ref101.theme;
  return theme.typography.fontFamily;
}, function (_ref102) {
  var theme = _ref102.theme;
  return theme.container.backgroundColor;
}, function (_ref103) {
  var theme = _ref103.theme;
  return theme.container.border;
}, function (_ref104) {
  var theme = _ref104.theme;
  return theme.container.borderRadius;
}, function (_ref105) {
  var theme = _ref105.theme,
    displayWatermark = _ref105.displayWatermark;
  return displayWatermark ? '0' : theme.container.borderRadius;
}, function (_ref106) {
  var theme = _ref106.theme,
    displayWatermark = _ref106.displayWatermark;
  return displayWatermark ? '0' : theme.container.borderRadius;
}, function (_ref107) {
  var theme = _ref107.theme,
    displayWatermark = _ref107.displayWatermark;
  return displayWatermark ? 'none' : theme.container.border;
});
var ChildrenContainer = He.div(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["\n  padding: 24px 32px;\n"])));
var WatermarkContainer = He.div(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: ", ";\n  background-color: ", ";\n  border: ", ";\n  border-top: none;\n  border-bottom-left-radius: ", ";\n  border-bottom-right-radius: ", ";\n  overflow: hidden;\n"])), function (_ref108) {
  var theme = _ref108.theme;
  return theme.container.width;
}, function (_ref109) {
  var theme = _ref109.theme;
  return theme.container.backgroundColor;
}, function (_ref110) {
  var theme = _ref110.theme;
  return theme.container.border;
}, function (_ref111) {
  var theme = _ref111.theme;
  return theme.container.borderRadius;
}, function (_ref112) {
  var theme = _ref112.theme;
  return theme.container.borderRadius;
});
var InnerContainer = He.div(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral(["\n  background-color: #19303d;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 0.5;\n"])));
var Image = He.img(_templateObject58 || (_templateObject58 = _taggedTemplateLiteral(["\n  width: 150px;\n"])));
var POWERED_BY_STYTCH_IMG_URL = 'https://public-assets.stytch.com/et_powered_by_stytch_logo.png';
var getTokenFromUrl = function getTokenFromUrl() {
  var url = new URL(window.location.href);
  var tokenType = url.searchParams.get('stytch_token_type');
  var token = url.searchParams.get('token');
  return {
    tokenType: tokenType,
    token: token
  };
};
var supportedTokenTypes = ['discovery', 'discovery_oauth', 'oauth', 'sso', 'multi_tenant_magic_links'];
var supportedTokenTypesSet = new Set(supportedTokenTypes);
var isSupportedTokenType = function isSupportedTokenType(tokenType) {
  return !!(tokenType && supportedTokenTypesSet.has(tokenType));
};
var AppContainer$1 = function AppContainer$1() {
  var _ScreenComponentMap;
  var _useGlobalReducer59 = useGlobalReducer(),
    _useGlobalReducer60 = _slicedToArray(_useGlobalReducer59, 2),
    state = _useGlobalReducer60[0],
    dispatch = _useGlobalReducer60[1];
  var stytchClient = useStytch();
  var config = useConfig();
  var _Ze2 = Ze(),
    displayWatermark = _Ze2.displayWatermark;
  var isOnlyFloatingOneTap = useIsOnlyFloatingOneTap();
  var currentScreen = state.screen;
  var ScreenComponentMap = (_ScreenComponentMap = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ScreenComponentMap, AppScreens$1.Main, /*#__PURE__*/wn.createElement(MainScreen, null)), AppScreens$1.EmailConfirmation, /*#__PURE__*/wn.createElement(EmailConfirmation, null)), AppScreens$1.LoggedIn, /*#__PURE__*/wn.createElement(ConfirmationScreen, null)), AppScreens$1.Discovery, /*#__PURE__*/wn.createElement(Discovery, null)), AppScreens$1.Error, /*#__PURE__*/wn.createElement(ErrorScreen, null)), AppScreens$1.PasswordEmailForm, /*#__PURE__*/wn.createElement(PasswordsEmailForm, null)), AppScreens$1.PasswordAuthenticate, /*#__PURE__*/wn.createElement(PasswordsAuthenticate, null)), AppScreens$1.PasswordResetForm, /*#__PURE__*/wn.createElement(PasswordResetForm, null)), AppScreens$1.PasswordResetVerifyConfirmation, /*#__PURE__*/wn.createElement(PasswordResetConfirmation, null)), AppScreens$1.PasswordForgotForm, /*#__PURE__*/wn.createElement(PasswordsForgotForm, null)), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ScreenComponentMap, AppScreens$1.PasswordSetNewConfirmation, /*#__PURE__*/wn.createElement(PasswordSetNew, null)), AppScreens$1.MFAEnrollmentSelection, /*#__PURE__*/wn.createElement(MFAEnrollmentSelectionScreen, null)), AppScreens$1.SMSOTPEnrollment, /*#__PURE__*/wn.createElement(SMSOTPEnrollScreen, null)), AppScreens$1.SMSOTPEntry, /*#__PURE__*/wn.createElement(SMSOTPEntryScreen, null)), AppScreens$1.RecoveryCodeEntry, /*#__PURE__*/wn.createElement(RecoveryCodeEntryScreen, null)), AppScreens$1.RecoveryCodeSave, /*#__PURE__*/wn.createElement(RecoveryCodeSaveScreen, null)), AppScreens$1.TOTPEnrollmentQRCode, /*#__PURE__*/wn.createElement(TOTPEnrollQRScreen, null)), AppScreens$1.TOTPEnrollmentManual, /*#__PURE__*/wn.createElement(TOTPEnrollManualScreen, null)), AppScreens$1.TOTPEntry, /*#__PURE__*/wn.createElement(TOTPEntryScreen, null)));
  var onSuccess = function onSuccess(data) {
    clearStytchSearchParams();
    onAuthenticateSuccess(data, dispatch, config);
  };
  var onDiscoverySuccess = function onDiscoverySuccess(data) {
    clearStytchSearchParams();
    dispatch({
      type: 'set_discovery_state',
      email: data.email_address,
      discoveredOrganizations: data.discovered_organizations,
      intermediateSessionToken: data.intermediate_session_token
    });
    dispatch({
      type: 'transition',
      screen: AppScreens$1.Discovery
    });
  };
  var onError = function onError(_ref113) {
    var errorType = _ref113.errorType;
    return function () {
      clearStytchSearchParams();
      dispatch({
        type: 'set_error_message_and_transition',
        errorType: errorType !== null && errorType !== void 0 ? errorType : ErrorType.Default
      });
    };
  };
  var _useMutate13 = useMutate("stytch.magicLinks.authenticate", function (_, _ref114) {
      var token = _ref114.arg.token;
      return stytchClient.magicLinks.authenticate({
        magic_links_token: token,
        session_duration_minutes: config.sessionOptions.sessionDurationMinutes
      });
    }, {
      onSuccess: onSuccess,
      onError: onError({
        errorType: ErrorType.EmailMagicLink
      })
    }),
    stytchMagicLinkAuthenticate = _useMutate13.trigger,
    isMagicLinkLoading = _useMutate13.isMutating;
  var _useMutate14 = useMutate("stytch.oauth.authenticate", function (_, _ref115) {
      var token = _ref115.arg.token;
      return stytchClient.oauth.authenticate({
        oauth_token: token,
        session_duration_minutes: config.sessionOptions.sessionDurationMinutes
      });
    }, {
      onSuccess: onSuccess,
      onError: onError({
        errorType: null
      })
    }),
    stytchOAuthAuthenticate = _useMutate14.trigger,
    isOAuthLoading = _useMutate14.isMutating;
  var _useMutate15 = useMutate("stytch.oauth.discovery.authenticate", function (_, _ref116) {
      var token = _ref116.arg.token;
      return stytchClient.oauth.discovery.authenticate({
        discovery_oauth_token: token
      });
    }, {
      onSuccess: onDiscoverySuccess,
      onError: onError({
        errorType: null
      })
    }),
    stytchOAuthDiscoveryAuthenticate = _useMutate15.trigger,
    isDiscoveryOAuthLoading = _useMutate15.isMutating;
  var _useMutate16 = useMutate("stytch.sso.authenticate", function (_, _ref117) {
      var token = _ref117.arg.token;
      return stytchClient.sso.authenticate({
        sso_token: token,
        session_duration_minutes: config.sessionOptions.sessionDurationMinutes
      });
    }, {
      onSuccess: onSuccess,
      onError: onError({
        errorType: null
      })
    }),
    stytchSSOAuthenticate = _useMutate16.trigger,
    isSSOLoading = _useMutate16.isMutating;
  var _useMutate17 = useMutate("stytch.magicLinks.discovery.authenticate", function (_, _ref118) {
      var token = _ref118.arg.token;
      return stytchClient.magicLinks.discovery.authenticate({
        discovery_magic_links_token: token
      });
    }, {
      onSuccess: onDiscoverySuccess,
      onError: onError({
        errorType: ErrorType.Default
      })
    }),
    stytchDiscoveryAuthenticate = _useMutate17.trigger,
    isDiscoveryLoading = _useMutate17.isMutating;
  var isTokenAuthLoading = isMagicLinkLoading || isSSOLoading || isDiscoveryLoading || isDiscoveryOAuthLoading || isOAuthLoading;
  var _useExtractSlug = useExtractSlug(),
    isSearching = _useExtractSlug.isSearching,
    slug = _useExtractSlug.slug,
    pattern = _useExtractSlug.pattern;
  p$1(function () {
    if (isOnlyFloatingOneTap) {
      return;
    }
    if (state.flowState.type == AuthFlowType.PasswordReset) {
      return;
    }
    var _getTokenFromUrl = getTokenFromUrl(),
      tokenType = _getTokenFromUrl.tokenType,
      token = _getTokenFromUrl.token;
    if (token && isSupportedTokenType(tokenType) && !isTokenAuthLoading) {
      switch (tokenType) {
        case 'discovery':
          stytchDiscoveryAuthenticate({
            token: token
          });
          break;
        case 'discovery_oauth':
          stytchOAuthDiscoveryAuthenticate({
            token: token
          });
          break;
        case 'oauth':
          stytchOAuthAuthenticate({
            token: token
          });
          break;
        case 'sso':
          stytchSSOAuthenticate({
            token: token
          });
          break;
        case 'multi_tenant_magic_links':
          stytchMagicLinkAuthenticate({
            token: token
          });
          break;
        default:
          return assertUnreachable();
      }
    }
  }, []);
  var triggerError = useErrorCallback();
  p$1(function () {
    if (isOnlyFloatingOneTap) {
      return;
    }
    if (isTokenAuthLoading) {
      return;
    }
    var _getTokenFromUrl2 = getTokenFromUrl(),
      tokenType = _getTokenFromUrl2.tokenType,
      token = _getTokenFromUrl2.token;
    if (token && isSupportedTokenType(tokenType)) {
      return;
    }
    if (!slug && pattern !== undefined && !isSearching && state.flowState.organization === null && state.screen === AppScreens$1.Main && state.flowState.type == AuthFlowType.Organization) {
      dispatch({
        type: 'set_error_message_and_transition',
        errorType: ErrorType.Organization
      });
    }
  }, [dispatch, isOnlyFloatingOneTap, isSearching, isTokenAuthLoading, pattern, slug, state.flowState.organization, state.flowState.type, state.screen, triggerError]);
  if (isOnlyFloatingOneTap) {
    return /*#__PURE__*/wn.createElement(B2BGoogleOneTap, null);
  }
  if (isTokenAuthLoading) {
    return /*#__PURE__*/wn.createElement(MainContainer, {
      displayWatermark: false
    }, /*#__PURE__*/wn.createElement(ChildrenContainer, null, /*#__PURE__*/wn.createElement(LoggingInScreen, null)));
  }
  if (isSearching) {
    return /*#__PURE__*/wn.createElement(MainContainer, {
      displayWatermark: false
    }, /*#__PURE__*/wn.createElement(ChildrenContainer, null, /*#__PURE__*/wn.createElement(LoadingScreen, null)));
  }
  return /*#__PURE__*/wn.createElement(wn.Fragment, null, /*#__PURE__*/wn.createElement(MainContainer, {
    displayWatermark: displayWatermark
  }, /*#__PURE__*/wn.createElement(ChildrenContainer, null, ScreenComponentMap[currentScreen], /*#__PURE__*/wn.createElement(Snackbar, null))), displayWatermark && ( /*#__PURE__*/wn.createElement(WatermarkContainer, null, /*#__PURE__*/wn.createElement(InnerContainer, null, /*#__PURE__*/wn.createElement("a", {
    style: {
      height: 32,
      display: 'flex',
      alignItems: 'center',
      padding: '8px 0px',
      boxSizing: 'border-box'
    },
    href: "https://stytch.com/",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/wn.createElement(Image, {
    alt: "Powered by Stytch",
    src: POWERED_BY_STYTCH_IMG_URL
  }))))));
};
var AppContainer = function AppContainer(_ref119) {
  var client = _ref119.client,
    styles = _ref119.styles,
    callbacks = _ref119.callbacks,
    config = _ref119.config;
  var _h$57 = h$1(function () {
      var _readB2BInternals$boo3 = readB2BInternals(client).bootstrap.getSync(),
        displayWatermark = _readB2BInternals$boo3.displayWatermark;
      return displayWatermark;
    }),
    _h$58 = _slicedToArray(_h$57, 2),
    displayWatermark = _h$58[0],
    setDisplayWatermark = _h$58[1];
  p$1(function () {
    readB2BInternals(client).networkClient.logEvent({
      name: 'render_b2b_login_screen',
      details: {
        options: config
      }
    });
    readB2BInternals(client).bootstrap.getAsync().then(function (_ref120) {
      var displayWatermark = _ref120.displayWatermark;
      setDisplayWatermark(displayWatermark);
    });
  }, [client]);
  var initialState = Object.assign(Object.assign({}, DEFAULT_STATE), {
    screen: config.authFlowType === AuthFlowType.PasswordReset ? AppScreens$1.PasswordResetForm : AppScreens$1.Main,
    flowState: Object.assign(Object.assign({}, DEFAULT_STATE.flowState), {
      type: config.authFlowType
    })
  });
  var theme = useTheme({
    styles: styles,
    displayWatermark: displayWatermark
  });
  return /*#__PURE__*/wn.createElement(GlobalContextProvider, {
    client: client,
    callbacks: callbacks,
    config: config,
    initialState: initialState
  }, /*#__PURE__*/wn.createElement(Fe, {
    theme: theme
  }, /*#__PURE__*/wn.createElement(AppContainer$1, null)));
};
var B2B_UI_SCREEN_WEB_COMPONENT_NAME = 'stytch-b2b-ui';
var B2BUILoginComponent = CreateSSRSafeWebComponent(AppContainer, B2B_UI_SCREEN_WEB_COMPONENT_NAME);
var StytchB2BUIClient = /*#__PURE__*/function (_StytchB2BHeadlessCli) {
  _inherits(StytchB2BUIClient, _StytchB2BHeadlessCli);
  function StytchB2BUIClient() {
    _classCallCheck(this, StytchB2BUIClient);
    checkNotSSR('StytchUIClient');
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _callSuper(this, StytchB2BUIClient, [].concat(args));
  }
  _createClass(StytchB2BUIClient, [{
    key: "mount",
    value: function mount(_ref121) {
      var elementId = _ref121.elementId,
        styles = _ref121.styles,
        callbacks = _ref121.callbacks,
        config = _ref121.config;
      var _a;
      var targetParentDomNode = document.querySelector(elementId);
      if (!targetParentDomNode) {
        var errorMessage = "The selector you specified (".concat(elementId, ") applies to no DOM elements that are currently on the page. Make sure the element exists on the page before calling mountLogin().");
        throw new Error(errorMessage);
      }
      if (((_a = targetParentDomNode.firstChild) === null || _a === void 0 ? void 0 : _a.nodeName.toLowerCase()) === B2B_UI_SCREEN_WEB_COMPONENT_NAME.toLowerCase()) {
        var node = targetParentDomNode.firstChild;
        node.render({
          client: this,
          config: config,
          callbacks: callbacks,
          styles: styles
        });
        return;
      }
      var loginElement = B2BUILoginComponent({
        client: this,
        config: config,
        callbacks: callbacks,
        styles: styles
      });
      targetParentDomNode.appendChild(loginElement);
    }
  }]);
  return StytchB2BUIClient;
}(StytchB2BHeadlessClient);
export { AuthFlowType, B2BMFAProducts, B2BOAuthProviders, B2BProducts, OTPMethods, OneTapPositions, Products, StytchAPIError, StytchB2BUIClient, StytchEventType, StytchSDKError, Wallets };
